import React from 'react'

export default class BusinessIcon extends React.Component {
  render() {
    const { fill, width, height, icon } = this.props

    const svg = {
      circle: () => {

        return (
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 24}
            height={height ? height : 24}
            // width="24"
            // height="24"
            viewBox="0 0 24 24">
            <title>radio_button_unchecked</title>
            <path
              fill={fill ? fill : '#436AB2'}
              d="M12 20.016c4.406 0 8.016-3.609 8.016-8.016s-3.609-8.016-8.016-8.016-8.016 3.609-8.016 8.016 3.609 8.016 8.016 8.016zM12 2.016c5.531 0 9.984 4.453 9.984 9.984s-4.453 9.984-9.984 9.984-9.984-4.453-9.984-9.984 4.453-9.984 9.984-9.984z"
            />
          </svg>
        )
      },
      uncheckedCircle:()=>{
        return(

          <svg xmlns="http://www.w3.org/2000/svg" width={width || '24'} height={height || '24'} viewBox="0 0 24 24">
          <path fill="#FFF" fillRule="evenodd" stroke="#436AB2" strokeWidth="2" d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11z"/>
          </svg>


        )
      },
      checkedBox:()=>{
        return (
          <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={width || '24'} height={height || "24"}  viewBox="0 0 24 24">
            <defs>
                <path id="a" d="M16 0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM7.71 13.29a.996.996 0 0 1-1.41 0L2.71 9.7a.996.996 0 1 1 1.41-1.41L7 11.17l6.88-6.88a.996.996 0 1 1 1.41 1.41l-7.58 7.59z"/>
            </defs>
            <g fill="none" fillRule="evenodd" transform="translate(3 3)">
                <mask id="b" fill="#fff">
                    <use xlinkHref="#a"/>
                </mask>
                <g fill="#436AB2" fillOpacity=".87" mask="url(#b)">
                    <path d="M-3-3h24v24H-3z"/>
                </g>
            </g>
        </svg>

        )
      },
      unCheckedBox:()=>{
        return (
          <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={width || '18'} height={height || "18"} viewBox="0 0 18 18">
            <defs>
                <path id="a" d="M11.5 12.25h-9a.752.752 0 0 1-.75-.75v-9c0-.413.337-.75.75-.75h9c.412 0 .75.337.75.75v9c0 .412-.338.75-.75.75zm.75-12H1.75C.925.25.25.925.25 1.75v10.5c0 .825.675 1.5 1.5 1.5h10.5c.825 0 1.5-.675 1.5-1.5V1.75c0-.825-.675-1.5-1.5-1.5z"/>
            </defs>
            <g fill="none" fillRule="evenodd" transform="translate(2 2)">
                <mask id="b" fill="#fff">
                    <use xlinkHref="#a"/>
                </mask>
                <g fill="#436AB2" fillOpacity=".87" mask="url(#b)">
                    <path d="M-2-2h18v18H-2z"/>
                </g>
            </g>
        </svg>

        )
      },
      checkedCircle :() =>{
        return(
          <svg xmlns="http://www.w3.org/2000/svg" width={width || '24'} height={height || '24'} viewBox="0 0 24 24">
           <g fill="none" fillRule="evenodd">
        <path fill={fill ? fill : '#436AB2'}d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z"/>
        <path fill="#FFF" d="M15.494 8.758a.884.884 0 0 1 1.248 1.248L11.447 15.3a.88.88 0 0 1-1.247 0l-2.942-2.941a.884.884 0 0 1 1.248-1.248l2.318 2.318 4.67-4.671z"/>
        </g>
          </svg>

        )
      },
      vitalPointBlue: () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="11" viewBox="0 0 8 11">
          <g fill={fill ? fill : '#436AB2'} fillRule="nonzero">
            <path d="M2.871 10.56L0 3h1.695l1.538 4.396c.265.738.424 1.335.479 1.79h.055c.04-.328.2-.925.478-1.79L5.783 3h1.71l-2.886 7.56H2.871zM1.677 1.047c-.24 0-.506.058-.8.174A3.375 3.375 0 0 0 0 1.75V.64C.473.22 1.07.012 1.791.012c.315 0 .614.025.896.075.282.05.633.147 1.053.29.626.214 1.151.32 1.576.32.249 0 .522-.06.82-.18.3-.12.587-.292.864-.517v1.105c-.502.43-1.099.645-1.791.645-.31 0-.615-.03-.914-.09a8.725 8.725 0 0 1-1.05-.294c-.606-.213-1.129-.32-1.568-.32z" />
          </g>
        </svg>
      ),
      share: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="24"
          height="24"
          viewBox="0 0 24 24">
          <defs>
            <path
              id="a"
              d="M18 16.12c-.76 0-1.44.3-1.96.77l-7.13-4.15c.05-.23.09-.46.09-.7 0-.24-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.85c-.54-.5-1.25-.81-2.04-.81-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92 0-1.61-1.31-2.92-2.92-2.92z"
            />
          </defs>
          <g fill="none" fillRule="evenodd">
            <mask id="b" fill="#fff">
              <use xlinkHref="#a" />
            </mask>
            <g fill="#000" fillOpacity=".54" mask="url(#b)">
              <path d="M0 0h24v24H0z" />
            </g>
          </g>
        </svg>
      ),
      roundCross: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="18"
          height="18"
          viewBox="0 0 18 18">
          <defs>
            <clipPath id="clip-path">
              <path
                id="icon_content_clear_24px"
                data-name="icon/content/clear_24px"
                d="M8.6.2a.664.664,0,0,0-.94,0L4.4,3.455,1.135.195a.665.665,0,1,0-.94.94l3.26,3.26L.195,7.655a.665.665,0,0,0,.94.94L4.4,5.335l3.26,3.26a.665.665,0,0,0,.94-.94l-3.26-3.26L8.6,1.135A.668.668,0,0,0,8.6.2Z"
                transform="translate(0 0)"
                fill="none"
              />
            </clipPath>
          </defs>
          <g id="Group_283" data-name="Group 283" transform="translate(-115 -250)">
            <circle id="Oval" cx="9" cy="9" r="9" transform="translate(115 250)" fill="#7e7b7f" />
            <g id="icon_content_clear_24px-2" data-name="icon/content/clear_24px" transform="translate(116 251)">
              <rect
                id="icon_content_clear_24px_background"
                data-name="icon/content/clear_24px background"
                width="16"
                height="16"
                fill="rgba(0,0,0,0)"
              />
              <path
                id="icon_content_clear_24px-3"
                data-name="icon/content/clear_24px"
                d="M8.6.2a.664.664,0,0,0-.94,0L4.4,3.455,1.135.195a.665.665,0,1,0-.94.94l3.26,3.26L.195,7.655a.665.665,0,0,0,.94.94L4.4,5.335l3.26,3.26a.665.665,0,0,0,.94-.94l-3.26-3.26L8.6,1.135A.668.668,0,0,0,8.6.2Z"
                transform="translate(3.605 3.605)"
                fill="none"
              />
              <g id="Group_147" data-name="Group 147" transform="translate(3.605 3.605)" clipPath="url(#clip-path)">
                <g id="_Color" data-name="↳ Color" transform="translate(-3.605 -3.605)">
                  <rect
                    id="_Color_background"
                    data-name="↳ Color background"
                    width="16"
                    height="16"
                    fill="rgba(0,0,0,0)"
                  />
                  <rect id="Rectangle_13" data-name="Rectangle 13" width="16" height="16" fill="#fff" />
                </g>
              </g>
            </g>
          </g>
        </svg>
      ),
      copyToClipboard: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="24"
          height="24"
          viewBox="0 0 24 24">
          <defs>
            <path
              id="a"
              d="M15.5 1h-11c-1.1 0-2 .9-2 2v13c0 .55.45 1 1 1s1-.45 1-1V4c0-.55.45-1 1-1h10c.55 0 1-.45 1-1s-.45-1-1-1zm4 4h-11c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-1 16h-9c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h9c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1z"
            />
          </defs>
          <g fill="none" fillRule="evenodd">
            <mask id="b" fill="#fff">
              <use xlinkHref="#a" />
            </mask>
            <g fill="#000" fillOpacity=".54" mask="url(#b)">
              <path d="M0 0h24v24H0z" />
            </g>
          </g>
        </svg>
      ),
      moreHoriz: () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="none" d="M0 0h24v24H0V0z" />
          <path
            fill={fill ? fill : '#fff'}
            d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
          />
        </svg>
      ),
      crossSmall: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width ? width : 24}
          height={height ? height : 24}
          viewBox="0 0 24 24">
          <path fill="none" d="M0 0h24v24H0V0z" />
          <path
            fill={fill ? fill : '#4a4a4a'}
            d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
          />
        </svg>
      ),
      arrow_right : () =>(
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" 
          width={width ? width : 24}
          height={height ? height : 24} viewBox="0 0 25 24">
          <defs>
              <path id="a" d="M1.209 9h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42.39.39 1.02.39 1.41 0l6.59-6.59a.996.996 0 0 0 0-1.41L8.919.7a.996.996 0 1 0-1.41 1.41L12.379 7H1.209c-.55 0-1 .45-1 1s.45 1 1 1z"/>
          </defs>
          <g fill="none" fillRule="evenodd" transform="translate(5 4)">
              <mask id="b" fill="#fff">
                  <use xlinkHref="#a"/>
              </mask>
              <g fill={fill || "#fff"} mask="url(#b)">
                  <path d="M-4-4h24v24H-4z"/>
              </g>
          </g>
      </svg>

      ),
      backArrow: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="16"
          height="16"
          viewBox="0 0 16 16">
          <defs>
            <path
              id="a"
              d="M18.791 11.005H7.621l4.88-4.88c.39-.39.39-1.03 0-1.42a.996.996 0 0 0-1.41 0l-6.59 6.59a.996.996 0 0 0 0 1.41l6.59 6.59a.996.996 0 1 0 1.41-1.41l-4.88-4.88h11.17c.55 0 1-.45 1-1s-.45-1-1-1z"
            />
          </defs>
          <g fill="none" fillRule="evenodd" transform="translate(-4 -4)">
            <mask id="b" fill="#fff">
              <use xlinkHref="#a" />
            </mask>
            <g fill={fill ? fill : '#fff'} mask="url(#b)">
              <path d="M0 0h24v24H0z" />
            </g>
          </g>
        </svg>
      ),
      infoOutLine: () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="none" d="M0 0h24v24H0V0z" />
          <path
            fill="#FF7676"
            d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
          />
        </svg>
        // <svg
        //   xmlns="http://www.w3.org/2000/svg"
        //   xmlnsXlink="http://www.w3.org/1999/xlink"
        //   width="20"
        //   height="20"
        //   viewBox="0 0 20 20">
        //   <defs>
        //     <path
        //       id="a"
        //       d="M9 5h2v2H9V5zm1 10c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1zm0-15C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
        //     />
        //   </defs>
        //   <use fill="#FF7676" fillRule="nonzero" xlinkHref="#a" />
        // </svg>
      ),
      plus: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 24}
            height={height ? height : 24}
            viewBox="0 0 24 24">
            <path fill="none" d="M0 0h24v24H0V0z" />
            <path
              fill={fill ? fill : '#fff'}
              d="M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1z"
            />
          </svg>
        )
      },
      circularPlus: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 24}
            height={height ? height : 24}
            viewBox="0 0 24 24">
            <path fill="none" d="M0 0h24v24H0V0z" />
            <path
              fill={fill ? fill : '#fff'}
              d="M12 7c-.55 0-1 .45-1 1v3H8c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V8c0-.55-.45-1-1-1zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
            />
          </svg>
        )
      },
      circularFillPlus: () => (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink">
          <defs>
            <path
              d="M13.5,9.75 L9.75,9.75 L9.75,13.5 C9.75,13.9125 9.4125,14.25 9,14.25 C8.5875,14.25 8.25,13.9125 8.25,13.5 L8.25,9.75 L4.5,9.75 C4.0875,9.75 3.75,9.4125 3.75,9 C3.75,8.5875 4.0875,8.25 4.5,8.25 L8.25,8.25 L8.25,4.5 C8.25,4.0875 8.5875,3.75 9,3.75 C9.4125,3.75 9.75,4.0875 9.75,4.5 L9.75,8.25 L13.5,8.25 C13.9125,8.25 14.25,8.5875 14.25,9 C14.25,9.4125 13.9125,9.75 13.5,9.75 Z"
              id="path-1"
            />
          </defs>
          <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Insure.Full-1---Copy" transform="translate(-210.000000, -359.000000)">
              <g id="Group-8" transform="translate(210.000000, 359.000000)">
                <circle id="Oval" fillOpacity="0.796601836" fill="#EFEEEE" cx="12" cy="12" r="12" />
                <g id="icon/content/add_24px" transform="translate(3.000000, 3.000000)">
                  <mask id="mask-2" fill="white">
                    <use xlinkHref="#path-1" />
                  </mask>
                  <g fillRule="nonzero" />
                  <g
                    id="✱-/-Color-/-Icons-/-Black-/-Inactive"
                    mask="url(#mask-2)"
                    fill="#000000"
                    fillOpacity="0.54"
                    fillRule="evenodd">
                    <rect id="Rectangle" x="0" y="0" width="18" height="18" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      ),
      circularFillPlus1: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width ? width : 24}
          height={height ? height : 24}
          viewBox="0 0 24 24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            fill={fill ? fill : '#fff'}
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
          />
        </svg>
      ),
      circularQusn: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 24}
            height={height ? height : 24}
            // width="24" height="24"
            viewBox="0 0 24 24">
            <path fill="none" d="M0 0h24v24H0V0z" />
            <path
              fill={fill ? fill : '#fff'}
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-4h2v2h-2zm1.61-9.96c-2.06-.3-3.88.97-4.43 2.79-.18.58.26 1.17.87 1.17h.2c.41 0 .74-.29.88-.67.32-.89 1.27-1.5 2.3-1.28.95.2 1.65 1.13 1.57 2.1-.1 1.34-1.62 1.63-2.45 2.88 0 .01-.01.01-.01.02-.01.02-.02.03-.03.05-.09.15-.18.32-.25.5-.01.03-.03.05-.04.08-.01.02-.01.04-.02.07-.12.34-.2.75-.2 1.25h2c0-.42.11-.77.28-1.07.02-.03.03-.06.05-.09.08-.14.18-.27.28-.39.01-.01.02-.03.03-.04.1-.12.21-.23.33-.34.96-.91 2.26-1.65 1.99-3.56-.24-1.74-1.61-3.21-3.35-3.47z"
            />
          </svg>
        )
      },
      minus: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 24}
            height={height ? height : 24}
            viewBox="0 0 24 24">
            <path fill="none" d="M0 0h24v24H0V0z" />
            <path fill={fill ? fill : '#fff'} d="M18 13H6c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1z" />
          </svg>
        )
      },
      circularMinus: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="24"
            height="24"
            viewBox="0 0 24 24">
            <defs>
              <path
                id="a"
                d="M7 12c0 .55.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1zm5-10C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
              />
            </defs>
            <g fill="none" fillRule="evenodd">
              <mask id="b" fill="#fff">
                <use xlinkHref="#a" />
              </mask>
              <g
                //  fill="#000" fillOpacity=".54"
                mask="url(#b)">
                <path fill={fill ? fill : '#fff'} d="M0 0h24v24H0z" />
              </g>
            </g>
          </svg>
        )
      },
      checkmark: () => {
        return (
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 24}
            height={height ? height : 24}
            // width="24"
            // height="24"
            viewBox="0 0 24 24">
            <title>check_circle</title>
            <path
              fill={fill ? fill : '#000000'}
              d="M9.984 17.016l9-9-1.406-1.453-7.594 7.594-3.563-3.563-1.406 1.406zM12 2.016c5.531 0 9.984 4.453 9.984 9.984s-4.453 9.984-9.984 9.984-9.984-4.453-9.984-9.984 4.453-9.984 9.984-9.984z"
            />
          </svg>
        )
      },
      cross: () => {
        return (
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            width={width ? width : 20}
            height={height ? height : 20}>
            <title>cross</title>
            <path
              fill={fill ? fill : '#000000'}
              d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
            />
          </svg>
        )
      },
      blackcross: () => {
        return (
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            width={width ? width : 20}
            height={height ? height : 20}>
            <title>blackcross</title>
            <path
              fill={fill ? fill : '#4a4a4a'}
              d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
            />
          </svg>
        )
      },
      checkmark_empty: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            // xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 32 32"
            version="1.1"
            width={width ? width : 32}
            height={height ? height : 32}
            // width="32px"
            // height="32px"
          >
            <g id="surface1">
              <path
                fill={fill ? fill : '#000000'}
                d="M 16 3 C 8.832031 3 3 8.832031 3 16 C 3 23.167969 8.832031 29 16 29 C 23.167969 29 29 23.167969 29 16 C 29 8.832031 23.167969 3 16 3 Z M 16 5 C 22.085938 5 27 9.914063 27 16 C 27 22.085938 22.085938 27 16 27 C 9.914063 27 5 22.085938 5 16 C 5 9.914063 9.914063 5 16 5 Z M 22.28125 11.28125 L 15 18.5625 L 10.71875 14.28125 L 9.28125 15.71875 L 14.28125 20.71875 L 15 21.40625 L 15.71875 20.71875 L 23.71875 12.71875 Z "
              />
            </g>
          </svg>
        )
      },
      google: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            // xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 48 48"
            version="1.1"
            // width="480px"
            // height="480px"
            width={width ? width : 48}
            height={height ? height : 48}>
            <g id="surface1">
              <path
                // style=" fill:#FFC107;"
                fill={fill ? fill : '#FFC107'}
                d="M 43.609375 20.082031 L 42 20.082031 L 42 20 L 24 20 L 24 28 L 35.304688 28 C 33.652344 32.65625 29.222656 36 24 36 C 17.371094 36 12 30.628906 12 24 C 12 17.371094 17.371094 12 24 12 C 27.058594 12 29.84375 13.152344 31.960938 15.039063 L 37.617188 9.382813 C 34.046875 6.054688 29.269531 4 24 4 C 12.953125 4 4 12.953125 4 24 C 4 35.046875 12.953125 44 24 44 C 35.046875 44 44 35.046875 44 24 C 44 22.660156 43.863281 21.351563 43.609375 20.082031 Z "
              />
              <path
                // style=" fill:#FF3D00;"
                fill={fill ? fill : '#FF3D00'}
                d="M 6.304688 14.691406 L 12.878906 19.511719 C 14.65625 15.109375 18.960938 12 24 12 C 27.058594 12 29.84375 13.152344 31.960938 15.039063 L 37.617188 9.382813 C 34.046875 6.054688 29.269531 4 24 4 C 16.316406 4 9.65625 8.335938 6.304688 14.691406 Z "
              />
              <path
                // style=" fill:#4CAF50;"
                fill={fill ? fill : '#4CAF50'}
                d="M 24 44 C 29.164063 44 33.859375 42.023438 37.410156 38.808594 L 31.21875 33.570313 C 29.210938 35.089844 26.714844 36 24 36 C 18.796875 36 14.382813 32.683594 12.71875 28.054688 L 6.195313 33.078125 C 9.503906 39.554688 16.226563 44 24 44 Z "
              />
              <path
                // style=" fill:#1976D2;"
                fill={fill ? fill : '#1976D2'}
                d="M 43.609375 20.082031 L 42 20.082031 L 42 20 L 24 20 L 24 28 L 35.304688 28 C 34.511719 30.238281 33.070313 32.164063 31.214844 33.570313 C 31.21875 33.570313 31.21875 33.570313 31.21875 33.570313 L 37.410156 38.808594 C 36.972656 39.203125 44 34 44 24 C 44 22.660156 43.863281 21.351563 43.609375 20.082031 Z "
              />
            </g>
          </svg>
        )
      },
      googlePay: () => {
        return (
          <svg
            // width="425px"
            // height="272px"
            width={width ? width : 48}
            height={height ? height : 48}
            // viewBox="0 0 48 48"
            viewBox="0 0 425 272"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink">
            <title>GooglePay_mark_800_gray</title>
            <desc>Created with Sketch.</desc>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="GooglePay_mark_800_gray">
                <g id="border">
                  <path
                    d="M386.731012,0.0897642745 L38.039747,0.0897642745 C36.587241,0.0897642745 35.1321687,0.0897642745 33.6822289,0.0974583552 C32.4581205,0.107717129 31.2365783,0.120540597 30.0124699,0.153881613 C27.3461205,0.225693033 24.6566747,0.38213934 22.0236867,0.856607648 C19.3496386,1.33620534 16.8603614,2.12100157 14.4326747,3.35718387 C12.0434819,4.57028392 9.85959036,6.15782923 7.96312048,8.05057307 C6.06921687,9.94588161 4.4806988,12.1258711 3.26685542,14.5161655 C2.02991566,16.9423656 1.24463855,19.4301184 0.767313253,22.1050938 C0.289987952,24.739034 0.133445783,27.4242682 0.0615903614,30.0864201 C0.0282289157,31.3097789 0.0128313253,32.5305731 0.00513253012,33.7513672 C-0.00256626506,35.2029838 1.08420217e-19,36.6546003 1.08420217e-19,38.1087816 L1.08420217e-19,233.841064 C1.08420217e-19,235.295246 -0.00256626506,236.744298 0.00513253012,238.198479 C0.0128313253,239.419273 0.0282289157,240.642632 0.0615903614,241.863426 C0.133445783,244.523013 0.289987952,247.210812 0.767313253,249.842188 C1.24463855,252.517163 2.02991566,255.004916 3.26685542,257.43368 C4.4806988,259.82141 6.06921687,262.003964 7.96312048,263.896708 C9.85959036,265.792017 12.0434819,267.379562 14.4326747,268.590097 C16.8603614,269.828844 19.3496386,270.613641 22.0236867,271.095803 C24.6566747,271.565142 27.3461205,271.724153 30.0124699,271.795964 C31.2365783,271.824176 32.4581205,271.842129 33.6822289,271.847258 C35.1321687,271.857517 36.587241,271.857517 38.039747,271.857517 L386.731012,271.857517 C388.180952,271.857517 389.636024,271.857517 391.085964,271.847258 C392.307506,271.842129 393.529048,271.824176 394.758289,271.795964 C397.419506,271.724153 400.108952,271.565142 402.747072,271.095803 C405.418554,270.613641 407.907831,269.828844 410.338084,268.590097 C412.727277,267.379562 414.906036,265.792017 416.805072,263.896708 C418.69641,262.003964 420.284928,259.82141 421.501337,257.43368 C422.740843,255.004916 423.52612,252.517163 424.00088,249.842188 C424.478205,247.210812 424.632181,244.523013 424.704036,241.863426 C424.737398,240.642632 424.752795,239.419273 424.760494,238.198479 C424.770759,236.744298 424.770759,235.295246 424.770759,233.841064 L424.770759,38.1087816 C424.770759,36.6546003 424.770759,35.2029838 424.760494,33.7513672 C424.752795,32.5305731 424.737398,31.3097789 424.704036,30.0864201 C424.632181,27.4242682 424.478205,24.739034 424.00088,22.1050938 C423.52612,19.4301184 422.740843,16.9423656 421.501337,14.5161655 C420.284928,12.1258711 418.69641,9.94588161 416.805072,8.05057307 C414.906036,6.15782923 412.727277,4.57028392 410.338084,3.35718387 C407.907831,2.12100157 405.418554,1.33620534 402.747072,0.856607648 C400.108952,0.38213934 397.419506,0.225693033 394.758289,0.153881613 C393.529048,0.120540597 392.307506,0.107717129 391.085964,0.0974583552 C389.636024,0.0897642745 388.180952,0.0897642745 386.731012,0.0897642745"
                    id="Fill-1"
                    fill="#3C4043"
                  />
                  <path
                    d="M386.731012,9.14826192 L391.021807,9.155956 C392.181759,9.16365008 393.344277,9.17647355 394.511928,9.20981456 C396.54441,9.26367313 398.923337,9.37395495 401.14059,9.77148245 C403.065289,10.1177161 404.682036,10.646043 406.23206,11.4334039 C407.76412,12.210506 409.165301,13.2312541 410.38941,14.4520482 C411.618651,15.6831011 412.640024,17.0859885 413.427867,18.6324987 C414.213145,20.1713148 414.736663,21.776813 415.083108,23.7157213 C415.478313,25.9085343 415.588663,28.2911346 415.642554,30.3351954 C415.675916,31.4867428 415.691313,32.6408549 415.696446,33.8231786 C415.706711,35.2517129 415.706711,36.6776826 415.706711,38.1087816 L415.706711,233.841064 C415.706711,235.272163 415.706711,236.698133 415.696446,238.154879 C415.691313,239.308991 415.675916,240.463103 415.642554,241.61978 C415.588663,243.658711 415.478313,246.041312 415.077976,248.257207 C414.736663,250.170468 414.213145,251.775966 413.422735,253.322477 C412.637458,254.866422 411.618651,256.266745 410.394542,257.490104 C409.162735,258.721157 407.766687,259.736775 406.216663,260.521572 C404.676904,261.306368 403.065289,261.834695 401.158554,262.175799 C398.895108,262.578456 396.418663,262.691302 394.552988,262.740031 C393.380205,262.768243 392.212554,262.783631 391.014108,262.788761 C389.589831,262.799019 388.157855,262.799019 386.731012,262.799019 L38.039747,262.799019 C38.0217831,262.799019 38.0038193,262.799019 37.9832892,262.799019 C36.5744096,262.799019 35.1603976,262.799019 33.7258554,262.788761 C32.5556386,262.783631 31.387988,262.768243 30.2588313,262.742596 C28.3495301,262.691302 25.8705181,262.578456 23.6276024,262.178364 C21.7029036,261.834695 20.0912892,261.306368 18.531,260.511313 C16.9963735,259.734211 15.6003253,258.718592 14.3685181,257.484974 C13.1469759,256.266745 12.1307349,254.868987 11.3454578,253.322477 C10.5576145,251.778531 10.0315301,250.167904 9.68508434,248.23156 C9.28731325,246.018229 9.17696386,243.648453 9.12050602,241.61978 C9.08971084,240.460539 9.07687952,239.298732 9.06918072,238.147185 L9.06404819,234.741272 L9.06404819,37.2111388 L9.06918072,33.8129199 C9.07687952,32.6511137 9.08971084,31.4918722 9.12050602,30.3326307 C9.17696386,28.3013934 9.28731325,25.9290519 9.69021687,23.6977685 C10.0315301,21.7819424 10.5576145,20.1687501 11.3480241,18.6171105 C12.1281687,17.0834238 13.1469759,15.6831011 14.3736506,14.4571776 C15.597759,13.2312541 17.001506,12.2156354 18.5438313,11.4308392 C20.0861566,10.6434783 21.7029036,10.1177161 23.6276024,9.77148245 C25.8448554,9.37395495 28.2237831,9.26367313 30.2613976,9.20981456 C31.4213494,9.17647355 32.5838675,9.16365008 33.7361205,9.155956 L38.039747,9.14826192 L386.731012,9.14826192"
                    id="wihit-fill"
                    fill="#FFFFFE"
                  />
                </g>
                <g id="GPay-logo" transform="translate(48.759036, 76.981132)">
                  <g id="Pay" transform="translate(143.569904, 7.624798)" fill="#3C4043">
                    <path
                      d="M12.1771332,57.6434717 L12.1771332,96.3774447 L0.0751674892,96.3774447 L0.0751674892,0.762479784 L32.1716854,0.762479784 C39.9139368,0.609983827 47.4306857,3.58365499 52.9179124,9.07350943 C63.8923658,19.4432345 64.5688732,36.9040216 54.2709272,48.1124744 C53.8199223,48.5699623 53.3689173,49.0274501 52.9179124,49.484938 C47.2803507,54.8985445 40.3649417,57.6434717 32.1716854,57.6434717 L12.1771332,57.6434717 Z M12.1771332,12.5046685 L12.1771332,45.901283 L32.4723553,45.901283 C36.9824047,46.053779 41.342119,44.2238275 44.4239861,40.9451644 C50.7380552,34.3115903 50.5877202,23.6368733 44.0481487,17.2320431 C40.9662816,14.182124 36.8320697,12.5046685 32.4723553,12.5046685 L12.1771332,12.5046685 Z"
                      id="Shape"
                      fillRule="nonzero"
                    />
                    <path
                      d="M89.5244796,28.8217358 C98.4694108,28.8217358 105.535155,31.2616712 110.721712,36.0652938 C115.908268,40.8689164 118.463963,47.5787385 118.463963,56.0422642 L118.463963,96.3774447 L106.88817,96.3774447 L106.88817,87.3039353 L106.361997,87.3039353 C101.325775,94.7762372 94.7110364,98.5123881 86.3674451,98.5123881 C79.3017011,98.5123881 73.2883019,96.3774447 68.5527501,92.107558 C63.8923658,88.1426631 61.2615037,82.2715687 61.4118387,76.0954825 C61.4118387,69.3094124 63.9675333,63.9720539 69.0037551,59.9309111 C74.0399768,55.8897682 80.8050509,53.9073208 89.2238097,53.9073208 C96.4398886,53.9073208 102.302953,55.2797844 106.963337,57.8722156 L106.963337,55.0510404 C106.963337,50.8574016 105.159317,46.8925067 102.002283,44.1475795 C98.7700808,41.2501563 94.6358689,39.6489488 90.351322,39.6489488 C83.586248,39.6489488 78.2493562,42.546372 74.3406468,48.3412183 L63.6668633,41.5551482 C69.3795925,33.0916226 78.0238538,28.8217358 89.5244796,28.8217358 Z M73.8896419,76.3242264 C73.8896419,79.5266415 75.3929916,82.5003127 77.8735188,84.3302642 C80.5795484,86.4652075 83.8869179,87.6089272 87.2694549,87.5326792 C92.3808442,87.5326792 97.266731,85.4739838 100.87477,81.8140809 C104.858647,78.0016819 106.88817,73.5030512 106.88817,68.3181887 C103.129795,65.2682695 97.8680709,63.74331 91.1029969,63.819558 C86.2171101,63.819558 82.0828982,65.0395256 78.7755287,67.4032129 C75.5433266,69.7669003 73.8896419,72.7405714 73.8896419,76.3242264 Z"
                      id="Shape"
                      fillRule="nonzero"
                    />
                    <polygon
                      id="Path"
                      points="184.912023 30.9566792 144.471914 125.122933 131.994111 125.122933 147.027609 92.1838059 120.493485 30.9566792 133.647796 30.9566792 152.815506 77.925434 153.041008 77.925434 171.757713 30.9566792"
                    />
                  </g>
                  <g id="Super-G">
                    <path
                      d="M106.813002,56.8809919 C106.813002,53.144841 106.512332,49.40869 105.910992,45.7487871 L54.8722671,45.7487871 L54.8722671,66.8694771 L84.1124204,66.8694771 C82.9097406,73.6555472 79.0010311,79.7553854 73.2883019,83.5677844 L73.2883019,97.2924205 L90.7271594,97.2924205 C100.949938,87.7614232 106.813002,73.6555472 106.813002,56.8809919 Z"
                      id="Path"
                      fill="#4285F4"
                    />
                    <path
                      d="M54.8722671,110.559569 C69.45476,110.559569 81.7822282,105.679698 90.7271594,97.2924205 L73.2883019,83.5677844 C68.4024152,86.9226954 62.1635136,88.8288949 54.8722671,88.8288949 C40.7407791,88.8288949 28.7891484,79.1454016 24.5046015,66.1832453 L6.53957156,66.1832453 L6.53957156,80.3653693 C15.7100052,98.893628 34.42671,110.559569 54.8722671,110.559569 Z"
                      id="Path"
                      fill="#34A853"
                    />
                    <path
                      d="M24.5046015,66.1832453 C22.2495768,59.3971752 22.2495768,52.0011213 24.5046015,45.1388032 L24.5046015,31.0329272 L6.53957156,31.0329272 C-1.20267983,46.5112668 -1.20267983,64.8107817 6.53957156,80.2891213 L24.5046015,66.1832453 Z"
                      id="Path"
                      fill="#FBBC04"
                    />
                    <path
                      d="M54.8722671,22.4931536 C62.6145185,22.3406577 70.0560999,25.3143288 75.6184941,30.7279353 L91.1029969,15.0208518 C81.2560558,5.71859838 68.3272477,0.609983827 54.8722671,0.762479784 C34.42671,0.762479784 15.7100052,12.5046685 6.53957156,31.0329272 L24.5046015,45.2150512 C28.7891484,32.1766469 40.7407791,22.4931536 54.8722671,22.4931536 Z"
                      id="Path"
                      fill="#EA4335"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        )
      },
      arrow_down: () => {
        return (
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 24}
            height={height ? height : 24}
            // width="24"
            // height="24"
            viewBox="0 0 24 24">
            <title>arrow_drop_down</title>
            <path fill={fill ? fill : '#000000'} d="M6.984 9.984h10.031l-5.016 5.016z" />
          </svg>
        )
      },
      check: () => {
        return (
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <title>check</title>
            <path d="M9 16.172l10.594-10.594 1.406 1.406-12 12-5.578-5.578 1.406-1.406z" />
          </svg>
        )
      },
      question: () =>  {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="14" height="14" viewBox="0 0 14 14">
            <defs>
                <path id="a" d="M6 .167A5.835 5.835 0 0 0 .167 6 5.835 5.835 0 0 0 6 11.833 5.835 5.835 0 0 0 11.833 6 5.835 5.835 0 0 0 6 .167zm0 10.5A4.673 4.673 0 0 1 1.333 6 4.673 4.673 0 0 1 6 1.333 4.673 4.673 0 0 1 10.667 6 4.673 4.673 0 0 1 6 10.667zm-.583-2.334h1.166V9.5H5.417V8.333zm.939-5.81a2.334 2.334 0 0 0-2.584 1.628.529.529 0 0 0 .507.682h.117c.239 0 .431-.169.513-.39.187-.52.741-.875 1.342-.747.554.116.962.659.916 1.225-.059.781-.945.95-1.43 1.68 0 .006-.005.006-.005.011-.006.012-.012.018-.018.03a1.943 1.943 0 0 0-.146.291c-.005.018-.017.03-.023.047-.006.012-.006.023-.012.04-.07.2-.116.438-.116.73h1.166c0-.245.064-.45.164-.624.011-.018.017-.035.029-.053.046-.081.105-.157.163-.227.006-.006.012-.018.018-.024a2.05 2.05 0 0 1 .192-.198c.56-.53 1.318-.962 1.161-2.076-.14-1.015-.94-1.873-1.954-2.025z"/>
            </defs>
            <g fill="none" fillRule="evenodd" transform="translate(1 1)">
                <mask id="b" fill="#fff">
                    <use xlinkHref="#a"/>
                </mask>
                <g fill="#436AB2" fillOpacity=".87" mask="url(#b)">
                    <path d="M-1-1h14v14H-1z"/>
                </g>
            </g>
        </svg>

        )
      },
      whiteCheck: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="76"
            height="76"
            viewBox="0 0 76 76">
            <defs>
              <clipPath id="clip-path">
                <path
                  id="icon_navigation_check_24px"
                  data-name="icon/navigation/check_24px"
                  d="M12.657,25.861l-8.491-8.83a2.371,2.371,0,0,0-3.45,0,2.606,2.606,0,0,0,0,3.588L10.944,31.256a2.371,2.371,0,0,0,3.45,0L40.284,4.332a2.606,2.606,0,0,0,0-3.588,2.371,2.371,0,0,0-3.45,0Z"
                  fill="#fff"
                />
              </clipPath>
            </defs>
            <g id="Group_53" data-name="Group 53" transform="translate(-150 -253)">
              <circle id="Oval" cx="38" cy="38" r="38" transform="translate(150 253)" fill="none" />
              <g
                id="icon_navigation_check_24px-2"
                data-name="icon/navigation/check_24px"
                transform="translate(168 275)">
                <path
                  id="icon_navigation_check_24px-3"
                  data-name="icon/navigation/check_24px"
                  d="M12.657,25.861l-8.491-8.83a2.371,2.371,0,0,0-3.45,0,2.606,2.606,0,0,0,0,3.588L10.944,31.256a2.371,2.371,0,0,0,3.45,0L40.284,4.332a2.606,2.606,0,0,0,0-3.588,2.371,2.371,0,0,0-3.45,0Z"
                  fill="#fff"
                />
              </g>
            </g>
          </svg>
        )
      },
      pinkCheck: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="76"
            height="76"
            viewBox="0 0 76 76">
            <defs>
              <path
                id="a"
                d="M12.657 25.86l-8.49-8.83a2.39 2.39 0 0 0-1.726-.744 2.39 2.39 0 0 0-1.725.745 2.606 2.606 0 0 0 0 3.588l10.228 10.637a2.371 2.371 0 0 0 3.45 0l25.89-26.924a2.606 2.606 0 0 0 0-3.588A2.39 2.39 0 0 0 38.56 0a2.39 2.39 0 0 0-1.725.744L12.657 25.861z"
              />
            </defs>
            <g fill="none" fillRule="evenodd">
              <circle cx="38" cy="38" r="38" fill="#FF7676" />
              <use fill="#FFF" fillRule="nonzero" transform="translate(18 22)" xlinkHref="#a" />
            </g>
          </svg>
        )
      },
      expand_less: () => {
        return (
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 24}
            height={height ? height : 24}
            // width="24"
            // height="24"
            viewBox="0 0 24 24">
            <title>expand_less</title>
            <path fill={fill ? fill : '#000000'} d="M12 8.016l6 6-1.406 1.406-4.594-4.594-4.594 4.594-1.406-1.406z" />
          </svg>
        )
      },
      expand_more: () => {
        return (
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 24}
            height={height ? height : 24}
            viewBox="0 0 24 24">
            <title>expand_more</title>
            <path fill={fill ? fill : '#000000'} d="M16.594 8.578l1.406 1.406-6 6-6-6 1.406-1.406 4.594 4.594z" />
          </svg>
        )
      },
      chevron_down: () => {
        return (
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 20}
            height={height ? height : 20}
            // width="20"
            // height="20"
            viewBox="0 0 20 20">
            <title>chevron-down</title>
            <path
              fill={fill ? fill : '#000000'}
              d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
            />
          </svg>
        )
      },
      chevron_left: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={width ? width : 24}
            height={height ? height : 24}
            viewBox="0 0 24 24">
            <defs>
              <path
                id="a"
                d="M17.002 2.985a1.25 1.25 0 0 0-1.77 0l-8.31 8.31a.996.996 0 0 0 0 1.41l8.31 8.31c.49.49 1.28.49 1.77 0s.49-1.28 0-1.77l-7.24-7.25 7.25-7.25c.48-.48.48-1.28-.01-1.76z"
              />
            </defs>
            <g fill="none" fillRule="evenodd">
              <mask id="b" fill="#fff">
                <use xlinkHref="#a" />
              </mask>
              <g
                fill={fill ? fill : '#000000'}
                // fill="#000" fill-opacity=".54"
                mask="url(#b)">
                <path d="M0 0h24v24H0z" />
              </g>
            </g>
          </svg>
        )
      },
      chevron_right: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path fill="none" d="M0 0h24v24H0V0z" />
            <path
              fill={fill ? fill : '#000000'}
              d="M9.29 6.71c-.39.39-.39 1.02 0 1.41L13.17 12l-3.88 3.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L10.7 6.7c-.38-.38-1.02-.38-1.41.01z"
            />
          </svg>
        )
      },
      chevron_up: () => {
        return (
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 20}
            height={height ? height : 20}
            viewBox="0 0 20 20">
            <title>chevron-up</title>
            <path
              fill={fill ? fill : '#000000'}
              d="M15.484 12.452c-0.436 0.446-1.043 0.481-1.576 0l-3.908-3.747-3.908 3.747c-0.533 0.481-1.141 0.446-1.574 0-0.436-0.445-0.408-1.197 0-1.615 0.406-0.418 4.695-4.502 4.695-4.502 0.217-0.223 0.502-0.335 0.787-0.335s0.57 0.112 0.789 0.335c0 0 4.287 4.084 4.695 4.502s0.436 1.17 0 1.615z"
            />
          </svg>
        )
      },
      triangle_down: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 24}
            height={height ? height : 24}
            viewBox="0 0 24 24">
            <path fill="none" d="M0 0h24v24H0V0z" />
            <path
              fill={fill ? fill : '#436ab2'}
              d="M8.71 11.71l2.59 2.59c.39.39 1.02.39 1.41 0l2.59-2.59c.63-.63.18-1.71-.71-1.71H9.41c-.89 0-1.33 1.08-.7 1.71z"
            />
          </svg>
        )
      },
      triangle_left: () => {
        return (
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 20}
            height={height ? height : 20}
            // width="20"
            // height="20"
            viewBox="0 0 20 20">
            <title>triangle-left</title>
            <path fill={fill ? fill : '#000000'} d="M14 5v10l-9-5 9-5z" />
          </svg>
        )
      },
      triangle_right: () => {
        return (
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 20}
            height={height ? height : 20}
            viewBox="0 0 20 20">
            <title>triangle-right</title>
            <path fill={fill ? fill : '#000000'} d="M15 10l-9 5v-10l9 5z" />
          </svg>
        )
      },
      triangle_up: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 24}
            height={height ? height : 24}
            viewBox="0 0 24 24">
            <path fill="none" d="M0 0h24v24H0V0z" />
            <path
              fill={fill ? fill : '#436ab2'}
              d="M8.71 12.29L11.3 9.7c.39-.39 1.02-.39 1.41 0l2.59 2.59c.63.63.18 1.71-.71 1.71H9.41c-.89 0-1.33-1.08-.7-1.71z"
            />
          </svg>
        )
      },
      howItworksIcon1: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="34.707" height="40" viewBox="0 0 34.707 40">
            <g id="pills" transform="translate(-33.877 0)">
              <g id="Group_1926" data-name="Group 1926" transform="translate(33.877 0)">
                <g id="Group_1925" data-name="Group 1925">
                  <path
                    id="Path_1"
                    data-name="Path 1"
                    d="M239.027,401.225a1.849,1.849,0,1,0-1.849,1.849A1.851,1.851,0,0,0,239.027,401.225Zm-2.483,0a.634.634,0,1,1,.634.634A.634.634,0,0,1,236.544,401.225Z"
                    transform="translate(-219.657 -368.5)"
                    fill="#1ae5be"
                  />
                  <path
                    id="Path_2"
                    data-name="Path 2"
                    d="M67.74,20.127a5.429,5.429,0,0,0,0-5.817L64.043,8.448h0L60.349,2.584A5.586,5.586,0,0,0,52.7.832a5.463,5.463,0,0,0-2.468,3.424,5.522,5.522,0,0,0-.127.819,5.549,5.549,0,0,0-3.952,1.385l-5.21,4.6h0l-5.21,4.6a5.461,5.461,0,0,0-.454,7.76A5.519,5.519,0,0,0,36.9,24.652a.589.589,0,0,0,.788-.253.578.578,0,0,0-.255-.781,4.324,4.324,0,0,1-.916-7.1l4.773-4.21,4.523,5.031a5.614,5.614,0,0,0-1.473.381,5.487,5.487,0,0,0-3,2.975A5.411,5.411,0,0,0,41,23.8a4.379,4.379,0,0,1-1.223.277.58.58,0,0,0,.047,1.159l.048,0a5.558,5.558,0,0,0,1.464-.32,5.487,5.487,0,0,0,3,2.962l6.042,2.479a1.027,1.027,0,0,0,1.336-.548L52.054,29a1.712,1.712,0,1,0,1.312-3.137l1.311-3.135,2.069,4.948a2.005,2.005,0,1,0,2.436,2.595l5.834-2.394a5.464,5.464,0,0,0,2.725-7.75Zm-25.577-8.59,4.773-4.21a4.377,4.377,0,0,1,3.207-1.086,5.447,5.447,0,0,0,.792,2.165l2.714,4.306a4.32,4.32,0,0,1-.891,1.09L48.4,17.649a5.616,5.616,0,0,0-.976-.264ZM53.435,27.5a.552.552,0,0,1-.924.4l.4-.951A.551.551,0,0,1,53.435,27.5Zm-2.744,1.724-5.9-2.423a4.326,4.326,0,0,1-2.369-5.665,4.4,4.4,0,0,1,5.718-2.346l5.9,2.423Zm3.986-9c-.017-.008-.033-.016-.05-.023L49.6,18.139l3.933-3.47a5.518,5.518,0,0,0,.8-.871l3.286,5.215L54.727,20.2C54.71,20.207,54.693,20.216,54.677,20.224Zm2.6,10.227a.841.841,0,0,1-.072-1.68l.434,1.038a1.008,1.008,0,0,0,.265.369A.848.848,0,0,1,57.275,30.451Zm9.66-5.992a4.328,4.328,0,0,1-2.369,2.346l-5.9,2.423-3.35-8.011,5.9-2.423a4.386,4.386,0,0,1,3.35,0A4.337,4.337,0,0,1,66.539,20.4c.007.012.015.024.023.036a4.377,4.377,0,0,1,.374.7A4.27,4.27,0,0,1,66.936,24.459Zm.048-5.375a5.59,5.59,0,0,0-6.215-1.362l-2.051.842-2.783-4.417,4.4-2.718a.577.577,0,0,0,.187-.8.589.589,0,0,0-.807-.185l-4.4,2.718-3.384-5.37A4.284,4.284,0,0,1,51.27,5.72c0-.016,0-.033,0-.049a4.322,4.322,0,0,1,2.056-3.854A4.406,4.406,0,0,1,59.354,3.2l3.384,5.37L62.044,9a.577.577,0,0,0-.187.8.589.589,0,0,0,.807.185l.694-.429,3.384,5.37A4.28,4.28,0,0,1,66.984,19.083Z"
                    transform="translate(-33.877 0)"
                    fill="#4a4a4a"
                  />
                  <path
                    id="Path_3"
                    data-name="Path 3"
                    d="M302.047,417.7a1.789,1.789,0,1,0,1.789,1.789A1.791,1.791,0,0,0,302.047,417.7Zm0,2.362a.574.574,0,1,1,.574-.574A.574.574,0,0,1,302.047,420.062Z"
                    transform="translate(-279.532 -385.34)"
                    fill="#1ae5be"
                  />
                  <path
                    id="Path_4"
                    data-name="Path 4"
                    d="M252.151,457.627a2.2,2.2,0,1,0,2.2,2.2A2.2,2.2,0,0,0,252.151,457.627Zm0,3.19a.987.987,0,1,1,.987-.987A.988.988,0,0,1,252.151,460.817Z"
                    transform="translate(-233.155 -422.032)"
                    fill="#1ae5be"
                  />
                </g>
              </g>
            </g>
          </svg>
        )
      },
      howItworksIcon2: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="40.329" height="28.457" viewBox="0 0 40.329 28.457">
            <g id="Group_1934" data-name="Group 1934" transform="translate(-280.8 -253.8)">
              <g id="Group_1933" data-name="Group 1933" transform="translate(281 254)">
                <path
                  id="delivery-truck"
                  d="M32.644,638.413a3.687,3.687,0,0,0-2.6,1.073,3.613,3.613,0,0,0,0,5.171,3.7,3.7,0,0,0,2.6,1.073,3.659,3.659,0,0,0,0-7.317Zm0,5.691a2.033,2.033,0,1,1,0-4.065,2.033,2.033,0,0,1,0,4.065Zm.943-17.879a.79.79,0,0,0-.545-.211H28.871a.815.815,0,0,0-.813.813v6.667a.815.815,0,0,0,.813.813h6.618a.815.815,0,0,0,.813-.813v-4.464a.814.814,0,0,0-.268-.6Zm1.089,6.456H29.684v-5.049h3.041l1.951,1.756Zm-21.887,5.732a3.687,3.687,0,0,0-2.6,1.073,3.613,3.613,0,0,0,0,5.171,3.7,3.7,0,0,0,2.6,1.073,3.659,3.659,0,0,0,0-7.317Zm0,5.691a2.033,2.033,0,1,1,0-4.065,2.033,2.033,0,0,1,0,4.065Zm-5.423-4.691H5.732v-2.163a.813.813,0,1,0-1.626,0v2.976a.815.815,0,0,0,.813.813H7.366a.813.813,0,0,0,0-1.626Zm4.122-4.431a.815.815,0,0,0-.813-.813H.813a.813.813,0,1,0,0,1.626h9.862A.81.81,0,0,0,11.488,634.982Zm-9.025-2.935,9.862.057a.821.821,0,0,0,.821-.805.805.805,0,0,0-.8-.821l-9.862-.057H2.472a.813.813,0,0,0-.008,1.626Zm1.659-3.691h9.862a.813.813,0,0,0,0-1.626H4.122a.813.813,0,0,0,0,1.626Zm35.505-1.1h0l-5.821-4.821a.8.8,0,0,0-.52-.187H26.44v-2.927a.815.815,0,0,0-.813-.813H4.919a.815.815,0,0,0-.813.813v5.951a.813.813,0,1,0,1.626,0v-5.138h19.09v19.277H18.155a.813.813,0,0,0,0,1.626h9.927a.813.813,0,0,0,0-1.626H26.448V623.876H33l5.3,4.39-.057,11.13H37.4a.813.813,0,0,0,0,1.626h1.65a.808.808,0,0,0,.813-.8l.065-12.326A.859.859,0,0,0,39.628,627.258Z"
                  transform="translate(0 -618.51)"
                  fill="#4a4a4a"
                  stroke="#fff"
                  strokeWidth="0.4"
                />
                <path
                  id="Path_7"
                  data-name="Path 7"
                  d="M254.141,457.627a4.192,4.192,0,1,0,4.192,4.192A4.2,4.2,0,0,0,254.141,457.627Zm0,6.071a1.879,1.879,0,1,1,1.879-1.879A1.881,1.881,0,0,1,254.141,463.7Z"
                  transform="translate(-221.603 -438.254)"
                  fill="#1ae5be"
                  stroke="#fff"
                  strokeWidth="1"
                />
              </g>
            </g>
          </svg>
        )
      },
      howItworksIcon3: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="38.329" height="40" viewBox="0 0 38.329 40">
            <g id="Group_1935" data-name="Group 1935" transform="translate(-278.145 -346.126)">
              <g id="Group_4" data-name="Group 4" transform="translate(304.561 357.746)">
                <path
                  id="v"
                  d="M2.528,6.658,0,0H1.493L2.848,3.871a7.67,7.67,0,0,1,.421,1.577h.048a10.591,10.591,0,0,1,.421-1.577L5.093,0H6.6L4.058,6.658Z"
                  transform="translate(0 2.642)"
                  fill="#1ae5be"
                />
                <path
                  id="_"
                  data-name="~"
                  d="M1.476.922a1.933,1.933,0,0,0-.7.154A2.972,2.972,0,0,0,0,1.541V.563A2.292,2.292,0,0,1,1.577.01a4.479,4.479,0,0,1,.789.067,6.566,6.566,0,0,1,.928.256A4.465,4.465,0,0,0,4.682.614,1.952,1.952,0,0,0,5.4.456,2.965,2.965,0,0,0,6.165,0V.973a2.343,2.343,0,0,1-1.577.568,4.068,4.068,0,0,1-.8-.079A7.684,7.684,0,0,1,2.858,1.2,4.279,4.279,0,0,0,1.476.922Z"
                  fill="#1ae5be"
                />
              </g>
              <g id="gift" transform="translate(278.146 346.126)">
                <path
                  id="Path_8"
                  data-name="Path 8"
                  d="M5.356,29.3a.652.652,0,0,0,.237.149v9.887A.666.666,0,0,0,6.261,40H36.986a.666.666,0,0,0,.668-.664V23.4a.666.666,0,0,0-.668-.664H12.9l2.842-2.825,4.723-4.7,9.447-9.392a.661.661,0,0,0,0-.939L25.193.186a.69.69,0,0,0-.944,0L18.024,6.374c-2.181-1.7-4.781-2.759-6.056-1.492-.837.832-.66,2.235.042,3.714L9.093,11.5c-1.488-.7-2.9-.874-3.737-.041-1.274,1.266-.206,3.851,1.5,6.02L.634,23.663a.661.661,0,0,0,0,.939Zm26.408-5.765-2.626.157Zm-6.8.528H36.318v14.61H24.963Zm-5.343,0h4.008v14.61H19.62Zm-1.336,0v14.61H6.929V28.71H6.893L11.6,24.026v.036ZM15.275,18.5,11.5,14.743l3.779-3.756,3.778,3.756Zm9.446-16.9L28.5,5.352,20,13.8,16.219,10.05ZM12.913,5.821a.8.8,0,0,1,.568-.171,6.877,6.877,0,0,1,3.593,1.669L14.8,9.577l-.382.38c-1.613-2.082-1.935-3.711-1.507-4.137Zm-.226,3.984c.239.373.5.743.783,1.1l-2.058,2.046c-.36-.28-.731-.541-1.106-.779ZM6.3,12.4a.793.793,0,0,1,.566-.171,6.872,6.872,0,0,1,3.594,1.669l-.382.38L7.808,16.531C6.195,14.449,5.873,12.82,6.3,12.4Zm4.251,3.286,3.779,3.757-8.5,8.452L2.054,24.134Zm0,0"
                  transform="translate(-0.438 0)"
                  fill="#4a4a4a"
                />
                <path
                  id="Path_10"
                  data-name="Path 10"
                  d="M399.858,25.875a.557.557,0,0,0-.557.557v.557h-.557a.557.557,0,0,0,0,1.113h.557v.557a.557.557,0,1,0,1.113,0V28.1h.557a.557.557,0,0,0,0-1.113h-.557v-.557A.557.557,0,0,0,399.858,25.875Zm0,0"
                  transform="translate(-364.312 -24.074)"
                  fill="#4a4a4a"
                />
                <path
                  id="Path_11"
                  data-name="Path 11"
                  d="M303.3,146.432a.557.557,0,1,1-.557-.557A.557.557,0,0,1,303.3,146.432Zm0,0"
                  transform="translate(-276.995 -133.699)"
                  fill="#4a4a4a"
                />
                <path
                  id="Path_12"
                  data-name="Path 12"
                  d="M223.858,213.215a.557.557,0,0,0,.557-.557V212.1h.557a.557.557,0,0,0,0-1.113h-.557v-.557a.557.557,0,1,0-1.113,0v.557h-.557a.557.557,0,1,0,0,1.113h.557v.557A.557.557,0,0,0,223.858,213.215Zm0,0"
                  transform="translate(-203.436 -192.142)"
                  fill="#4a4a4a"
                />
                <path
                  id="Path_13"
                  data-name="Path 13"
                  d="M447.3,226.432a.557.557,0,1,1-.557-.557A.557.557,0,0,1,447.3,226.432Zm0,0"
                  transform="translate(-408.972 -207.021)"
                  fill="#4a4a4a"
                />
              </g>
            </g>
          </svg>
        )
      },
      camera: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={width ? width : 48}
            height={height ? height : 48}
            viewBox="0 0 48 48">
            <defs>
              <path id="a" d="M0 0h32v26.133H0z" />
            </defs>
            <g fill="none" fillRule="evenodd">
              <path fill="#FFF" fillOpacity=".01" d="M0 0h48v48H0z" />
              <g transform="translate(8 11)">
                <mask id="b" fill="#fff">
                  <use xlinkHref="#a" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M30.933 24.024c0 .576-.466 1.043-1.042 1.043H2.11a1.042 1.042 0 0 1-1.042-1.043V7.442c0-.575.466-1.042 1.042-1.042h5.013c.426 0 .81-.26.968-.655L9.7 1.722c.157-.396.54-.655.967-.655h10.666c.426 0 .81.259.968.655l1.61 4.023c.157.396.54.655.967.655h5.013c.576 0 1.042.467 1.042 1.042v16.582zM4.8 3.734c.295 0 .533.238.533.533V4.8a.533.533 0 1 1-1.066 0v-.533c0-.295.238-.534.533-.534zm26.158 1.6H25.6c-.426 0-.81-.26-.967-.656L23.023.655A1.041 1.041 0 0 0 22.055 0H9.945c-.427 0-.81.26-.968.655l-1.61 4.023a1.041 1.041 0 0 1-.967.655V3.71c0-.576-.467-1.042-1.042-1.042H4.242c-.575 0-1.042.466-1.042 1.042v.582c0 .576-.467 1.042-1.042 1.042H1.042C.467 5.333 0 5.8 0 6.375v18.716c0 .576.467 1.042 1.042 1.042h29.916c.575 0 1.042-.466 1.042-1.042V6.375c0-.575-.467-1.042-1.042-1.042z"
                  mask="url(#b)"
                />
              </g>
              <path
                fill="#1AE5BE"
                d="M25.112 33.863c-5.573.708-10.283-4.002-9.574-9.575.482-3.8 3.55-6.868 7.35-7.35 5.573-.71 10.283 4 9.574 9.574-.482 3.8-3.55 6.868-7.35 7.35m3.265-17.082c-8.558-3.878-16.875 4.44-12.997 12.997a8.546 8.546 0 0 0 4.243 4.243c8.558 3.878 16.875-4.44 12.997-12.997a8.541 8.541 0 0 0-4.243-4.243"
              />
              <path
                fill="#1AE5BE"
                d="M24.905 30.658a5.342 5.342 0 0 1-6.164-6.163c.366-2.207 2.147-3.988 4.354-4.353a5.342 5.342 0 0 1 6.163 6.163c-.365 2.208-2.145 3.988-4.353 4.353M27.417 19.9c-6.04-3.243-12.16 2.877-8.918 8.918a5.131 5.131 0 0 0 2.084 2.083c6.041 3.244 12.16-2.876 8.917-8.917a5.131 5.131 0 0 0-2.083-2.084M35.733 21.667a1.068 1.068 0 0 1 0-2.134 1.068 1.068 0 0 1 0 2.134m1.404-2.74c-2.182-1.48-4.556.894-3.077 3.077.07.104.165.199.27.27 2.182 1.479 4.556-.895 3.077-3.078a1.025 1.025 0 0 0-.27-.27"
              />
            </g>
          </svg>
        )
      },
      roundCheckCircle: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 24}
            height={height ? height : 24}
            viewBox="0 0 24 24">
            <path fill="none" d="M0 0h24v24H0V0z" />
            <path
              fill={fill ? fill : '#436AB2'}
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.88-11.71L10 14.17l-1.88-1.88c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l2.59 2.59c.39.39 1.02.39 1.41 0L17.3 9.7c.39-.39.39-1.02 0-1.41-.39-.39-1.03-.39-1.42 0z"
            />
          </svg>
        )
      },
      hospitalization: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
            <g fill="none" fillRule="evenodd">
              <path fill="#D7E9FF" d="M8.516 3.871h2V1.548h-2zM10.613 46.645h2v-42h-2z" />
              <path
                fill="#4A4A4A"
                d="M37.873 19.544h8.507v-2.329h-8.507v2.33zm0 27.038h5.975v-25.62h-5.975v25.62zm-17.012 0h6.177v-11.14h-6.177v11.14zM11.34 5.063h25.115v41.52h-8V35.138c-.001-.615-.5-1.113-1.114-1.114h-6.785c-.615.001-1.113.5-1.114 1.114v11.443h-8.101V5.063zM3.95 46.583h5.975V15.797H3.95v30.784zM1.418 14.38h8.506v-2.33H1.418v2.33zM8.506 3.645h30.785V1.418H8.506v2.227zm29.367 12.153V5.063h1.925c.503 0 .91-.408.91-.911V.912a.912.912 0 0 0-.91-.912H8a.913.913 0 0 0-.911.912v3.24c0 .503.408.91.911.911h1.924v5.57H.911a.912.912 0 0 0-.911.911v3.342c0 .503.408.91.911.912h1.62V47.29c0 .391.318.709.71.709h41.316a.71.71 0 0 0 .709-.709v-26.33h1.62a.912.912 0 0 0 .911-.91v-3.342a.912.912 0 0 0-.91-.911h-9.014z"
              />
              <path
                fill="#1AE5BE"
                d="M14.583 21.975H16.1V20.05h-1.518v1.924zm1.822-3.342h-2.127c-.615 0-1.113.499-1.113 1.114v2.532c0 .615.498 1.113 1.113 1.113h2.127c.615 0 1.113-.498 1.114-1.113v-2.532c0-.615-.499-1.113-1.114-1.114zM14.583 29.975H16.1V28.05h-1.518v1.924zm1.822-3.342h-2.127c-.615 0-1.113.5-1.113 1.114v2.532c0 .615.498 1.113 1.113 1.113h2.127c.615 0 1.113-.498 1.114-1.113v-2.532c0-.615-.499-1.113-1.114-1.114zM23.089 21.975h1.518V20.05H23.09v1.924zm-.304 1.417h2.126c.615 0 1.114-.498 1.114-1.113v-2.532c0-.615-.499-1.113-1.114-1.114h-2.126c-.615 0-1.113.499-1.114 1.114v2.532c0 .615.499 1.113 1.114 1.113zM23.089 29.974h1.518V28.05H23.09v1.924zm-.304 1.418h2.126c.615 0 1.114-.498 1.114-1.113v-2.532c0-.615-.499-1.113-1.114-1.114h-2.126c-.615 0-1.113.5-1.114 1.114v2.532c0 .615.499 1.113 1.114 1.113zM31.696 21.975h1.52V20.05h-1.52v1.924zm-.304 1.417h2.127c.615 0 1.113-.498 1.114-1.113v-2.532c0-.615-.5-1.113-1.114-1.114h-2.127c-.615 0-1.113.499-1.114 1.114v2.532c.001.615.5 1.113 1.114 1.113zM31.696 29.974h1.52V28.05h-1.52v1.924zm-.304 1.418h2.127c.615 0 1.113-.498 1.114-1.113v-2.532c0-.615-.5-1.113-1.114-1.114h-2.127c-.615 0-1.113.5-1.114 1.114v2.532c.001.615.5 1.113 1.114 1.113zM39.899 26.734h1.519V24.81h-1.52v1.924zm-.304 1.418h2.126c.615 0 1.114-.5 1.115-1.114v-2.532c-.001-.615-.5-1.113-1.115-1.114h-2.126c-.615.001-1.113.5-1.114 1.114v2.532c0 .615.499 1.113 1.114 1.114zM6.177 26.734h1.52V24.81h-1.52v1.924zM8 23.392H5.873c-.614.001-1.113.5-1.114 1.114v2.532c.001.615.5 1.113 1.114 1.114H8c.615 0 1.113-.5 1.114-1.114v-2.532c0-.615-.5-1.113-1.114-1.114zM27.747 11.848h-2.025c-.615 0-1.114.5-1.114 1.114v2.127h-1.114v-2.127c-.001-.615-.5-1.113-1.114-1.114h-2.228v-1.013h2.228c.615 0 1.113-.499 1.114-1.113V7.696h1.114v2.026c0 .614.499 1.113 1.114 1.113h2.025v1.013zm.304-2.43h-2.026V7.393c0-.615-.499-1.114-1.114-1.115H23.19c-.615.001-1.113.5-1.114 1.115v2.025h-2.228c-.615 0-1.113.499-1.114 1.114v1.62c0 .615.5 1.113 1.114 1.114h2.228v2.126c0 .615.499 1.113 1.114 1.114h1.721c.615 0 1.114-.499 1.114-1.114v-2.126h2.026c.615 0 1.113-.5 1.113-1.114v-1.62c0-.615-.498-1.114-1.113-1.114z"
              />
            </g>
          </svg>
        )
      },
      bulletPoint: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
            <g id="Group_2084" data-name="Group 2084" transform="translate(-24 -378)">
              <g
                id="Ellipse_287"
                data-name="Ellipse 287"
                transform="translate(24 378)"
                fill="#f5f5f5"
                stroke="#4a4a4a"
                strokeWidth="1">
                <circle cx="6" cy="6" r="6" stroke="none" />
                <circle cx="6" cy="6" r="5.5" fill="none" />
              </g>
              <circle
                id="Ellipse_288"
                data-name="Ellipse 288"
                cx="3"
                cy="3"
                r="3"
                transform="translate(27 381)"
                fill="#4a4a4a"
              />
            </g>
          </svg>
        )
      },
      policyDocumentPhoneTap: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="39.88" height="39.88" viewBox="0 0 39.88 39.88">
            <g id="code" transform="translate(0)">
              <path
                id="Path_41"
                data-name="Path 41"
                d="M243.313,96v6.625a1.271,1.271,0,0,1,.547-.128,1.35,1.35,0,0,1,1.32,1.378,1.411,1.411,0,0,1-.386.975l.622-.65a1.294,1.294,0,0,1,.933-.4c.028,0,.055.007.083.009l-.007-.007v-4.55h11.2v7.8h-7.467l-6.844,7.147v.65h.622l6.474-4.916a1.364,1.364,0,0,1,.828-.281,1.441,1.441,0,0,1,1.409,1.471v.357a1.49,1.49,0,0,1-.607,1.209l-6.975,5.043a3.66,3.66,0,0,1-1.1.543l-.652.194v2.228h17.422V96Zm0,0"
                transform="translate(-223.344 -88.533)"
                fill="#fff"
              />
              <path
                id="Path_42"
                data-name="Path 42"
                d="M388.557,32.622a.622.622,0,1,1-.622-.622A.622.622,0,0,1,388.557,32.622Zm0,0"
                transform="translate(-356.351 -29.511)"
                fill="#4a4a4a"
              />
              <path
                id="Path_43"
                data-name="Path 43"
                d="M308.557,32.622a.622.622,0,1,1-.622-.622A.622.622,0,0,1,308.557,32.622Zm0,0"
                transform="translate(-282.746 -29.511)"
                fill="#4a4a4a"
              />
              <path
                id="Path_44"
                data-name="Path 44"
                d="M387.313,256h3.733v1.244h-3.733Zm0,0"
                transform="translate(-356.144 -235.536)"
                fill="#4a4a4a"
              />
              <path
                id="Path_45"
                data-name="Path 45"
                d="M387.313,288h3.733v1.244h-3.733Zm0,0"
                transform="translate(-356.144 -264.978)"
                fill="#4a4a4a"
              />
              <path
                id="Path_46"
                data-name="Path 46"
                d="M387.313,320h3.733v1.244h-3.733Zm0,0"
                transform="translate(-356.144 -294.42)"
                fill="#4a4a4a"
              />
              <path
                id="Path_47"
                data-name="Path 47"
                d="M307.313,352h9.956v1.244h-9.956Zm0,0"
                transform="translate(-282.366 -323.861)"
                fill="#4a4a4a"
              />
              <path
                id="Path_48"
                data-name="Path 48"
                d="M36.686,0H20.073a3.2,3.2,0,0,0-3.195,3.195v9.592c-.026,0-.051-.008-.077-.008a1.982,1.982,0,0,0-1.41.584l-4.651,4.651A4.485,4.485,0,0,0,9.6,19.948l-.732,2.562a3.21,3.21,0,0,1-.813,1.382l-1.4,1.4L5.377,24.016,0,29.392,10.488,39.88,15.865,34.5l-1.278-1.278,1.4-1.4a3.183,3.183,0,0,1,.89-.621v5.217a3.2,3.2,0,0,0,3.195,3.195H36.686a3.2,3.2,0,0,0,3.195-3.195V3.195A3.2,3.2,0,0,0,36.686,0ZM20.073,1.278H36.686A1.919,1.919,0,0,1,38.6,3.195v.639H33.226L31.948,5.112H24.81L23.532,3.834H18.156V3.195A1.919,1.919,0,0,1,20.073,1.278ZM18.156,5.112H23L24.281,6.39h8.2l1.278-1.278H38.6V33.226H18.156V30.787l2.122-.607a4.457,4.457,0,0,0,1.318-.623L28.758,24.6a2.085,2.085,0,0,0,.9-1.715v-.351a2.085,2.085,0,0,0-3.312-1.686L21.6,24.3l5.13-5.13h8.042V10.223H21.99v4.562c-.034.01-.068.019-.1.031a1.98,1.98,0,0,0-3.265-.845,1.991,1.991,0,0,0-.467-.652V5.112ZM28.3,12.779a1.982,1.982,0,0,0-1.41.584l-2.52,2.52a2,2,0,0,0-1.1-1.049V11.5H33.491v6.39H28l1.707-1.707a1.994,1.994,0,0,0-1.41-3.4ZM1.807,29.392,3.46,27.74l8.681,8.681-1.652,1.652Zm11.237,6.125L4.363,26.836l1.013-1.013L14.057,34.5Zm2.04-4.6-1.4,1.4L7.558,26.2l1.4-1.4A4.485,4.485,0,0,0,10.1,22.862L10.83,20.3a3.21,3.21,0,0,1,.813-1.382l4.651-4.651a.717.717,0,0,1,1.014,1.013l-4.076,4.076.9.9,5.354-5.354A.717.717,0,0,1,20.5,15.919l-5.354,5.354.9.9,5.993-5.993A.717.717,0,0,1,23.058,17.2L17.065,23.19l.9.9L27.8,14.267a.717.717,0,0,1,1.013,1.013L18.795,25.294v1.542H20.28L27.1,21.879a.8.8,0,0,1,.475-.154.808.808,0,0,1,.808.808v.351a.809.809,0,0,1-.348.664l-7.163,4.959a3.192,3.192,0,0,1-.941.446l-2.909.831a4.48,4.48,0,0,0-1.935,1.138Zm21.6,7.416H20.073a1.919,1.919,0,0,1-1.917-1.917V34.5H38.6v1.917A1.919,1.919,0,0,1,36.686,38.337Zm0,0"
                transform="translate(0)"
                fill="#4a4a4a"
              />
              <path
                id="Path_49"
                data-name="Path 49"
                d="M315.313,448h6.222v1.245h-6.222Zm0,0"
                transform="translate(-290.003 -412.111)"
                fill="#1ae5be"
              />
              <path
                id="Path_50"
                data-name="Path 50"
                d="M339.313,32H341.8v1.244h-2.489Zm0,0"
                transform="translate(-312.163 -29.511)"
                fill="#4a4a4a"
              />
            </g>
          </svg>
        )
      },
      ambulance: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="48"
            height="49"
            viewBox="0 0 48 49">
            <defs>
              <path id="a" d="M0 0h1.391v3.38H0z" />
              <path id="c" d="M.024.016h10.34v10.419H.024z" />
            </defs>
            <g fill="none" fillRule="evenodd">
              <path fill="#D7E9FF" d="M2.715 12.65h28.589V11.61H1.69a.3.3 0 0 0-.299.3V35.26h1.617l-.293-22.61z" />
              <path
                fill="#FFF"
                d="M43.264 16.994c-.124-.383-.558-.6-.97-.485-.41.115-.645.517-.522.9l4.005 12.46c.12.385.553.605.966.493.413-.112.65-.513.53-.897a.145.145 0 0 0-.003-.01l-4.006-12.461z"
              />
              <path
                fill="#1AE5BE"
                d="M32.56 11.596a.692.692 0 0 0 .818-.536l.882-4.348H36l.883 4.335c.075.37.441.61.818.535a.682.682 0 0 0 .546-.802l-.93-4.57c-.103-.5-.55-.861-1.072-.862h-2.23a1.09 1.09 0 0 0-1.071.862l-.93 4.584c-.075.37.17.728.546.802"
              />
              <g transform="translate(34.087 .478)">
                <mask id="b" fill="#fff">
                  <use xlinkHref="#a" />
                </mask>
                <path
                  fill="#1AE5BE"
                  d="M1.391 2.684V.696A.696.696 0 0 0 0 .696v1.988a.696.696 0 1 0 1.391 0"
                  mask="url(#b)"
                />
              </g>
              <path
                fill="#1AE5BE"
                d="M38.26 6.74c0 .383.321.695.717.695h2.046a.706.706 0 0 0 .716-.696.706.706 0 0 0-.716-.695h-2.046a.706.706 0 0 0-.716.695M31.284 7.435A.706.706 0 0 0 32 6.739a.706.706 0 0 0-.716-.695h-2.046a.706.706 0 0 0-.716.695c0 .384.32.696.716.696h2.046zM32.004 4.652a.692.692 0 0 0 .489-1.181l-1.398-1.399a.692.692 0 0 0-.98.98l1.4 1.397a.69.69 0 0 0 .489.203M39.166 2.072l-1.398 1.399a.692.692 0 1 0 .979.978l1.398-1.398a.692.692 0 1 0-.979-.979zM12.536 27.853h2.41a.703.703 0 0 0 .703-.703v-2.31h.803v2.31c0 .388.314.703.703.703h2.309v.803h-2.31a.703.703 0 0 0-.702.703v2.41h-.803v-2.41a.703.703 0 0 0-.703-.703h-2.41v-.803zm-.703 2.208h2.41v2.41c0 .388.315.703.703.703h2.209a.703.703 0 0 0 .702-.703v-2.41h2.31a.703.703 0 0 0 .703-.702v-2.21a.703.703 0 0 0-.703-.702h-2.31v-2.31a.703.703 0 0 0-.702-.702h-2.21a.703.703 0 0 0-.702.703v2.309h-2.41a.703.703 0 0 0-.703.703v2.209c0 .388.315.702.703.702z"
              />
              <path
                fill="#4A4A4A"
                d="M31.781 35.593H1.417V11.938c0-.168.136-.304.304-.304h30.06v23.959zm1.417-23.959h10.88c.167 0 .303.136.303.304v2.132c0 1.616-.832 2.436-2.474 2.436h-8.709v-4.872zm9.9 15.012h-9.9v-8.724h8.71c2.435 0 3.89-1.44 3.89-3.852v-2.132a1.722 1.722 0 0 0-1.72-1.72H1.72c-.95 0-1.719.77-1.72 1.719v24.276c0 .06.008.122.024.181v3.643c0 2.353 1.541 4.267 3.436 4.267h2.625a.708.708 0 1 0 0-1.416H3.46c-1.094 0-2.019-1.306-2.019-2.851v-3.028h30.365v5.88h-16.81a.708.708 0 1 0 0 1.415h19.815a.708.708 0 1 0 0-1.416h-1.588V28.062h9.874a3.489 3.489 0 0 1 3.486 3.483v7.86c0 1.606-.742 3.483-2.834 3.483a.708.708 0 1 0 0 1.416c2.543 0 4.251-1.969 4.251-4.9v-7.859a4.907 4.907 0 0 0-4.903-4.9z"
              />
              <g transform="translate(34.087 38.044)">
                <mask id="d" fill="#fff">
                  <use xlinkHref="#c" />
                </mask>
                <path
                  fill="#4A4A4A"
                  d="M5.194 1.426c2.071.002 3.75 1.697 3.752 3.788l-.001.09C8.895 7.396 7.177 9.05 5.105 9 3.101 8.953 1.49 7.323 1.443 5.3v-.086c.002-2.091 1.68-3.786 3.751-3.788M1.58 8.946a5.135 5.135 0 0 0 7.31-.08 5.247 5.247 0 0 0 1.474-3.525l.001-.127C10.352 2.331 8.027.004 5.171.016 2.334.03.037 2.35.024 5.214a5.214 5.214 0 0 0 1.554 3.732"
                  mask="url(#d)"
                />
              </g>
              <path
                fill="#4A4A4A"
                d="M14.567 43.351a3.787 3.787 0 0 1-7.57-.003l-.001-.086a3.773 3.773 0 0 1 1.014-2.578l.016-.017a3.782 3.782 0 0 1 5.501-.011l.013.012.01.01c.655.7 1.02 1.625 1.018 2.584v.09m-.007-3.687a5.214 5.214 0 0 0-7.575.018l-.017.018a5.199 5.199 0 0 0-1.403 3.683 5.218 5.218 0 1 0 9.016-3.697l-.021-.022M17.004 15.055H27.5c.168 0 .303.13.303.29v5.048c0 .161-.135.292-.303.292H17.004v-5.63zm-1.413 5.63H5.194a.297.297 0 0 1-.303-.292v-5.047c0-.161.136-.291.303-.291h10.397v5.63zm13.626-.292v-5.047c0-.911-.768-1.65-1.716-1.65H5.194c-.947 0-1.715.739-1.716 1.65v5.047c.001.911.769 1.65 1.716 1.65h22.307c.948 0 1.715-.739 1.716-1.65z"
              />
            </g>
          </svg>
        )
      },
      location: () => {
        return (
          <svg
            id="outline-location_on-24px"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18">
            <path id="Path_494" data-name="Path 494" d="M0,0H18V18H0Z" fill="none" />
            <path
              id="Path_495"
              data-name="Path 495"
              d="M9.919,2A5.039,5.039,0,0,0,5,7.157c0,3.868,4.919,9.578,4.919,9.578s4.919-5.71,4.919-9.578A5.039,5.039,0,0,0,9.919,2ZM6.406,7.157A3.6,3.6,0,0,1,9.919,3.474a3.6,3.6,0,0,1,3.514,3.684c0,2.122-2.024,5.3-3.514,7.279C8.458,12.47,6.406,9.257,6.406,7.157Z"
              transform="translate(-0.919 -0.368)"
              fill="#6200ee"
            />
            <circle
              id="Ellipse_98"
              data-name="Ellipse 98"
              cx="2.04"
              cy="2.04"
              r="2.04"
              transform="translate(6.96 4.762)"
              fill="#6200ee"
            />
          </svg>
        )
      },
      mobileTap: () => {
        return (
          <svg id="code" xmlns="http://www.w3.org/2000/svg" width="39.881" height="39.88" viewBox="0 0 39.881 39.88">
            <path
              id="Path_41"
              data-name="Path 41"
              d="M243.313,96v6.625a1.271,1.271,0,0,1,.547-.128,1.35,1.35,0,0,1,1.32,1.378,1.411,1.411,0,0,1-.386.975l.622-.65a1.294,1.294,0,0,1,.933-.4c.028,0,.055.007.083.009l-.007-.007v-4.55h11.2v7.8h-7.467l-6.844,7.147v.65h.622l6.474-4.916a1.364,1.364,0,0,1,.828-.281,1.441,1.441,0,0,1,1.409,1.471v.357a1.49,1.49,0,0,1-.607,1.209l-6.975,5.043a3.66,3.66,0,0,1-1.1.543l-.652.194v2.228h17.422V96Zm0,0"
              transform="translate(-223.344 -88.533)"
              fill="#f0bc5e"
            />
            <path
              id="Path_42"
              data-name="Path 42"
              d="M388.557,32.622a.622.622,0,1,1-.622-.622A.622.622,0,0,1,388.557,32.622Zm0,0"
              transform="translate(-356.351 -29.511)"
            />
            <path
              id="Path_43"
              data-name="Path 43"
              d="M308.557,32.622a.622.622,0,1,1-.622-.622A.622.622,0,0,1,308.557,32.622Zm0,0"
              transform="translate(-282.746 -29.511)"
            />
            <path
              id="Path_44"
              data-name="Path 44"
              d="M387.313,256h3.733v1.244h-3.733Zm0,0"
              transform="translate(-356.144 -235.536)"
            />
            <path
              id="Path_45"
              data-name="Path 45"
              d="M387.313,288h3.733v1.244h-3.733Zm0,0"
              transform="translate(-356.144 -264.978)"
            />
            <path
              id="Path_46"
              data-name="Path 46"
              d="M387.313,320h3.733v1.244h-3.733Zm0,0"
              transform="translate(-356.144 -294.42)"
            />
            <path
              id="Path_47"
              data-name="Path 47"
              d="M307.313,352h9.956v1.244h-9.956Zm0,0"
              transform="translate(-282.366 -323.861)"
            />
            <path
              id="Path_48"
              data-name="Path 48"
              d="M36.686,0H20.073a3.2,3.2,0,0,0-3.195,3.195v9.592c-.026,0-.051-.008-.077-.008a1.982,1.982,0,0,0-1.41.584l-4.651,4.651A4.485,4.485,0,0,0,9.6,19.948l-.732,2.562a3.21,3.21,0,0,1-.813,1.382l-1.4,1.4L5.377,24.016,0,29.392,10.488,39.88,15.865,34.5l-1.278-1.278,1.4-1.4a3.183,3.183,0,0,1,.89-.621v5.217a3.2,3.2,0,0,0,3.195,3.195H36.686a3.2,3.2,0,0,0,3.195-3.195V3.195A3.2,3.2,0,0,0,36.686,0ZM20.073,1.278H36.686A1.919,1.919,0,0,1,38.6,3.195v.639H33.226L31.948,5.112H24.81L23.532,3.834H18.156V3.195A1.919,1.919,0,0,1,20.073,1.278ZM18.156,5.112H23L24.281,6.39h8.2l1.278-1.278H38.6V33.226H18.156V30.787l2.122-.607a4.457,4.457,0,0,0,1.318-.623L28.758,24.6a2.085,2.085,0,0,0,.9-1.715v-.351a2.085,2.085,0,0,0-3.312-1.686L21.6,24.3l5.13-5.13h8.042V10.223H21.99v4.562c-.034.01-.068.019-.1.031a1.98,1.98,0,0,0-3.265-.845,1.991,1.991,0,0,0-.467-.652V5.112ZM28.3,12.779a1.982,1.982,0,0,0-1.41.584l-2.52,2.52a2,2,0,0,0-1.1-1.049V11.5H33.491v6.39H28l1.707-1.707a1.994,1.994,0,0,0-1.41-3.4ZM1.807,29.392,3.46,27.74l8.681,8.681-1.652,1.652Zm11.237,6.125L4.363,26.836l1.013-1.013L14.057,34.5Zm2.04-4.6-1.4,1.4L7.558,26.2l1.4-1.4A4.485,4.485,0,0,0,10.1,22.862L10.83,20.3a3.21,3.21,0,0,1,.813-1.382l4.651-4.651a.717.717,0,0,1,1.014,1.013l-4.076,4.076.9.9,5.354-5.354A.717.717,0,0,1,20.5,15.919l-5.354,5.354.9.9,5.993-5.993A.717.717,0,0,1,23.058,17.2L17.065,23.19l.9.9L27.8,14.267a.717.717,0,0,1,1.013,1.013L18.795,25.294v1.542H20.28L27.1,21.879a.8.8,0,0,1,.475-.154.808.808,0,0,1,.808.808v.351a.809.809,0,0,1-.348.664l-7.163,4.959a3.192,3.192,0,0,1-.941.446l-2.909.831a4.48,4.48,0,0,0-1.935,1.138Zm21.6,7.416H20.073a1.919,1.919,0,0,1-1.917-1.917V34.5H38.6v1.917A1.919,1.919,0,0,1,36.686,38.337Zm0,0"
              transform="translate(0)"
            />
            <path
              id="Path_49"
              data-name="Path 49"
              d="M315.313,448h6.222v1.245h-6.222Zm0,0"
              transform="translate(-290.003 -412.111)"
            />
            <path
              id="Path_50"
              data-name="Path 50"
              d="M339.313,32H341.8v1.244h-2.489Zm0,0"
              transform="translate(-312.163 -29.511)"
            />
          </svg>
        )
      },
      agreementWrite: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="39.175" height="39.175" viewBox="0 0 39.175 39.175">
            <g id="Group_1897" data-name="Group 1897" transform="translate(0 0)">
              <path
                id="Path_5"
                data-name="Path 5"
                d="M39.174,19.253a2.825,2.825,0,0,0-2.83-2.825h-.08a2.743,2.743,0,0,0-1.955.81L27.8,23.748V0H6.688L0,6.689V39.175H27.8V31.855l8.214-8.214.147.147a1.657,1.657,0,0,1,0,2.343l-4.57,4.57a2.157,2.157,0,0,0,0,3.051l.817.817.893-.893-.817-.817a.894.894,0,0,1,0-1.264l4.57-4.57a2.92,2.92,0,0,0,0-4.13l-.147-.147,1.427-1.427a2.872,2.872,0,0,0,.839-2.067ZM6.318,2.157V6.319H2.157ZM26.537,37.911H1.263V7.582H7.582V1.264H26.537V25.012l-6.25,6.25-1.177,4.122h-.919a.177.177,0,0,1-.159-.1l-1.022-2.044.546-.874a5.037,5.037,0,0,0,.766-2.671,1.9,1.9,0,1,0-3.791,0v.224a5.063,5.063,0,0,0,.532,2.253l.5,1L14.234,35.3a.177.177,0,0,1-.15.083h-.815a.177.177,0,0,1-.172-.135l-.326-1.3a1.441,1.441,0,0,0-2.8,0l-.326,1.3a.177.177,0,0,1-.172.134h-1.9v1.264h1.9a1.438,1.438,0,0,0,1.4-1.091l.326-1.3a.184.184,0,0,1,.344,0l.326,1.3a1.437,1.437,0,0,0,1.4,1.091h.815a1.431,1.431,0,0,0,1.222-.677l.921-1.473.677,1.353a1.434,1.434,0,0,0,1.289.8h1.484l4.665-1.333,2.2-2.2ZM21.163,32.8l1.64,1.64-2.3.657Zm-4.677-1.1-.138.22-.154-.309a3.793,3.793,0,0,1-.4-1.688V29.7a.632.632,0,1,1,1.264,0,3.768,3.768,0,0,1-.573,2Zm7.524,2.161-2.266-2.266L32.855,20.481l2.266,2.266ZM37.442,20.427l-1.427,1.427-2.266-2.266L35.2,18.132a1.488,1.488,0,0,1,1.061-.44h.08a1.558,1.558,0,0,1,1.11.458,1.632,1.632,0,0,1-.013,2.277Zm0,0"
                transform="translate(0.001 0)"
              />
              <g id="Group_225" data-name="Group 225" transform="translate(2.136 3.244)">
                <path
                  id="Path_6"
                  data-name="Path 6"
                  d="M64,448h1.266v1.266H64Zm0,0"
                  transform="translate(-61.468 -415.085)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_7"
                  data-name="Path 7"
                  d="M304,32h1.266v1.266H304Zm0,0"
                  transform="translate(-282.478 -32)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_8"
                  data-name="Path 8"
                  d="M192,32h7.6v1.266H192Zm0,0"
                  transform="translate(-179.34 -32)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_9"
                  data-name="Path 9"
                  d="M304,64h1.266v1.266H304Zm0,0"
                  transform="translate(-282.478 -61.468)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_10"
                  data-name="Path 10"
                  d="M192,64h7.6v1.266H192Zm0,0"
                  transform="translate(-179.34 -61.468)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_11"
                  data-name="Path 11"
                  d="M304,96h1.266v1.266H304Zm0,0"
                  transform="translate(-282.478 -90.936)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_12"
                  data-name="Path 12"
                  d="M192,96h7.6v1.266H192Zm0,0"
                  transform="translate(-179.34 -90.936)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_13"
                  data-name="Path 13"
                  d="M32,128H54.788v1.266H32Zm0,0"
                  transform="translate(-32 -120.404)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_14"
                  data-name="Path 14"
                  d="M32,160H54.788v1.266H32Zm0,0"
                  transform="translate(-32 -149.872)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_15"
                  data-name="Path 15"
                  d="M32,192H54.788v1.266H32Zm0,0"
                  transform="translate(-32 -179.34)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_16"
                  data-name="Path 16"
                  d="M144,232h1.266v1.266H144Zm0,0"
                  transform="translate(-135.138 -216.175)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_17"
                  data-name="Path 17"
                  d="M176,232h11.394v1.266H176Zm0,0"
                  transform="translate(-164.606 -216.175)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_18"
                  data-name="Path 18"
                  d="M144,264h13.926v1.266H144Zm0,0"
                  transform="translate(-135.138 -245.644)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_19"
                  data-name="Path 19"
                  d="M144,296h13.926v1.266H144Zm0,0"
                  transform="translate(-135.138 -275.112)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_20"
                  data-name="Path 20"
                  d="M32,336h8.862v1.266H32Zm0,0"
                  transform="translate(-32 -311.947)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_21"
                  data-name="Path 21"
                  d="M32,368h8.862v1.266H32Zm0,0"
                  transform="translate(-32 -341.415)"
                  fill="#f0bc5e"
                />
              </g>
            </g>
          </svg>
        )
      },
      agreementSend: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="37.905" height="39.289" viewBox="0 0 37.905 39.289">
            <g id="Group_1899" data-name="Group 1899" transform="translate(0 0)">
              <path
                id="Path_5"
                data-name="Path 5"
                d="M27.881,31.38c0-7.987,0-31.379,0-31.379H6.707L0,6.708v32.58H27.881V31.947C27.881,29.969,27.881,39.366,27.881,31.38ZM6.336,2.164V6.337H2.163ZM26.614,38.021H1.267V7.6H7.6V1.268h19.01V38.021Z"
                transform="translate(10.024 0)"
                fill="#4a4a4a"
              />
              <g id="Group_225" data-name="Group 225" transform="translate(12.165 3.253)">
                <path
                  id="Path_6"
                  data-name="Path 6"
                  d="M64,448h1.27v1.27H64Zm0,0"
                  transform="translate(-61.461 -414.99)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_7"
                  data-name="Path 7"
                  d="M304,32h1.27v1.27H304Zm0,0"
                  transform="translate(-282.416 -32)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_8"
                  data-name="Path 8"
                  d="M192,32h7.618v1.27H192Zm0,0"
                  transform="translate(-179.304 -32)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_9"
                  data-name="Path 9"
                  d="M304,64h1.27v1.27H304Zm0,0"
                  transform="translate(-282.416 -61.461)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_10"
                  data-name="Path 10"
                  d="M192,64h7.618v1.27H192Zm0,0"
                  transform="translate(-179.304 -61.461)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_11"
                  data-name="Path 11"
                  d="M304,96h1.27v1.27H304Zm0,0"
                  transform="translate(-282.416 -90.922)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_12"
                  data-name="Path 12"
                  d="M192,96h7.618v1.27H192Zm0,0"
                  transform="translate(-179.304 -90.922)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_13"
                  data-name="Path 13"
                  d="M32,128H54.854v1.27H32Zm0,0"
                  transform="translate(-32 -120.382)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_14"
                  data-name="Path 14"
                  d="M32,160H54.854v1.27H32Zm0,0"
                  transform="translate(-32 -149.843)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_15"
                  data-name="Path 15"
                  d="M32,192H54.854v1.27H32Zm0,0"
                  transform="translate(-32 -179.304)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_16"
                  data-name="Path 16"
                  d="M144,232h1.27v1.27H144Zm0,0"
                  transform="translate(-135.113 -216.13)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_17"
                  data-name="Path 17"
                  d="M176,232h11.427v1.27H176Zm0,0"
                  transform="translate(-164.573 -216.13)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_18"
                  data-name="Path 18"
                  d="M144,264h13.966v1.27H144Zm0,0"
                  transform="translate(-135.113 -245.59)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_19"
                  data-name="Path 19"
                  d="M144,296h13.966v1.27H144Zm0,0"
                  transform="translate(-135.113 -275.051)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_20"
                  data-name="Path 20"
                  d="M32,336h8.887v1.27H32Zm0,0"
                  transform="translate(-32 -311.877)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_21"
                  data-name="Path 21"
                  d="M32,368h8.887v1.27H32Zm0,0"
                  transform="translate(-32 -341.338)"
                  fill="#f0bc5e"
                />
              </g>
              <path
                id="Path_479"
                data-name="Path 479"
                d="M20.62,40.817H19.7a.178.178,0,0,1-.159-.1l-1.025-2.05.548-.877a5.051,5.051,0,0,0,.768-2.679,1.9,1.9,0,1,0-3.8,0v.224a5.078,5.078,0,0,0,.533,2.26l.5,1-1.334,2.134a.178.178,0,0,1-.151.083h-.817a.177.177,0,0,1-.172-.135l-.327-1.306a1.445,1.445,0,0,0-2.8,0l-.327,1.306a.178.178,0,0,1-.172.134h-1.9v1.267h1.9a1.443,1.443,0,0,0,1.4-1.094l.327-1.306a.185.185,0,0,1,.345,0l.327,1.306a1.441,1.441,0,0,0,1.4,1.094h.817a1.435,1.435,0,0,0,1.226-.679l.923-1.477.679,1.357a1.438,1.438,0,0,0,1.293.8Zm-2.632-3.7-.138.221-.155-.309a3.8,3.8,0,0,1-.4-1.693v-.224a.634.634,0,0,1,1.267,0,3.779,3.779,0,0,1-.575,2.006Z"
                transform="translate(14.447 -5.331)"
                fill="#4a4a4a"
              />
              <rect
                id="Rectangle_1179"
                data-name="Rectangle 1179"
                width="8.395"
                height="1.259"
                rx="0.63"
                transform="translate(0 6.397)"
                fill="#4a4a4a"
              />
              <rect
                id="Rectangle_1180"
                data-name="Rectangle 1180"
                width="5.876"
                height="1.259"
                rx="0.63"
                transform="translate(2.518 8.915)"
                fill="#4a4a4a"
              />
              <rect
                id="Rectangle_1181"
                data-name="Rectangle 1181"
                width="2.518"
                height="1.259"
                rx="0.63"
                transform="translate(5.876 11.434)"
                fill="#4a4a4a"
              />
            </g>
          </svg>
        )
      },
      approval: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="39.883" height="39.883" viewBox="0 0 39.883 39.883">
            <g id="approval" transform="translate(0 0)">
              <path
                id="Path_22"
                data-name="Path 22"
                d="M295.076,110.152a7.076,7.076,0,1,1,7.076-7.076A7.084,7.084,0,0,1,295.076,110.152Zm0,0"
                transform="translate(-264.842 -88.281)"
                fill="#f0bc5e"
              />
              <path
                id="Path_23"
                data-name="Path 23"
                d="M369.287,448.643a.643.643,0,1,1-.643-.643A.643.643,0,0,1,369.287,448.643Zm0,0"
                transform="translate(-338.409 -411.976)"
                fill="#4a4a4a"
              />
              <path
                id="Path_24"
                data-name="Path 24"
                d="M42.292,297.006H32V288H42.292Zm0,0"
                transform="translate(-29.427 -264.842)"
                fill="#fff"
              />
              <path
                id="Path_25"
                data-name="Path 25"
                d="M42.292,145.006H32V136H42.292Zm0,0"
                transform="translate(-29.427 -125.064)"
                fill="#fff"
              />
              <path
                id="Path_26"
                data-name="Path 26"
                d="M39.883,14.8a9.653,9.653,0,0,0-9.006-9.617V0H0V34.737H27.018v1.93a3.216,3.216,0,1,0,6.433,0V27.017H32.164V24.25A9.666,9.666,0,0,0,39.883,14.8Zm-1.287,0a8.363,8.363,0,1,1-8.363-8.363A8.372,8.372,0,0,1,38.6,14.8ZM27.018,27.017V33.45H1.287V1.286h28.3V5.179A9.643,9.643,0,0,0,28.3,24.25v2.767Zm5.146,9.649a1.93,1.93,0,1,1-3.86,0V28.3h3.86Zm-1.287-9.649H29.591V24.412c.214.014.426.033.643.033s.43-.019.643-.033Zm0,0"
                transform="translate(0 0)"
                fill="#4a4a4a"
              />
              <path
                id="Path_27"
                data-name="Path 27"
                d="M340.272,145.324l-.714,1.07,2.537,1.69L345.637,141l-1.152-.575-2.89,5.781Zm0,0"
                transform="translate(-312.254 -129.134)"
                fill="#4a4a4a"
              />
              <path
                id="Path_28"
                data-name="Path 28"
                d="M68.5,267.755l-1.25-1.25-.91.91,2.609,2.609,3.585-8.606-1.187-.5Zm0,0"
                transform="translate(-61.009 -239.942)"
                fill="#4a4a4a"
              />
              <path
                id="Path_29"
                data-name="Path 29"
                d="M68.5,115.755l-1.25-1.25-.91.91,2.609,2.609,3.585-8.606-1.187-.5Zm0,0"
                transform="translate(-61.009 -100.164)"
                fill="#4a4a4a"
              />
              <path
                id="Path_30"
                data-name="Path 30"
                d="M224,64h1.287v1.287H224Zm0,0"
                transform="translate(-205.988 -58.854)"
                fill="#4a4a4a"
              />
              <path
                id="Path_31"
                data-name="Path 31"
                d="M32,64H46.152v1.287H32Zm0,0"
                transform="translate(-29.427 -58.854)"
                fill="#4a4a4a"
              />
              <path
                id="Path_32"
                data-name="Path 32"
                d="M176,288h7.719v1.287H176Zm0,0"
                transform="translate(-161.848 -264.842)"
                fill="#4a4a4a"
              />
              <path
                id="Path_33"
                data-name="Path 33"
                d="M176,320h7.719v1.287H176Zm0,0"
                transform="translate(-161.848 -294.269)"
                fill="#4a4a4a"
              />
              <path
                id="Path_34"
                data-name="Path 34"
                d="M176,352h7.719v1.287H176Zm0,0"
                transform="translate(-161.848 -323.696)"
                fill="#4a4a4a"
              />
              <path
                id="Path_35"
                data-name="Path 35"
                d="M176,384h7.719v1.287H176Zm0,0"
                transform="translate(-161.848 -353.123)"
                fill="#4a4a4a"
              />
              <path
                id="Path_36"
                data-name="Path 36"
                d="M176,136h5.146v1.287H176Zm0,0"
                transform="translate(-161.848 -125.064)"
                fill="#4a4a4a"
              />
              <path
                id="Path_37"
                data-name="Path 37"
                d="M176,168h5.146v1.287H176Zm0,0"
                transform="translate(-161.848 -154.491)"
                fill="#4a4a4a"
              />
              <path
                id="Path_38"
                data-name="Path 38"
                d="M176,200h5.146v1.287H176Zm0,0"
                transform="translate(-161.848 -183.918)"
                fill="#4a4a4a"
              />
              <path
                id="Path_39"
                data-name="Path 39"
                d="M176,232h5.146v1.287H176Zm0,0"
                transform="translate(-161.848 -213.345)"
                fill="#4a4a4a"
              />
              <path
                id="Path_40"
                data-name="Path 40"
                d="M32,32H48.725v1.287H32Zm0,0"
                transform="translate(-29.427 -29.427)"
                fill="#4a4a4a"
              />
            </g>
          </svg>
        )
      },
      daycare: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="48"
            height="51"
            viewBox="0 0 48 51">
            <defs>
              <path id="a" d="M0 0h6.386v6.386H0z" />
              <path id="c" d="M0 0h6.386v6.386H0z" />
            </defs>
            <g fill="none" fillRule="evenodd">
              <path
                fill="#D7E9FF"
                d="M25.437 8.408H21.18c-2.148 0-3.747 1.086-4.527 2.103-.14.183-.368.675-.586 1.196h4.257c.218-.521.446-1.013.587-1.196.78-1.017 2.378-2.103 4.526-2.103"
              />
              <g transform="translate(7.663 44.065)">
                <mask id="b" fill="#fff">
                  <use xlinkHref="#a" />
                </mask>
                <path
                  fill="#4A4A4A"
                  d="M3.193 4.895a1.703 1.703 0 1 1 0-3.406 1.703 1.703 0 0 1 0 3.406m0-4.895a3.193 3.193 0 1 0 0 6.386 3.193 3.193 0 0 0 0-6.386"
                  mask="url(#b)"
                />
              </g>
              <g transform="translate(33.951 44.065)">
                <mask id="d" fill="#fff">
                  <use xlinkHref="#c" />
                </mask>
                <path
                  fill="#4A4A4A"
                  d="M3.193 4.895a1.703 1.703 0 1 1 0-3.406 1.703 1.703 0 0 1 0 3.406m0-4.895a3.193 3.193 0 1 0 0 6.386 3.193 3.193 0 0 0 0-6.386"
                  mask="url(#d)"
                />
              </g>
              <path
                fill="#1AE5BE"
                d="M26.927 8.408a.745.745 0 0 0 .745-.745V4.789c0-.646-.525-1.17-1.17-1.17h-1.704V.745a.745.745 0 1 0-1.49 0v2.874h-1.703c-.646 0-1.17.524-1.17 1.17v2.874a.745.745 0 1 0 1.49 0V5.109h4.257v2.554c0 .411.333.745.745.745"
              />
              <path
                fill="#4A4A4A"
                d="M1.49 30.971h45.02v-1.064H1.49v1.064zm1.49-2.554h6.067V26.5H2.98v1.916zm43.85 0H10.536v-2.235c-.001-.646-.525-1.17-1.171-1.17H2.66c-.646 0-1.17.524-1.171 1.17v2.235h-.32c-.646 0-1.17.524-1.17 1.17v1.703c0 .647.524 1.17 1.17 1.171h45.66c.646 0 1.17-.524 1.17-1.17v-1.703c0-.647-.524-1.17-1.17-1.171z"
              />
              <path
                fill="#4A4A4A"
                d="M11.6 41.614h24.8V40.55H11.6v1.064zm25.118-2.554h-5.321v-7.344a.745.745 0 1 0-1.49 0v7.344H18.093v-7.344a.745.745 0 1 0-1.49 0v7.344h-5.321c-.647 0-1.17.524-1.171 1.17v6.386a.745.745 0 1 0 1.49 0v-3.512h24.798v3.512a.745.745 0 1 0 1.49 0v-6.385c0-.647-.524-1.17-1.17-1.171z"
              />
              <path
                fill="#7E7B7F"
                d="M16.653 10.511c.78-1.017 2.379-2.103 4.527-2.103h5.755c2.122 0 4.045 1.058 4.846 2.103.14.183.368.675.586 1.196h-16.3c.217-.521.446-1.013.586-1.196zm-1.678 2.686h18.484a.745.745 0 0 0 .7-1c-.12-.329-.74-2-1.196-2.593-.992-1.294-3.302-2.686-6.028-2.686H21.18c-2.69 0-4.713 1.388-5.709 2.686-.455.594-1.076 2.264-1.196 2.593a.745.745 0 0 0 .7 1z"
              />
            </g>
          </svg>
        )
      },
      roundCheckCircle1: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
            <g fill="none" fillRule="evenodd">
              <path
                fill={fill ? fill : '#fff'}
                stroke="#FFF"
                strokeWidth="2"
                d="M13 25c6.627 0 12-5.373 12-12S19.627 1 13 1 1 6.373 1 13s5.373 12 12 12z"
              />
              <path
                fill="#FFF"
                d="M16.494 9.758a.884.884 0 0 1 1.248 1.248L12.447 16.3a.88.88 0 0 1-1.247 0l-2.942-2.941a.884.884 0 0 1 1.248-1.248l2.318 2.318 4.67-4.671z"
              />
            </g>
          </svg>
        )
      },
      circleLoader: () => {
        // fill={fill ? fill : '#fff'}
        return (
          <svg
            width="24px"
            height="24px"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
            className="lds-rolling">
            <circle
              cx="50"
              cy="50"
              fill="none"
              ng-attr-stroke="{{config.color}}"
              ng-attr-strokeWidth="{{config.width}}"
              ng-attr-r="{{config.radius}}"
              ng-attr-stroke-dasharray="{{config.dasharray}}"
              // stroke="#fff"
              stroke={fill ? fill : '#436ab2'}
              strokeWidth="9"
              r="35"
              strokeDasharray="164.93361431346415 56.97787143782138"
              transform="rotate(10.7467 50 50)">
              <animateTransform
                attributeName="transform"
                type="rotate"
                calcMode="linear"
                values="0 50 50;360 50 50"
                keyTimes="0;1"
                dur="1s"
                begin="0s"
                repeatCount="indefinite"
              />
            </circle>
          </svg>
        )
      },
      hospitalization: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
            <g fill="none" fillRule="evenodd">
              <path fill="#D7E9FF" d="M8.516 3.871h2V1.548h-2zM10.613 46.645h2v-42h-2z" />
              <path
                fill="#4A4A4A"
                d="M37.873 19.544h8.507v-2.329h-8.507v2.33zm0 27.038h5.975v-25.62h-5.975v25.62zm-17.012 0h6.177v-11.14h-6.177v11.14zM11.34 5.063h25.115v41.52h-8V35.138c-.001-.615-.5-1.113-1.114-1.114h-6.785c-.615.001-1.113.5-1.114 1.114v11.443h-8.101V5.063zM3.95 46.583h5.975V15.797H3.95v30.784zM1.418 14.38h8.506v-2.33H1.418v2.33zM8.506 3.645h30.785V1.418H8.506v2.227zm29.367 12.153V5.063h1.925c.503 0 .91-.408.91-.911V.912a.912.912 0 0 0-.91-.912H8a.913.913 0 0 0-.911.912v3.24c0 .503.408.91.911.911h1.924v5.57H.911a.912.912 0 0 0-.911.911v3.342c0 .503.408.91.911.912h1.62V47.29c0 .391.318.709.71.709h41.316a.71.71 0 0 0 .709-.709v-26.33h1.62a.912.912 0 0 0 .911-.91v-3.342a.912.912 0 0 0-.91-.911h-9.014z"
              />
              <path
                fill="#1AE5BE"
                d="M14.583 21.975H16.1V20.05h-1.518v1.924zm1.822-3.342h-2.127c-.615 0-1.113.499-1.113 1.114v2.532c0 .615.498 1.113 1.113 1.113h2.127c.615 0 1.113-.498 1.114-1.113v-2.532c0-.615-.499-1.113-1.114-1.114zM14.583 29.975H16.1V28.05h-1.518v1.924zm1.822-3.342h-2.127c-.615 0-1.113.5-1.113 1.114v2.532c0 .615.498 1.113 1.113 1.113h2.127c.615 0 1.113-.498 1.114-1.113v-2.532c0-.615-.499-1.113-1.114-1.114zM23.089 21.975h1.518V20.05H23.09v1.924zm-.304 1.417h2.126c.615 0 1.114-.498 1.114-1.113v-2.532c0-.615-.499-1.113-1.114-1.114h-2.126c-.615 0-1.113.499-1.114 1.114v2.532c0 .615.499 1.113 1.114 1.113zM23.089 29.974h1.518V28.05H23.09v1.924zm-.304 1.418h2.126c.615 0 1.114-.498 1.114-1.113v-2.532c0-.615-.499-1.113-1.114-1.114h-2.126c-.615 0-1.113.5-1.114 1.114v2.532c0 .615.499 1.113 1.114 1.113zM31.696 21.975h1.52V20.05h-1.52v1.924zm-.304 1.417h2.127c.615 0 1.113-.498 1.114-1.113v-2.532c0-.615-.5-1.113-1.114-1.114h-2.127c-.615 0-1.113.499-1.114 1.114v2.532c.001.615.5 1.113 1.114 1.113zM31.696 29.974h1.52V28.05h-1.52v1.924zm-.304 1.418h2.127c.615 0 1.113-.498 1.114-1.113v-2.532c0-.615-.5-1.113-1.114-1.114h-2.127c-.615 0-1.113.5-1.114 1.114v2.532c.001.615.5 1.113 1.114 1.113zM39.899 26.734h1.519V24.81h-1.52v1.924zm-.304 1.418h2.126c.615 0 1.114-.5 1.115-1.114v-2.532c-.001-.615-.5-1.113-1.115-1.114h-2.126c-.615.001-1.113.5-1.114 1.114v2.532c0 .615.499 1.113 1.114 1.114zM6.177 26.734h1.52V24.81h-1.52v1.924zM8 23.392H5.873c-.614.001-1.113.5-1.114 1.114v2.532c.001.615.5 1.113 1.114 1.114H8c.615 0 1.113-.5 1.114-1.114v-2.532c0-.615-.5-1.113-1.114-1.114zM27.747 11.848h-2.025c-.615 0-1.114.5-1.114 1.114v2.127h-1.114v-2.127c-.001-.615-.5-1.113-1.114-1.114h-2.228v-1.013h2.228c.615 0 1.113-.499 1.114-1.113V7.696h1.114v2.026c0 .614.499 1.113 1.114 1.113h2.025v1.013zm.304-2.43h-2.026V7.393c0-.615-.499-1.114-1.114-1.115H23.19c-.615.001-1.113.5-1.114 1.115v2.025h-2.228c-.615 0-1.113.499-1.114 1.114v1.62c0 .615.5 1.113 1.114 1.114h2.228v2.126c0 .615.499 1.113 1.114 1.114h1.721c.615 0 1.114-.499 1.114-1.114v-2.126h2.026c.615 0 1.113-.5 1.113-1.114v-1.62c0-.615-.498-1.114-1.113-1.114z"
              />
            </g>
          </svg>
        )
      },
      ambulance: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="48"
            height="49"
            viewBox="0 0 48 49">
            <defs>
              <path id="a" d="M0 0h1.391v3.38H0z" />
              <path id="c" d="M.024.016h10.34v10.419H.024z" />
            </defs>
            <g fill="none" fillRule="evenodd">
              <path fill="#D7E9FF" d="M2.715 12.65h28.589V11.61H1.69a.3.3 0 0 0-.299.3V35.26h1.617l-.293-22.61z" />
              <path
                fill="#FFF"
                d="M43.264 16.994c-.124-.383-.558-.6-.97-.485-.41.115-.645.517-.522.9l4.005 12.46c.12.385.553.605.966.493.413-.112.65-.513.53-.897a.145.145 0 0 0-.003-.01l-4.006-12.461z"
              />
              <path
                fill="#1AE5BE"
                d="M32.56 11.596a.692.692 0 0 0 .818-.536l.882-4.348H36l.883 4.335c.075.37.441.61.818.535a.682.682 0 0 0 .546-.802l-.93-4.57c-.103-.5-.55-.861-1.072-.862h-2.23a1.09 1.09 0 0 0-1.071.862l-.93 4.584c-.075.37.17.728.546.802"
              />
              <g transform="translate(34.087 .478)">
                <mask id="b" fill="#fff">
                  <use xlinkHref="#a" />
                </mask>
                <path
                  fill="#1AE5BE"
                  d="M1.391 2.684V.696A.696.696 0 0 0 0 .696v1.988a.696.696 0 1 0 1.391 0"
                  mask="url(#b)"
                />
              </g>
              <path
                fill="#1AE5BE"
                d="M38.26 6.74c0 .383.321.695.717.695h2.046a.706.706 0 0 0 .716-.696.706.706 0 0 0-.716-.695h-2.046a.706.706 0 0 0-.716.695M31.284 7.435A.706.706 0 0 0 32 6.739a.706.706 0 0 0-.716-.695h-2.046a.706.706 0 0 0-.716.695c0 .384.32.696.716.696h2.046zM32.004 4.652a.692.692 0 0 0 .489-1.181l-1.398-1.399a.692.692 0 0 0-.98.98l1.4 1.397a.69.69 0 0 0 .489.203M39.166 2.072l-1.398 1.399a.692.692 0 1 0 .979.978l1.398-1.398a.692.692 0 1 0-.979-.979zM12.536 27.853h2.41a.703.703 0 0 0 .703-.703v-2.31h.803v2.31c0 .388.314.703.703.703h2.309v.803h-2.31a.703.703 0 0 0-.702.703v2.41h-.803v-2.41a.703.703 0 0 0-.703-.703h-2.41v-.803zm-.703 2.208h2.41v2.41c0 .388.315.703.703.703h2.209a.703.703 0 0 0 .702-.703v-2.41h2.31a.703.703 0 0 0 .703-.702v-2.21a.703.703 0 0 0-.703-.702h-2.31v-2.31a.703.703 0 0 0-.702-.702h-2.21a.703.703 0 0 0-.702.703v2.309h-2.41a.703.703 0 0 0-.703.703v2.209c0 .388.315.702.703.702z"
              />
              <path
                fill="#4A4A4A"
                d="M31.781 35.593H1.417V11.938c0-.168.136-.304.304-.304h30.06v23.959zm1.417-23.959h10.88c.167 0 .303.136.303.304v2.132c0 1.616-.832 2.436-2.474 2.436h-8.709v-4.872zm9.9 15.012h-9.9v-8.724h8.71c2.435 0 3.89-1.44 3.89-3.852v-2.132a1.722 1.722 0 0 0-1.72-1.72H1.72c-.95 0-1.719.77-1.72 1.719v24.276c0 .06.008.122.024.181v3.643c0 2.353 1.541 4.267 3.436 4.267h2.625a.708.708 0 1 0 0-1.416H3.46c-1.094 0-2.019-1.306-2.019-2.851v-3.028h30.365v5.88h-16.81a.708.708 0 1 0 0 1.415h19.815a.708.708 0 1 0 0-1.416h-1.588V28.062h9.874a3.489 3.489 0 0 1 3.486 3.483v7.86c0 1.606-.742 3.483-2.834 3.483a.708.708 0 1 0 0 1.416c2.543 0 4.251-1.969 4.251-4.9v-7.859a4.907 4.907 0 0 0-4.903-4.9z"
              />
              <g transform="translate(34.087 38.044)">
                <mask id="d" fill="#fff">
                  <use xlinkHref="#c" />
                </mask>
                <path
                  fill="#4A4A4A"
                  d="M5.194 1.426c2.071.002 3.75 1.697 3.752 3.788l-.001.09C8.895 7.396 7.177 9.05 5.105 9 3.101 8.953 1.49 7.323 1.443 5.3v-.086c.002-2.091 1.68-3.786 3.751-3.788M1.58 8.946a5.135 5.135 0 0 0 7.31-.08 5.247 5.247 0 0 0 1.474-3.525l.001-.127C10.352 2.331 8.027.004 5.171.016 2.334.03.037 2.35.024 5.214a5.214 5.214 0 0 0 1.554 3.732"
                  mask="url(#d)"
                />
              </g>
              <path
                fill="#4A4A4A"
                d="M14.567 43.351a3.787 3.787 0 0 1-7.57-.003l-.001-.086a3.773 3.773 0 0 1 1.014-2.578l.016-.017a3.782 3.782 0 0 1 5.501-.011l.013.012.01.01c.655.7 1.02 1.625 1.018 2.584v.09m-.007-3.687a5.214 5.214 0 0 0-7.575.018l-.017.018a5.199 5.199 0 0 0-1.403 3.683 5.218 5.218 0 1 0 9.016-3.697l-.021-.022M17.004 15.055H27.5c.168 0 .303.13.303.29v5.048c0 .161-.135.292-.303.292H17.004v-5.63zm-1.413 5.63H5.194a.297.297 0 0 1-.303-.292v-5.047c0-.161.136-.291.303-.291h10.397v5.63zm13.626-.292v-5.047c0-.911-.768-1.65-1.716-1.65H5.194c-.947 0-1.715.739-1.716 1.65v5.047c.001.911.769 1.65 1.716 1.65h22.307c.948 0 1.715-.739 1.716-1.65z"
              />
            </g>
          </svg>
        )
      },
      mobileTap: () => {
        return (
          <svg id="code" xmlns="http://www.w3.org/2000/svg" width="39.881" height="39.88" viewBox="0 0 39.881 39.88">
            <path
              id="Path_41"
              data-name="Path 41"
              d="M243.313,96v6.625a1.271,1.271,0,0,1,.547-.128,1.35,1.35,0,0,1,1.32,1.378,1.411,1.411,0,0,1-.386.975l.622-.65a1.294,1.294,0,0,1,.933-.4c.028,0,.055.007.083.009l-.007-.007v-4.55h11.2v7.8h-7.467l-6.844,7.147v.65h.622l6.474-4.916a1.364,1.364,0,0,1,.828-.281,1.441,1.441,0,0,1,1.409,1.471v.357a1.49,1.49,0,0,1-.607,1.209l-6.975,5.043a3.66,3.66,0,0,1-1.1.543l-.652.194v2.228h17.422V96Zm0,0"
              transform="translate(-223.344 -88.533)"
              fill="#f0bc5e"
            />
            <path
              id="Path_42"
              data-name="Path 42"
              d="M388.557,32.622a.622.622,0,1,1-.622-.622A.622.622,0,0,1,388.557,32.622Zm0,0"
              transform="translate(-356.351 -29.511)"
            />
            <path
              id="Path_43"
              data-name="Path 43"
              d="M308.557,32.622a.622.622,0,1,1-.622-.622A.622.622,0,0,1,308.557,32.622Zm0,0"
              transform="translate(-282.746 -29.511)"
            />
            <path
              id="Path_44"
              data-name="Path 44"
              d="M387.313,256h3.733v1.244h-3.733Zm0,0"
              transform="translate(-356.144 -235.536)"
            />
            <path
              id="Path_45"
              data-name="Path 45"
              d="M387.313,288h3.733v1.244h-3.733Zm0,0"
              transform="translate(-356.144 -264.978)"
            />
            <path
              id="Path_46"
              data-name="Path 46"
              d="M387.313,320h3.733v1.244h-3.733Zm0,0"
              transform="translate(-356.144 -294.42)"
            />
            <path
              id="Path_47"
              data-name="Path 47"
              d="M307.313,352h9.956v1.244h-9.956Zm0,0"
              transform="translate(-282.366 -323.861)"
            />
            <path
              id="Path_48"
              data-name="Path 48"
              d="M36.686,0H20.073a3.2,3.2,0,0,0-3.195,3.195v9.592c-.026,0-.051-.008-.077-.008a1.982,1.982,0,0,0-1.41.584l-4.651,4.651A4.485,4.485,0,0,0,9.6,19.948l-.732,2.562a3.21,3.21,0,0,1-.813,1.382l-1.4,1.4L5.377,24.016,0,29.392,10.488,39.88,15.865,34.5l-1.278-1.278,1.4-1.4a3.183,3.183,0,0,1,.89-.621v5.217a3.2,3.2,0,0,0,3.195,3.195H36.686a3.2,3.2,0,0,0,3.195-3.195V3.195A3.2,3.2,0,0,0,36.686,0ZM20.073,1.278H36.686A1.919,1.919,0,0,1,38.6,3.195v.639H33.226L31.948,5.112H24.81L23.532,3.834H18.156V3.195A1.919,1.919,0,0,1,20.073,1.278ZM18.156,5.112H23L24.281,6.39h8.2l1.278-1.278H38.6V33.226H18.156V30.787l2.122-.607a4.457,4.457,0,0,0,1.318-.623L28.758,24.6a2.085,2.085,0,0,0,.9-1.715v-.351a2.085,2.085,0,0,0-3.312-1.686L21.6,24.3l5.13-5.13h8.042V10.223H21.99v4.562c-.034.01-.068.019-.1.031a1.98,1.98,0,0,0-3.265-.845,1.991,1.991,0,0,0-.467-.652V5.112ZM28.3,12.779a1.982,1.982,0,0,0-1.41.584l-2.52,2.52a2,2,0,0,0-1.1-1.049V11.5H33.491v6.39H28l1.707-1.707a1.994,1.994,0,0,0-1.41-3.4ZM1.807,29.392,3.46,27.74l8.681,8.681-1.652,1.652Zm11.237,6.125L4.363,26.836l1.013-1.013L14.057,34.5Zm2.04-4.6-1.4,1.4L7.558,26.2l1.4-1.4A4.485,4.485,0,0,0,10.1,22.862L10.83,20.3a3.21,3.21,0,0,1,.813-1.382l4.651-4.651a.717.717,0,0,1,1.014,1.013l-4.076,4.076.9.9,5.354-5.354A.717.717,0,0,1,20.5,15.919l-5.354,5.354.9.9,5.993-5.993A.717.717,0,0,1,23.058,17.2L17.065,23.19l.9.9L27.8,14.267a.717.717,0,0,1,1.013,1.013L18.795,25.294v1.542H20.28L27.1,21.879a.8.8,0,0,1,.475-.154.808.808,0,0,1,.808.808v.351a.809.809,0,0,1-.348.664l-7.163,4.959a3.192,3.192,0,0,1-.941.446l-2.909.831a4.48,4.48,0,0,0-1.935,1.138Zm21.6,7.416H20.073a1.919,1.919,0,0,1-1.917-1.917V34.5H38.6v1.917A1.919,1.919,0,0,1,36.686,38.337Zm0,0"
              transform="translate(0)"
            />
            <path
              id="Path_49"
              data-name="Path 49"
              d="M315.313,448h6.222v1.245h-6.222Zm0,0"
              transform="translate(-290.003 -412.111)"
            />
            <path
              id="Path_50"
              data-name="Path 50"
              d="M339.313,32H341.8v1.244h-2.489Zm0,0"
              transform="translate(-312.163 -29.511)"
            />
          </svg>
        )
      },
      agreementWrite: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="39.175" height="39.175" viewBox="0 0 39.175 39.175">
            <g id="Group_1897" data-name="Group 1897" transform="translate(0 0)">
              <path
                id="Path_5"
                data-name="Path 5"
                d="M39.174,19.253a2.825,2.825,0,0,0-2.83-2.825h-.08a2.743,2.743,0,0,0-1.955.81L27.8,23.748V0H6.688L0,6.689V39.175H27.8V31.855l8.214-8.214.147.147a1.657,1.657,0,0,1,0,2.343l-4.57,4.57a2.157,2.157,0,0,0,0,3.051l.817.817.893-.893-.817-.817a.894.894,0,0,1,0-1.264l4.57-4.57a2.92,2.92,0,0,0,0-4.13l-.147-.147,1.427-1.427a2.872,2.872,0,0,0,.839-2.067ZM6.318,2.157V6.319H2.157ZM26.537,37.911H1.263V7.582H7.582V1.264H26.537V25.012l-6.25,6.25-1.177,4.122h-.919a.177.177,0,0,1-.159-.1l-1.022-2.044.546-.874a5.037,5.037,0,0,0,.766-2.671,1.9,1.9,0,1,0-3.791,0v.224a5.063,5.063,0,0,0,.532,2.253l.5,1L14.234,35.3a.177.177,0,0,1-.15.083h-.815a.177.177,0,0,1-.172-.135l-.326-1.3a1.441,1.441,0,0,0-2.8,0l-.326,1.3a.177.177,0,0,1-.172.134h-1.9v1.264h1.9a1.438,1.438,0,0,0,1.4-1.091l.326-1.3a.184.184,0,0,1,.344,0l.326,1.3a1.437,1.437,0,0,0,1.4,1.091h.815a1.431,1.431,0,0,0,1.222-.677l.921-1.473.677,1.353a1.434,1.434,0,0,0,1.289.8h1.484l4.665-1.333,2.2-2.2ZM21.163,32.8l1.64,1.64-2.3.657Zm-4.677-1.1-.138.22-.154-.309a3.793,3.793,0,0,1-.4-1.688V29.7a.632.632,0,1,1,1.264,0,3.768,3.768,0,0,1-.573,2Zm7.524,2.161-2.266-2.266L32.855,20.481l2.266,2.266ZM37.442,20.427l-1.427,1.427-2.266-2.266L35.2,18.132a1.488,1.488,0,0,1,1.061-.44h.08a1.558,1.558,0,0,1,1.11.458,1.632,1.632,0,0,1-.013,2.277Zm0,0"
                transform="translate(0.001 0)"
              />
              <g id="Group_225" data-name="Group 225" transform="translate(2.136 3.244)">
                <path
                  id="Path_6"
                  data-name="Path 6"
                  d="M64,448h1.266v1.266H64Zm0,0"
                  transform="translate(-61.468 -415.085)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_7"
                  data-name="Path 7"
                  d="M304,32h1.266v1.266H304Zm0,0"
                  transform="translate(-282.478 -32)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_8"
                  data-name="Path 8"
                  d="M192,32h7.6v1.266H192Zm0,0"
                  transform="translate(-179.34 -32)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_9"
                  data-name="Path 9"
                  d="M304,64h1.266v1.266H304Zm0,0"
                  transform="translate(-282.478 -61.468)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_10"
                  data-name="Path 10"
                  d="M192,64h7.6v1.266H192Zm0,0"
                  transform="translate(-179.34 -61.468)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_11"
                  data-name="Path 11"
                  d="M304,96h1.266v1.266H304Zm0,0"
                  transform="translate(-282.478 -90.936)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_12"
                  data-name="Path 12"
                  d="M192,96h7.6v1.266H192Zm0,0"
                  transform="translate(-179.34 -90.936)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_13"
                  data-name="Path 13"
                  d="M32,128H54.788v1.266H32Zm0,0"
                  transform="translate(-32 -120.404)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_14"
                  data-name="Path 14"
                  d="M32,160H54.788v1.266H32Zm0,0"
                  transform="translate(-32 -149.872)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_15"
                  data-name="Path 15"
                  d="M32,192H54.788v1.266H32Zm0,0"
                  transform="translate(-32 -179.34)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_16"
                  data-name="Path 16"
                  d="M144,232h1.266v1.266H144Zm0,0"
                  transform="translate(-135.138 -216.175)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_17"
                  data-name="Path 17"
                  d="M176,232h11.394v1.266H176Zm0,0"
                  transform="translate(-164.606 -216.175)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_18"
                  data-name="Path 18"
                  d="M144,264h13.926v1.266H144Zm0,0"
                  transform="translate(-135.138 -245.644)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_19"
                  data-name="Path 19"
                  d="M144,296h13.926v1.266H144Zm0,0"
                  transform="translate(-135.138 -275.112)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_20"
                  data-name="Path 20"
                  d="M32,336h8.862v1.266H32Zm0,0"
                  transform="translate(-32 -311.947)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_21"
                  data-name="Path 21"
                  d="M32,368h8.862v1.266H32Zm0,0"
                  transform="translate(-32 -341.415)"
                  fill="#f0bc5e"
                />
              </g>
            </g>
          </svg>
        )
      },
      downloadPDF: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            viewBox="0 0 471.2 471.2"
            xmlSpace="preserve"
            width="16px"
            height="16px">
            <g>
              <g>
                <g>
                  <path
                    d="M457.7,230.15c-7.5,0-13.5,6-13.5,13.5v122.8c0,33.4-27.2,60.5-60.5,60.5H87.5c-33.4,0-60.5-27.2-60.5-60.5v-124.8    c0-7.5-6-13.5-13.5-13.5s-13.5,6-13.5,13.5v124.8c0,48.3,39.3,87.5,87.5,87.5h296.2c48.3,0,87.5-39.3,87.5-87.5v-122.8    C471.2,236.25,465.2,230.15,457.7,230.15z"
                    data-original="#000000"
                    className="active-path"
                    data-old_color="#000000"
                    fill="#436AB2"
                  />
                  <path
                    d="M226.1,346.75c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.8-85.8c5.3-5.3,5.3-13.8,0-19.1c-5.3-5.3-13.8-5.3-19.1,0l-62.7,62.8    V30.75c0-7.5-6-13.5-13.5-13.5s-13.5,6-13.5,13.5v273.9l-62.8-62.8c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1    L226.1,346.75z"
                    data-original="#000000"
                    className="active-path"
                    data-old_color="#000000"
                    fill="#436AB2"
                  />
                </g>
              </g>
            </g>
          </svg>
        )
      },
      agreementSend: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="37.905" height="39.289" viewBox="0 0 37.905 39.289">
            <g id="Group_1899" data-name="Group 1899" transform="translate(0 0)">
              <path
                id="Path_5"
                data-name="Path 5"
                d="M27.881,31.38c0-7.987,0-31.379,0-31.379H6.707L0,6.708v32.58H27.881V31.947C27.881,29.969,27.881,39.366,27.881,31.38ZM6.336,2.164V6.337H2.163ZM26.614,38.021H1.267V7.6H7.6V1.268h19.01V38.021Z"
                transform="translate(10.024 0)"
                fill="#4a4a4a"
              />
              <g id="Group_225" data-name="Group 225" transform="translate(12.165 3.253)">
                <path
                  id="Path_6"
                  data-name="Path 6"
                  d="M64,448h1.27v1.27H64Zm0,0"
                  transform="translate(-61.461 -414.99)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_7"
                  data-name="Path 7"
                  d="M304,32h1.27v1.27H304Zm0,0"
                  transform="translate(-282.416 -32)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_8"
                  data-name="Path 8"
                  d="M192,32h7.618v1.27H192Zm0,0"
                  transform="translate(-179.304 -32)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_9"
                  data-name="Path 9"
                  d="M304,64h1.27v1.27H304Zm0,0"
                  transform="translate(-282.416 -61.461)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_10"
                  data-name="Path 10"
                  d="M192,64h7.618v1.27H192Zm0,0"
                  transform="translate(-179.304 -61.461)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_11"
                  data-name="Path 11"
                  d="M304,96h1.27v1.27H304Zm0,0"
                  transform="translate(-282.416 -90.922)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_12"
                  data-name="Path 12"
                  d="M192,96h7.618v1.27H192Zm0,0"
                  transform="translate(-179.304 -90.922)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_13"
                  data-name="Path 13"
                  d="M32,128H54.854v1.27H32Zm0,0"
                  transform="translate(-32 -120.382)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_14"
                  data-name="Path 14"
                  d="M32,160H54.854v1.27H32Zm0,0"
                  transform="translate(-32 -149.843)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_15"
                  data-name="Path 15"
                  d="M32,192H54.854v1.27H32Zm0,0"
                  transform="translate(-32 -179.304)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_16"
                  data-name="Path 16"
                  d="M144,232h1.27v1.27H144Zm0,0"
                  transform="translate(-135.113 -216.13)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_17"
                  data-name="Path 17"
                  d="M176,232h11.427v1.27H176Zm0,0"
                  transform="translate(-164.573 -216.13)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_18"
                  data-name="Path 18"
                  d="M144,264h13.966v1.27H144Zm0,0"
                  transform="translate(-135.113 -245.59)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_19"
                  data-name="Path 19"
                  d="M144,296h13.966v1.27H144Zm0,0"
                  transform="translate(-135.113 -275.051)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_20"
                  data-name="Path 20"
                  d="M32,336h8.887v1.27H32Zm0,0"
                  transform="translate(-32 -311.877)"
                  fill="#f0bc5e"
                />
                <path
                  id="Path_21"
                  data-name="Path 21"
                  d="M32,368h8.887v1.27H32Zm0,0"
                  transform="translate(-32 -341.338)"
                  fill="#f0bc5e"
                />
              </g>
              <path
                id="Path_479"
                data-name="Path 479"
                d="M20.62,40.817H19.7a.178.178,0,0,1-.159-.1l-1.025-2.05.548-.877a5.051,5.051,0,0,0,.768-2.679,1.9,1.9,0,1,0-3.8,0v.224a5.078,5.078,0,0,0,.533,2.26l.5,1-1.334,2.134a.178.178,0,0,1-.151.083h-.817a.177.177,0,0,1-.172-.135l-.327-1.306a1.445,1.445,0,0,0-2.8,0l-.327,1.306a.178.178,0,0,1-.172.134h-1.9v1.267h1.9a1.443,1.443,0,0,0,1.4-1.094l.327-1.306a.185.185,0,0,1,.345,0l.327,1.306a1.441,1.441,0,0,0,1.4,1.094h.817a1.435,1.435,0,0,0,1.226-.679l.923-1.477.679,1.357a1.438,1.438,0,0,0,1.293.8Zm-2.632-3.7-.138.221-.155-.309a3.8,3.8,0,0,1-.4-1.693v-.224a.634.634,0,0,1,1.267,0,3.779,3.779,0,0,1-.575,2.006Z"
                transform="translate(14.447 -5.331)"
                fill="#4a4a4a"
              />
              <rect
                id="Rectangle_1179"
                data-name="Rectangle 1179"
                width="8.395"
                height="1.259"
                rx="0.63"
                transform="translate(0 6.397)"
                fill="#4a4a4a"
              />
              <rect
                id="Rectangle_1180"
                data-name="Rectangle 1180"
                width="5.876"
                height="1.259"
                rx="0.63"
                transform="translate(2.518 8.915)"
                fill="#4a4a4a"
              />
              <rect
                id="Rectangle_1181"
                data-name="Rectangle 1181"
                width="2.518"
                height="1.259"
                rx="0.63"
                transform="translate(5.876 11.434)"
                fill="#4a4a4a"
              />
            </g>
          </svg>
        )
      },
      approval: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="39.883" height="39.883" viewBox="0 0 39.883 39.883">
            <g id="approval" transform="translate(0 0)">
              <path
                id="Path_22"
                data-name="Path 22"
                d="M295.076,110.152a7.076,7.076,0,1,1,7.076-7.076A7.084,7.084,0,0,1,295.076,110.152Zm0,0"
                transform="translate(-264.842 -88.281)"
                fill="#f0bc5e"
              />
              <path
                id="Path_23"
                data-name="Path 23"
                d="M369.287,448.643a.643.643,0,1,1-.643-.643A.643.643,0,0,1,369.287,448.643Zm0,0"
                transform="translate(-338.409 -411.976)"
                fill="#4a4a4a"
              />
              <path
                id="Path_24"
                data-name="Path 24"
                d="M42.292,297.006H32V288H42.292Zm0,0"
                transform="translate(-29.427 -264.842)"
                fill="#fff"
              />
              <path
                id="Path_25"
                data-name="Path 25"
                d="M42.292,145.006H32V136H42.292Zm0,0"
                transform="translate(-29.427 -125.064)"
                fill="#fff"
              />
              <path
                id="Path_26"
                data-name="Path 26"
                d="M39.883,14.8a9.653,9.653,0,0,0-9.006-9.617V0H0V34.737H27.018v1.93a3.216,3.216,0,1,0,6.433,0V27.017H32.164V24.25A9.666,9.666,0,0,0,39.883,14.8Zm-1.287,0a8.363,8.363,0,1,1-8.363-8.363A8.372,8.372,0,0,1,38.6,14.8ZM27.018,27.017V33.45H1.287V1.286h28.3V5.179A9.643,9.643,0,0,0,28.3,24.25v2.767Zm5.146,9.649a1.93,1.93,0,1,1-3.86,0V28.3h3.86Zm-1.287-9.649H29.591V24.412c.214.014.426.033.643.033s.43-.019.643-.033Zm0,0"
                transform="translate(0 0)"
                fill="#4a4a4a"
              />
              <path
                id="Path_27"
                data-name="Path 27"
                d="M340.272,145.324l-.714,1.07,2.537,1.69L345.637,141l-1.152-.575-2.89,5.781Zm0,0"
                transform="translate(-312.254 -129.134)"
                fill="#4a4a4a"
              />
              <path
                id="Path_28"
                data-name="Path 28"
                d="M68.5,267.755l-1.25-1.25-.91.91,2.609,2.609,3.585-8.606-1.187-.5Zm0,0"
                transform="translate(-61.009 -239.942)"
                fill="#4a4a4a"
              />
              <path
                id="Path_29"
                data-name="Path 29"
                d="M68.5,115.755l-1.25-1.25-.91.91,2.609,2.609,3.585-8.606-1.187-.5Zm0,0"
                transform="translate(-61.009 -100.164)"
                fill="#4a4a4a"
              />
              <path
                id="Path_30"
                data-name="Path 30"
                d="M224,64h1.287v1.287H224Zm0,0"
                transform="translate(-205.988 -58.854)"
                fill="#4a4a4a"
              />
              <path
                id="Path_31"
                data-name="Path 31"
                d="M32,64H46.152v1.287H32Zm0,0"
                transform="translate(-29.427 -58.854)"
                fill="#4a4a4a"
              />
              <path
                id="Path_32"
                data-name="Path 32"
                d="M176,288h7.719v1.287H176Zm0,0"
                transform="translate(-161.848 -264.842)"
                fill="#4a4a4a"
              />
              <path
                id="Path_33"
                data-name="Path 33"
                d="M176,320h7.719v1.287H176Zm0,0"
                transform="translate(-161.848 -294.269)"
                fill="#4a4a4a"
              />
              <path
                id="Path_34"
                data-name="Path 34"
                d="M176,352h7.719v1.287H176Zm0,0"
                transform="translate(-161.848 -323.696)"
                fill="#4a4a4a"
              />
              <path
                id="Path_35"
                data-name="Path 35"
                d="M176,384h7.719v1.287H176Zm0,0"
                transform="translate(-161.848 -353.123)"
                fill="#4a4a4a"
              />
              <path
                id="Path_36"
                data-name="Path 36"
                d="M176,136h5.146v1.287H176Zm0,0"
                transform="translate(-161.848 -125.064)"
                fill="#4a4a4a"
              />
              <path
                id="Path_37"
                data-name="Path 37"
                d="M176,168h5.146v1.287H176Zm0,0"
                transform="translate(-161.848 -154.491)"
                fill="#4a4a4a"
              />
              <path
                id="Path_38"
                data-name="Path 38"
                d="M176,200h5.146v1.287H176Zm0,0"
                transform="translate(-161.848 -183.918)"
                fill="#4a4a4a"
              />
              <path
                id="Path_39"
                data-name="Path 39"
                d="M176,232h5.146v1.287H176Zm0,0"
                transform="translate(-161.848 -213.345)"
                fill="#4a4a4a"
              />
              <path
                id="Path_40"
                data-name="Path 40"
                d="M32,32H48.725v1.287H32Zm0,0"
                transform="translate(-29.427 -29.427)"
                fill="#4a4a4a"
              />
            </g>
          </svg>
        )
      },
      dayCare: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="48"
            height="51"
            viewBox="0 0 48 51">
            <defs>
              <path id="a" d="M0 0h6.386v6.386H0z" />
              <path id="c" d="M0 0h6.386v6.386H0z" />
            </defs>
            <g fill="none" fillRule="evenodd">
              <path
                fill="#D7E9FF"
                d="M25.437 8.408H21.18c-2.148 0-3.747 1.086-4.527 2.103-.14.183-.368.675-.586 1.196h4.257c.218-.521.446-1.013.587-1.196.78-1.017 2.378-2.103 4.526-2.103"
              />
              <g transform="translate(7.663 44.065)">
                <mask id="b" fill="#fff">
                  <use xlinkHref="#a" />
                </mask>
                <path
                  fill="#4A4A4A"
                  d="M3.193 4.895a1.703 1.703 0 1 1 0-3.406 1.703 1.703 0 0 1 0 3.406m0-4.895a3.193 3.193 0 1 0 0 6.386 3.193 3.193 0 0 0 0-6.386"
                  mask="url(#b)"
                />
              </g>
              <g transform="translate(33.951 44.065)">
                <mask id="d" fill="#fff">
                  <use xlinkHref="#c" />
                </mask>
                <path
                  fill="#4A4A4A"
                  d="M3.193 4.895a1.703 1.703 0 1 1 0-3.406 1.703 1.703 0 0 1 0 3.406m0-4.895a3.193 3.193 0 1 0 0 6.386 3.193 3.193 0 0 0 0-6.386"
                  mask="url(#d)"
                />
              </g>
              <path
                fill="#1AE5BE"
                d="M26.927 8.408a.745.745 0 0 0 .745-.745V4.789c0-.646-.525-1.17-1.17-1.17h-1.704V.745a.745.745 0 1 0-1.49 0v2.874h-1.703c-.646 0-1.17.524-1.17 1.17v2.874a.745.745 0 1 0 1.49 0V5.109h4.257v2.554c0 .411.333.745.745.745"
              />
              <path
                fill="#4A4A4A"
                d="M1.49 30.971h45.02v-1.064H1.49v1.064zm1.49-2.554h6.067V26.5H2.98v1.916zm43.85 0H10.536v-2.235c-.001-.646-.525-1.17-1.171-1.17H2.66c-.646 0-1.17.524-1.171 1.17v2.235h-.32c-.646 0-1.17.524-1.17 1.17v1.703c0 .647.524 1.17 1.17 1.171h45.66c.646 0 1.17-.524 1.17-1.17v-1.703c0-.647-.524-1.17-1.17-1.171z"
              />
              <path
                fill="#4A4A4A"
                d="M11.6 41.614h24.8V40.55H11.6v1.064zm25.118-2.554h-5.321v-7.344a.745.745 0 1 0-1.49 0v7.344H18.093v-7.344a.745.745 0 1 0-1.49 0v7.344h-5.321c-.647 0-1.17.524-1.171 1.17v6.386a.745.745 0 1 0 1.49 0v-3.512h24.798v3.512a.745.745 0 1 0 1.49 0v-6.385c0-.647-.524-1.17-1.17-1.171z"
              />
              <path
                fill="#7E7B7F"
                d="M16.653 10.511c.78-1.017 2.379-2.103 4.527-2.103h5.755c2.122 0 4.045 1.058 4.846 2.103.14.183.368.675.586 1.196h-16.3c.217-.521.446-1.013.586-1.196zm-1.678 2.686h18.484a.745.745 0 0 0 .7-1c-.12-.329-.74-2-1.196-2.593-.992-1.294-3.302-2.686-6.028-2.686H21.18c-2.69 0-4.713 1.388-5.709 2.686-.455.594-1.076 2.264-1.196 2.593a.745.745 0 0 0 .7 1z"
              />
            </g>
          </svg>
        )
      },
      roundCheckCircle1: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
            <g fill="none" fillRule="evenodd">
              <path
                fill={fill ? fill : '#fff'}
                stroke="#FFF"
                strokeWidth="2"
                d="M13 25c6.627 0 12-5.373 12-12S19.627 1 13 1 1 6.373 1 13s5.373 12 12 12z"
              />
              <path
                fill="#FFF"
                d="M16.494 9.758a.884.884 0 0 1 1.248 1.248L12.447 16.3a.88.88 0 0 1-1.247 0l-2.942-2.941a.884.884 0 0 1 1.248-1.248l2.318 2.318 4.67-4.671z"
              />
            </g>
          </svg>
        )
      },
      circleLoader: () => {
        // fill={fill ? fill : '#fff'}
        return (
          <svg
            width="24px"
            height="24px"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
            className="lds-rolling">
            <circle
              cx="50"
              cy="50"
              fill="none"
              ng-attr-stroke="{{config.color}}"
              ng-attr-strokewidth="{{config.width}}"
              ng-attr-r="{{config.radius}}"
              ng-attr-stroke-dasharray="{{config.dasharray}}"
              // stroke="#fff"
              stroke={fill ? fill : '#436ab2'}
              strokeWidth="9"
              r="35"
              strokeDasharray="164.93361431346415 56.97787143782138"
              transform="rotate(10.7467 50 50)">
              <animateTransform
                attributeName="transform"
                type="rotate"
                calcMode="linear"
                values="0 50 50;360 50 50"
                keyTimes="0;1"
                dur="1s"
                begin="0s"
                repeatCount="indefinite"
              />
            </circle>
          </svg>
        )
      },
      // return (
      //   <svg width="24" height="24" fill="none" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#FFF">
      //     <g fillRule="evenodd">
      //       <g transform="translate(1 1)" strokeWidth="2">
      //         <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
      //         <path d="M36 18c0-9.94-8.06-18-18-18" transform="rotate(161.703 18 18)">
      //           <animateTransform
      //             attributeName="transform"
      //             type="rotate"
      //             from="0 18 18"
      //             to="360 18 18"
      //             dur="1s"
      //             repeatCount="indefinite"
      //           />
      //         </path>
      //       </g>
      //     </g>
      //   </svg>
      // )
      // return (
      //   <svg width="24" height="24" fill="none" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#FFF">
      //     <g fillRule="evenodd">
      //       <g transform="translate(1 1)" strokeWidth="3">
      //         <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
      //         <path d="M36 18c0-9.94-8.06-18-18-18" transform="rotate(161.703 18 18)">
      //           <animateTransform
      //             attributeName="transform"
      //             type="rotate"
      //             from="0 18 18"
      //             to="360 18 18"
      //             dur="1s"
      //             repeatCount="indefinite"
      //           />
      //         </path>
      //       </g>
      //     </g>
      //   </svg>
      // )
      // },
      checkCircle: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={width || '26'} height={height || "26"} viewBox="0 0 26 26">
            <g fill="none" fillRule="evenodd">
              <path
                fill="#436AB2"
                stroke="#FFF"
                strokeWidth="2"
                d="M13 25c6.627 0 12-5.373 12-12S19.627 1 13 1 1 6.373 1 13s5.373 12 12 12z"
              />
              <path
                fill="#FFF"
                d="M16.494 9.758a.884.884 0 0 1 1.248 1.248L12.447 16.3a.88.88 0 0 1-1.247 0l-2.942-2.941a.884.884 0 0 1 1.248-1.248l2.318 2.318 4.67-4.671z"
              />
            </g>
          </svg>
        )
      },
      roundCancelCircle: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ? width : 24}
            height={height ? height : 24}
            // width="24" height="24"
            viewBox="0 0 24 24">
            <path opacity=".87" fill="none" d="M0 0h24v24H0V0z" />
            <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm4.3 14.3c-.39.39-1.02.39-1.41 0L12 13.41 9.11 16.3c-.39.39-1.02.39-1.41 0-.39-.39-.39-1.02 0-1.41L10.59 12 7.7 9.11c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L12 10.59l2.89-2.89c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41L13.41 12l2.89 2.89c.38.38.38 1.02 0 1.41z" />
          </svg>
        )
      },
      roundCloudUpload: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={width ? width : 48}
            height={height ? height : 48}
            viewBox="0 0 48 48">
            <defs>
              <path id="a" d="M0 .07h27.99v35.328H0z" />
            </defs>
            <g fill="none" fillRule="evenodd">
              <path fill="#FFF" fillOpacity=".01" d="M0 0h48v48H0z" />
              <path
                fill="#D7E9FF"
                d="M27.579 6.717v2.258l-12.78.106s-2.08.387-1.882 2.022v8.34c0 4.649.033 9.299.005 13.947l-.021 2.76c-.003.37-.006.746.089 1.103.205.781.854 1.385 1.582 1.732.67.32 1.409.458 2.136.571.545.085 1.413.295 1.944.135l-3.11.938-4.112-1.486-.99-3.022v-3.914l.297-21.996.892-1.882.694-.942h.891l2.428-.483 11.937-.187z"
              />
              <g transform="translate(10 6)">
                <mask id="b" fill="#fff">
                  <use xlinkHref="#a" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M23.347 33.69H4.642c-1.595 0-2.935-1.322-2.935-2.926V4.703c0-1.596 1.33-2.927 2.935-2.927H17.58v5.393a3.733 3.733 0 0 0 3.746 3.737h4.958v19.858c0 1.604-1.331 2.927-2.936 2.927zM19.285 3.082L25.114 9.2h-3.789a2.032 2.032 0 0 1-2.04-2.031V3.08zM19.038.342a.855.855 0 0 0-.614-.273H4.642C2.1.07 0 2.16 0 4.703v26.06c0 2.544 2.1 4.635 4.642 4.635h18.705c2.543 0 4.643-2.091 4.643-4.634V10.07a.918.918 0 0 0-.248-.597L19.038.343z"
                  mask="url(#b)"
                />
              </g>
              <path
                fill="#1AE5BE"
                d="M31.018 33.803H16.972a.856.856 0 0 0-.854.853c0 .47.385.854.854.854h14.054c.47 0 .854-.384.854-.854a.858.858 0 0 0-.862-.853M19.626 24.621l3.515-3.78v9.318c0 .47.384.853.854.853s.853-.384.853-.853V20.84l3.516 3.781a.849.849 0 0 0 1.203.043.85.85 0 0 0 .043-1.204l-5-5.367a.86.86 0 0 0-.624-.273c-.239 0-.46.102-.622.273l-5.001 5.367a.85.85 0 0 0 .042 1.204.87.87 0 0 0 1.22-.043"
              />
            </g>
          </svg>
        )
      },
      // <g>
      paytm: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            id="Layer_1"
            x="0px"
            y="0px"
            viewBox="0 0 48 48"
            // style="enable-background:new 0 0 48 48;"
            width={width ? width : 48}
            height={height ? height : 48}
            // width="48px"
            // height="48px"
          >
            <path
              fill="#0D47A1"
              d="M5.446,18.01H0.548c-0.277,0-0.502,0.167-0.503,0.502L0,30.519c-0.001,0.3,0.196,0.45,0.465,0.45  c0.735,0,1.335,0,2.07,0C2.79,30.969,3,30.844,3,30.594C3,29.483,3,28.111,3,27l2.126,0.009c1.399-0.092,2.335-0.742,2.725-2.052  c0.117-0.393,0.14-0.733,0.14-1.137l0.11-2.862C7.999,18.946,6.949,18.181,5.446,18.01z M4.995,23.465  C4.995,23.759,4.754,24,4.461,24H3v-3h1.461c0.293,0,0.534,0.24,0.534,0.535V23.465z"
            />
            <path
              fill="#0D47A1"
              d="M13.938,18h-3.423c-0.26,0-0.483,0.08-0.483,0.351c0,0.706,0,1.495,0,2.201  C10.06,20.846,10.263,21,10.552,21h2.855c0.594,0,0.532,0.972,0,1H11.84C10.101,22,9,23.562,9,25.137c0,0.42,0.005,1.406,0,1.863  c-0.008,0.651-0.014,1.311,0.112,1.899C9.336,29.939,10.235,31,11.597,31h4.228c0.541,0,1.173-0.474,1.173-1.101v-8.274  C17.026,19.443,15.942,18.117,13.938,18z M14,27.55c0,0.248-0.202,0.45-0.448,0.45h-1.105C12.201,28,12,27.798,12,27.55v-2.101  C12,25.202,12.201,25,12.447,25h1.105C13.798,25,14,25.202,14,25.449V27.55z"
            />
            <path
              fill="#0D47A1"
              d="M18,18.594v5.608c0.124,1.6,1.608,2.798,3.171,2.798h1.414c0.597,0,0.561,0.969,0,0.969H19.49  c-0.339,0-0.462,0.177-0.462,0.476v2.152c0,0.226,0.183,0.396,0.422,0.396h2.959c2.416,0,3.592-1.159,3.591-3.757v-8.84  c0-0.276-0.175-0.383-0.342-0.383h-2.302c-0.224,0-0.355,0.243-0.355,0.422v5.218c0,0.199-0.111,0.316-0.29,0.316H21.41  c-0.264,0-0.409-0.143-0.409-0.396v-5.058C21,18.218,20.88,18,20.552,18c-0.778,0-1.442,0-2.22,0C18.067,18,18,18.263,18,18.594  L18,18.594z"
            />
            <path
              fill="#00ADEE"
              d="M27.038,20.569v-2.138c0-0.237,0.194-0.431,0.43-0.431H28c1.368-0.285,1.851-0.62,2.688-1.522  c0.514-0.557,0.966-0.704,1.298-0.113L32,18h1.569C33.807,18,34,18.194,34,18.431v2.138C34,20.805,33.806,21,33.569,21H32v9.569  C32,30.807,31.806,31,31.57,31h-2.14C29.193,31,29,30.807,29,30.569V21h-1.531C27.234,21,27.038,20.806,27.038,20.569L27.038,20.569  z"
            />
            <path
              fill="#00ADEE"
              d="M42.991,30.465c0,0.294-0.244,0.535-0.539,0.535h-1.91c-0.297,0-0.54-0.241-0.54-0.535v-6.623v-1.871  c0-1.284-2.002-1.284-2.002,0v8.494C38,30.759,37.758,31,37.461,31H35.54C35.243,31,35,30.759,35,30.465V18.537  C35,18.241,35.243,18,35.54,18h1.976c0.297,0,0.539,0.241,0.539,0.537v0.292c1.32-1.266,3.302-0.973,4.416,0.228  c2.097-2.405,5.69-0.262,5.523,2.375c0,2.916-0.026,6.093-0.026,9.033c0,0.294-0.244,0.535-0.538,0.535h-1.891  C45.242,31,45,30.759,45,30.465c0-2.786,0-5.701,0-8.44c0-1.307-2-1.37-2,0v8.44H42.991z"
            />
          </svg>
        )
      },
      phonePe: () => {
        return (
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            width={width ? width : 48}
            height={height ? height : 48}>
            <g>
              <g>
                <path
                  fill="#673AB7"
                  d="M24,0C10.7,0,0,10.7,0,24c0,13.3,10.7,24,24,24s24-10.7,24-24C48,10.7,37.3,0,24,0z"
                />
              </g>
              <g>
                <path
                  fill="#FFFFFF"
                  d="M33.9,16.6h-4.4l-2.2-3.9l-3.6-6.3c-0.1-0.2-0.3-0.3-0.5-0.3H20c-0.5,0-0.8,0.5-0.5,0.9l7.1,9.6H14.1
						c-0.3,0-0.6,0.3-0.6,0.6v2.7c0,0.3,0.3,0.6,0.6,0.6H17v7.3c0,1.1,0.3,2.2,0.8,3.2c1.2,2.3,3.6,3.9,6.3,3.9
						c1.1,0,2.2-0.3,3.2-0.8V40c0,0.3,0.3,0.6,0.6,0.6h2.7c0.3,0,0.6-0.3,0.6-0.6V20.5h2.8c0.3,0,0.6-0.3,0.6-0.6v-2.7
						C34.5,16.9,34.2,16.6,33.9,16.6z M27.2,27.8c0,1.8-1.4,3.2-3.2,3.2c-1.8,0-3.2-1.4-3.2-3.2v-7.3h6.4V27.8z"
                />
              </g>
            </g>
          </svg>
        )
      },
      PhonePeLogo: () => {
        return (
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width={width ? width : 48}
            height={height ? height : 48}
            viewBox="0 0 132 48"
            // style="enable-background:new 0 0 132 48;" xmlSpace="preserve"
          >
            <g id="Layer_1_1_" display="none">
              <title>Group 39</title>
              <desc>Created with Sketch.</desc>
              <g id="Page-1" display="inline">
                <g id="_x30_-homepage" transform="translate(-24.000000, -12.000000)">
                  <g id="header">
                    <g id="Group-39" transform="translate(24.000000, 12.000000)">
                      <g id="Group-6">
                        <g id="Group-5">
                          <path
                            id="Fill-16"
                            fill="#673AB7"
                            d="M47.7,23.9c0,12.9-10.4,23.4-23.3,23.4S1,36.9,1,23.9S11.5,0.5,24.4,0.5S47.7,11,47.7,23.9
                     "
                          />
                          <path
                            id="Fill-18"
                            fill="#FFFFFF"
                            d="M28.1,27.3c0,0.5-0.1,0.9-0.2,1.2c-0.1,0.4-0.3,0.7-0.6,0.9c-0.3,0.3-0.6,0.5-1,0.6
                     s-0.8,0.2-1.4,0.2h-0.5H24c-0.9,0-1.6-0.2-2.1-0.7s-0.7-1.2-0.7-2.2v-3.9v-3.9c0-0.1,0-0.3,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1
                     h3h3c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3v3.9v3.9H28.1z M34.3,16.1h-2.2h-2.2h-0.1h-0.1c-0.2,0-0.4-0.1-0.5-0.2
                     c-0.2-0.1-0.3-0.3-0.4-0.5L26,11.2l-2.6-4.3c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.4-0.1-0.6-0.1h-1.1h-1.1
                     c-0.2,0-0.3,0-0.4,0.1s-0.1,0.2-0.1,0.4c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.2,0.1,0.3l1,1.5l1,1.5c0.7,1,1.4,2,2.1,2.9
                     s1.5,1.8,2.3,2.6h-5.5h-5.5c-0.2,0-0.4,0.1-0.5,0.2s-0.2,0.3-0.2,0.5v0.8v0.8c0,0.2,0.1,0.4,0.2,0.6s0.3,0.2,0.5,0.2h1.1h1.1
                     c0.1,0,0.2,0.1,0.2,0.1s0.1,0.2,0.1,0.3v4.1v4.1c0,0.9,0.1,1.6,0.4,2.3c0.3,0.7,0.6,1.3,1.2,1.8c0.5,0.5,1.1,0.9,1.8,1.1
                     c0.7,0.3,1.4,0.4,2.3,0.4H24h0.5c0.8,0,1.5-0.1,2.1-0.4c0.6-0.3,1-0.7,1.3-1.2H28h0.1v3.4v3.4c0,0.2,0.1,0.4,0.2,0.5
                     s0.3,0.2,0.5,0.2h1h1c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5V29v-9.5c0-0.1,0-0.3,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1
                     h1.2h1.2c0.2,0,0.4-0.1,0.5-0.2s0.2-0.3,0.2-0.5v-0.8v-0.8c0-0.2-0.1-0.4-0.2-0.5S34.5,16.1,34.3,16.1z"
                          />
                        </g>
                        <g id="Group-4" transform="translate(57.462185, 14.799999)">
                          <g id="Group-3">
                            <path
                              id="Fill-2"
                              d="M2.6,7.8h3.3c0.9,0,1.6-0.2,2.1-0.7C8.4,6.6,8.7,6,8.7,5.2S8.5,3.8,8,3.3C7.5,2.9,6.9,2.6,5.9,2.6H2.6
                       V7.8z M2.6,9.2v5.3H0.9V1.2h5c1.4,0,2.5,0.4,3.3,1.1s1.1,1.7,1.1,2.9S9.9,7.4,9.2,8.1C8.4,8.8,7.3,9.2,5.9,9.2H2.6z"
                            />
                            <path
                              id="Fill-4"
                              d="M14.1,6L14.1,6c0.4-0.5,0.8-0.9,1.3-1.1c0.5-0.3,1-0.4,1.7-0.4c1.1,0,1.9,0.3,2.4,0.9
                       C20.1,6,20.3,7,20.3,8.3v6.2h-1.7V8.3c0-0.9-0.2-1.5-0.5-1.9c-0.4-0.4-0.9-0.6-1.6-0.6c-0.5,0-1,0.1-1.4,0.4
                       c-0.4,0.2-0.7,0.6-1,1v7.2h-1.7V0.3h1.7C14.1,0.3,14.1,6,14.1,6z"
                            />
                            <path
                              id="Fill-6"
                              d="M24.2,9.7c0,1.1,0.2,1.9,0.7,2.6s1.1,1,2,1s1.6-0.3,2-1c0.5-0.7,0.7-1.5,0.7-2.6V9.5
                       c0-1.1-0.2-1.9-0.7-2.6s-1.1-1-2-1s-1.6,0.3-2,1s-0.7,1.6-0.7,2.6V9.7z M22.5,9.5c0-1.5,0.4-2.7,1.2-3.6
                       c0.8-0.9,1.8-1.4,3.2-1.4c1.4,0,2.5,0.5,3.2,1.4c0.8,0.9,1.2,2.1,1.2,3.6v0.2c0,1.5-0.4,2.7-1.2,3.6
                       c-0.8,0.9-1.8,1.4-3.2,1.4c-1.4,0-2.5-0.5-3.2-1.4c-0.8-0.9-1.2-2.1-1.2-3.6V9.5z"
                            />
                            <path
                              id="Fill-8"
                              d="M35,4.6l0.1,1.5l0,0c0.3-0.5,0.7-0.9,1.2-1.2s1.1-0.4,1.7-0.4c1.1,0,1.9,0.3,2.5,0.9
                       C41,6,41.3,6.9,41.3,8.3v6.2h-1.7V8.3c0-0.9-0.2-1.5-0.5-1.9s-0.9-0.5-1.6-0.5c-0.5,0-1,0.1-1.4,0.4s-0.7,0.6-1,1.1v7.1
                       h-1.7V4.6H35z"
                            />
                            <path
                              id="Fill-10"
                              d="M47.7,5.8c-0.6,0-1.2,0.3-1.6,0.8c-0.4,0.5-0.7,1.2-0.8,2H50V8.4c0-0.7-0.2-1.3-0.6-1.8
                       C49.1,6.1,48.5,5.8,47.7,5.8 M48,14.7c-1.4,0-2.5-0.4-3.3-1.3c-0.8-0.9-1.2-2.1-1.2-3.6V9.4c0-1.4,0.4-2.6,1.2-3.5
                       s1.8-1.4,3-1.4c1.3,0,2.3,0.4,3,1.2s1,1.9,1,3.2V10h-6.5c0,1,0.3,1.8,0.7,2.4c0.5,0.6,1.1,0.9,2,0.9c0.6,0,1.1-0.1,1.6-0.3
                       c0.4-0.2,0.8-0.4,1.2-0.7l0.7,1.1C51,13.8,50.6,14,50,14.3C49.5,14.6,48.8,14.7,48,14.7"
                            />
                            <path
                              id="Fill-12"
                              d="M55.7,7.8H59c0.9,0,1.6-0.2,2.1-0.7c0.4-0.5,0.7-1.1,0.7-1.9s-0.2-1.4-0.7-1.9C60.6,2.9,60,2.6,59,2.6
                       h-3.3V7.8z M55.7,9.2v5.3H54V1.2h5c1.4,0,2.5,0.4,3.3,1.1s1.1,1.7,1.1,2.9S63,7.4,62.3,8.1c-0.8,0.7-1.9,1.1-3.3,1.1
                       C59,9.2,55.7,9.2,55.7,9.2z"
                            />
                            <path
                              id="Fill-14"
                              d="M69.2,5.8c-0.6,0-1.2,0.3-1.6,0.8s-0.7,1.2-0.8,2h4.8V8.4c0-0.7-0.2-1.3-0.6-1.8
                       C70.5,6.1,69.9,5.8,69.2,5.8 M69.4,14.7c-1.4,0-2.5-0.4-3.3-1.3c-0.8-0.9-1.2-2.1-1.2-3.6V9.4c0-1.4,0.4-2.6,1.2-3.5
                       c0.8-0.9,1.8-1.4,3-1.4c1.3,0,2.3,0.4,3,1.2s1,1.9,1,3.2V10h-6.5c0,1,0.3,1.8,0.7,2.4c0.5,0.6,1.1,0.9,2,0.9
                       c0.6,0,1.1-0.1,1.6-0.3c0.4-0.2,0.8-0.4,1.2-0.7l0.7,1.1c-0.4,0.4-0.8,0.6-1.4,0.9C71,14.6,70.3,14.7,69.4,14.7"
                            />
                          </g>
                          <g id="Group-2" transform="translate(0.000000, 20.507066)">
                            <polygon id="Fill-20" points="0.5,4.1 1.2,4.1 1.2,0.5 0.5,0.5 								" />
                            <polygon
                              id="Fill-22"
                              points="5.8,4.1 5.1,4.1 3.4,1.5 3.4,4.1 2.8,4.1 2.8,0.5 3.4,0.5 5.1,3.1 5.1,0.5 5.8,0.5 								
                       "
                            />
                            <path
                              id="Fill-23"
                              d="M8,1v2.6h0.4c0.2,0,0.3,0,0.5-0.1C9,3.4,9.2,3.4,9.2,3.3c0.1-0.1,0.2-0.2,0.2-0.4s0.1-0.3,0.1-0.5V2.2
                       c0-0.4-0.1-0.7-0.3-0.9C9.1,1.1,8.8,1,8.5,1H8z M7.4,4.1V0.5h1.1c0.3,0,0.5,0,0.7,0.1S9.6,0.8,9.7,1
                       c0.2,0.2,0.3,0.3,0.4,0.5c0.1,0.2,0.1,0.4,0.1,0.7v0.2c0,0.3,0,0.5-0.1,0.7C10,3.3,9.9,3.5,9.7,3.6C9.6,3.8,9.4,3.9,9.2,4
                       S8.7,4.1,8.5,4.1H7.4z"
                            />
                            <polygon id="Fill-24" points="11.7,4.1 12.4,4.1 12.4,0.5 11.7,0.5 								" />
                            <path
                              id="Fill-25"
                              d="M14.8,2.8H16l-0.6-1.5L14.8,2.8z M16.1,3.3h-1.5l-0.3,0.8h-0.7L15,0.5h0.6L17,4.1h-0.7L16.1,3.3z"
                            />
                            <polygon id="Fill-26" points="18.4,0.6 18.3,1.6 17.9,1.6 17.9,0.3 18.4,0.3 								" />
                            <path
                              id="Fill-27"
                              d="M21.7,3.2c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1S21.2,2.6,21,2.6
                       c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2-0.1-0.3-0.1-0.4-0.2C20,2.1,19.9,2,19.8,1.9s-0.1-0.2-0.1-0.4c0-0.1,0-0.3,0.1-0.4
                       s0.2-0.2,0.3-0.3s0.3-0.2,0.4-0.2c0.2,0,0.4-0.1,0.6-0.1s0.4,0,0.6,0.1s0.3,0.1,0.4,0.2s0.2,0.2,0.3,0.4
                       c0.1,0.1,0.1,0.3,0.1,0.4h-0.7c0-0.1,0-0.2,0-0.2c0-0.1-0.1-0.1-0.1-0.2C21.5,1.1,21.4,1,21.3,1S21.1,1,21,1s-0.2,0-0.3,0
                       c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0-0.1,0.1-0.1,0.2s0,0.1,0,0.2s0.1,0.2,0.2,0.3C20.7,1.9,20.9,2,21.1,2
                       c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0.1,0.3,0.2,0.4,0.2c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.1,0.1,0.2,0.1,0.4s0,0.3-0.1,0.4
                       c-0.1,0.1-0.2,0.2-0.3,0.3C21.9,4,21.8,4,21.6,4.1c-0.2,0-0.4,0.1-0.6,0.1s-0.4,0-0.5-0.1C20.3,4,20.1,4,20,3.9
                       s-0.3-0.2-0.3-0.4c-0.1-0.1-0.1-0.3-0.1-0.5h0.7c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.1
                       c0.1,0,0.2,0,0.3,0c0.2,0,0.4,0,0.5-0.1C21.7,3.4,21.7,3.3,21.7,3.2"
                            />
                            <path
                              id="Fill-28"
                              d="M26.5,2.3h0.8c0.1,0,0.2,0,0.3,0c0.1,0,0.2-0.1,0.2-0.1C28,2,28,2,28,1.9s0-0.2,0-0.2
                       c0-0.1,0-0.2,0-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1C27.6,1,27.5,1,27.3,1h-0.8V2.3z M26.5,2.8v1.3h-0.7V0.5
                       h1.5c0.2,0,0.4,0,0.6,0.1s0.3,0.1,0.4,0.2s0.2,0.2,0.3,0.4s0.1,0.3,0.1,0.5s0,0.3-0.1,0.5c-0.1,0.1-0.2,0.3-0.3,0.4
                       c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0.1-0.4,0.1-0.6,0.1h-0.8V2.8z"
                            />
                            <path
                              id="Fill-29"
                              d="M30.5,2.8h1.1L31,1.3L30.5,2.8z M31.8,3.3h-1.5L30,4.1h-0.7l1.4-3.6h0.6l1.4,3.6H32L31.8,3.3z"
                            />
                            <polygon
                              id="Fill-30"
                              points="34.8,2.2 35.7,0.5 36.5,0.5 35.2,2.8 35.2,4.1 34.5,4.1 34.5,2.8 33.2,0.5 34,0.5 								"
                            />
                            <polygon
                              id="Fill-31"
                              points="38.5,0.5 39.6,3.3 40.7,0.5 41.6,0.5 41.6,4.1 40.9,4.1 40.9,2.9 41,1.3 39.8,4.1 39.4,4.1 
                       38.2,1.3 38.3,2.9 38.3,4.1 37.6,4.1 37.6,0.5 								"
                            />
                            <polygon
                              id="Fill-32"
                              points="45.4,2.5 43.8,2.5 43.8,3.6 45.6,3.6 45.6,4.1 43.1,4.1 43.1,0.5 45.6,0.5 45.6,1 43.8,1 
                       43.8,2 45.4,2 								"
                            />
                            <polygon
                              id="Fill-33"
                              points="50,4.1 49.3,4.1 47.6,1.5 47.6,4.1 47,4.1 47,0.5 47.6,0.5 49.3,3.1 49.3,0.5 50,0.5 								
                       "
                            />
                            <polygon
                              id="Fill-34"
                              points="54.3,1 53.1,1 53.1,4.1 52.4,4.1 52.4,1 51.2,1 51.2,0.5 54.3,0.5 								"
                            />
                            <path
                              id="Fill-35"
                              d="M57.5,3.2c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2-0.1-0.4-0.1
                       c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.1-0.2-0.1-0.4
                       c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.2,0.3-0.3s0.3-0.2,0.4-0.2c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.6,0.1
                       c0.2,0.1,0.3,0.1,0.4,0.2c0,0.1,0.1,0.2,0.2,0.3s0.1,0.3,0.1,0.4h-0.7c0-0.1,0-0.2,0-0.2c0-0.1-0.1-0.1-0.1-0.2
                       c-0.1,0-0.2-0.1-0.3-0.1s-0.2,0-0.3,0s-0.2,0-0.3,0s-0.2,0.1-0.2,0.1c-0.1,0-0.1,0.1-0.1,0.2s0,0.1,0,0.2s0.1,0.2,0.2,0.3
                       c0,0.1,0.2,0.2,0.5,0.2c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0.1,0.3,0.2,0.4,0.2c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.1,0.1,0.2,0.1,0.4
                       s0,0.3-0.1,0.4c-0.1,0.1-0.2,0.2-0.3,0.3C57.7,4,57.5,4,57.4,4.1c-0.2,0-0.4,0.1-0.6,0.1c-0.2,0-0.4,0-0.5-0.1
                       c-0.2,0-0.3-0.1-0.5-0.2c-0.1-0.1-0.3-0.2-0.3-0.4c-0.1-0.1-0.1-0.3-0.1-0.5H56c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.1,0.2,0.2
                       c0.1,0.1,0.2,0.1,0.3,0.1s0.2,0,0.3,0c0.2,0,0.4,0,0.5-0.1C57.4,3.4,57.5,3.3,57.5,3.2"
                            />
                            <path
                              id="Fill-36"
                              d="M62.5,2.8h1.1L63,1.3L62.5,2.8z M63.8,3.3h-1.5L62,4.1h-0.7l1.4-3.6h0.6l1.4,3.6H64L63.8,3.3z"
                            />
                            <path
                              id="Fill-37"
                              d="M66.7,2.3h0.8c0.1,0,0.2,0,0.3,0c0.1,0,0.2-0.1,0.2-0.1C68.1,2,68.1,2,68.1,1.9s0-0.2,0-0.2
                       c0-0.1,0-0.2,0-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1C67.7,1,67.6,1,67.5,1h-0.8V2.3z M66.7,2.8v1.3H66V0.5
                       h1.5c0.2,0,0.4,0,0.6,0.1s0.3,0.1,0.4,0.2s0.2,0.2,0.3,0.4c0.1,0.1,0.1,0.3,0.1,0.5s0,0.3-0.1,0.5c-0.1,0.1-0.2,0.3-0.3,0.4
                       c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0.1-0.4,0.1-0.6,0.1h-0.8V2.8z"
                            />
                            <path
                              id="Fill-38"
                              d="M70.9,2.3h0.8c0.1,0,0.2,0,0.3,0c0.1,0,0.2-0.1,0.2-0.1C72.3,2,72.3,2,72.4,1.9c0-0.1,0-0.2,0-0.2
                       c0-0.1,0-0.2,0-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1C71.9,1,71.8,1,71.7,1h-0.8C70.9,1,70.9,2.3,70.9,2.3z
                        M70.9,2.8v1.3h-0.7V0.5h1.5c0.2,0,0.4,0,0.6,0.1s0.3,0.1,0.4,0.2S72.9,1,73,1.2c0.1,0.1,0.1,0.3,0.1,0.5s0,0.3-0.1,0.5
                       c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0.1-0.4,0.1-0.6,0.1h-0.8C70.9,2.9,70.9,2.8,70.9,2.8z"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g>
              <g>
                <g>
                  <g>
                    <g>
                      <path
                        fill="#673AB7"
                        d="M16.6,7.4C7.4,7.4,0,14.9,0,24c0,9.1,7.4,16.6,16.6,16.6S33.1,33.1,33.1,24C33.1,14.9,25.7,7.4,16.6,7.4z"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <g>
                        <path
                          fill="#FFFFFF"
                          d="M23.4,18.9h-3l-1.6-2.7l-2.5-4.3c-0.1-0.1-0.2-0.2-0.4-0.2h-2.1c-0.3,0-0.5,0.3-0.4,0.6l4.9,6.6H9.7
                   c-0.2,0-0.4,0.2-0.4,0.4v1.9c0,0.2,0.2,0.4,0.4,0.4h2v5c0,0.8,0.2,1.5,0.5,2.2c0.8,1.6,2.5,2.7,4.4,2.7c0.8,0,1.5-0.2,2.2-0.5
                   v4c0,0.2,0.2,0.4,0.4,0.4H21c0.2,0,0.4-0.2,0.4-0.4V21.6h1.9c0.2,0,0.4-0.2,0.4-0.4v-1.9C23.8,19.1,23.6,18.9,23.4,18.9z
                    M18.8,26.6c0,1.2-1,2.2-2.2,2.2c-1.2,0-2.2-1-2.2-2.2v-5h4.4V26.6z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g>
                <g>
                  <path
                    fill="#673AB7"
                    d="M47.7,26.3v6.3h-2.1V16.5h6c1.8,0,3.1,0.5,4.1,1.4c1,0.9,1.5,2.1,1.5,3.6c0,1.6-0.5,2.8-1.5,3.6
             c-1,0.8-2.4,1.3-4.2,1.3H47.7z M47.7,24.6h3.8c1.1,0,2-0.3,2.6-0.8c0.6-0.5,0.9-1.3,0.9-2.3c0-1-0.3-1.7-0.9-2.3
             c-0.6-0.6-1.4-0.9-2.5-0.9h-3.9V24.6z"
                  />
                </g>
                <g>
                  <path
                    fill="#673AB7"
                    d="M61.3,22.1c0.9-1.1,2.1-1.7,3.5-1.7c2.5,0,3.8,1.4,3.8,4.3v7.9h-2v-7.9c0-0.9-0.2-1.5-0.6-1.9
             c-0.4-0.4-1-0.6-1.8-0.6c-0.7,0-1.2,0.2-1.8,0.5c-0.5,0.4-0.9,0.8-1.2,1.4v8.5h-2v-17h2V22.1z"
                  />
                </g>
                <g>
                  <path
                    fill="#673AB7"
                    d="M71,26.3c0-1.2,0.2-2.2,0.7-3.2c0.5-0.9,1.1-1.7,1.9-2.2c0.8-0.5,1.8-0.8,2.8-0.8c1.6,0,3,0.6,4,1.7
             c1,1.1,1.5,2.6,1.5,4.5v0.1c0,1.2-0.2,2.2-0.7,3.1c-0.4,0.9-1.1,1.6-1.9,2.2c-0.8,0.5-1.8,0.8-2.9,0.8c-1.6,0-2.9-0.6-4-1.7
             c-1-1.1-1.5-2.6-1.5-4.5V26.3z M73,26.6c0,1.3,0.3,2.4,0.9,3.2c0.6,0.8,1.4,1.2,2.5,1.2c1,0,1.9-0.4,2.5-1.2
             c0.6-0.8,0.9-2,0.9-3.4c0-1.3-0.3-2.4-0.9-3.2c-0.6-0.8-1.5-1.2-2.5-1.2c-1,0-1.8,0.4-2.4,1.2C73.3,23.9,73,25.1,73,26.6z"
                  />
                </g>
                <g>
                  <path
                    fill="#673AB7"
                    d="M86.2,20.7l0.1,1.5c0.9-1.2,2.1-1.7,3.6-1.7c2.5,0,3.8,1.4,3.8,4.3v7.9h-2v-7.9c0-0.9-0.2-1.5-0.6-1.9
             c-0.4-0.4-1-0.6-1.8-0.6c-0.7,0-1.2,0.2-1.8,0.5c-0.5,0.4-0.9,0.8-1.2,1.4v8.5h-2v-12H86.2z"
                  />
                </g>
                <g>
                  <path
                    fill="#673AB7"
                    d="M101.5,32.7c-1.6,0-2.9-0.5-4-1.6c-1-1.1-1.5-2.5-1.5-4.3v-0.4c0-1.2,0.2-2.3,0.7-3.2
             c0.5-0.9,1.1-1.7,1.9-2.2c0.8-0.5,1.7-0.8,2.7-0.8c1.6,0,2.8,0.5,3.6,1.5c0.9,1,1.3,2.5,1.3,4.4V27h-8.1c0,1.2,0.4,2.1,1,2.9
             c0.7,0.7,1.5,1.1,2.5,1.1c0.7,0,1.3-0.1,1.8-0.4c0.5-0.3,0.9-0.7,1.3-1.2l1.3,1C105,31.9,103.5,32.7,101.5,32.7z M101.3,21.9
             c-0.8,0-1.5,0.3-2.1,0.9c-0.6,0.6-0.9,1.4-1,2.5h6v-0.2c-0.1-1-0.3-1.8-0.8-2.4C102.8,22.2,102.1,21.9,101.3,21.9z"
                  />
                </g>
                <g>
                  <path
                    fill="#673AB7"
                    d="M110.9,26.3v6.3h-2.1V16.5h6c1.8,0,3.1,0.5,4.1,1.4c1,0.9,1.5,2.1,1.5,3.6c0,1.6-0.5,2.8-1.5,3.6
             c-1,0.8-2.4,1.3-4.2,1.3H110.9z M110.9,24.6h3.8c1.1,0,2-0.3,2.6-0.8c0.6-0.5,0.9-1.3,0.9-2.3c0-1-0.3-1.7-0.9-2.3
             c-0.6-0.6-1.4-0.9-2.5-0.9h-3.9V24.6z"
                  />
                </g>
                <g>
                  <path
                    fill="#673AB7"
                    d="M127.3,32.7c-1.6,0-2.9-0.5-4-1.6c-1-1.1-1.5-2.5-1.5-4.3v-0.4c0-1.2,0.2-2.3,0.7-3.2
             c0.5-0.9,1.1-1.7,1.9-2.2c0.8-0.5,1.7-0.8,2.7-0.8c1.6,0,2.8,0.5,3.6,1.5c0.9,1,1.3,2.5,1.3,4.4V27h-8.1c0,1.2,0.4,2.1,1,2.9
             c0.7,0.7,1.5,1.1,2.5,1.1c0.7,0,1.3-0.1,1.8-0.4c0.5-0.3,0.9-0.7,1.3-1.2l1.3,1C130.8,31.9,129.3,32.7,127.3,32.7z M127.1,21.9
             c-0.8,0-1.5,0.3-2.1,0.9c-0.6,0.6-0.9,1.4-1,2.5h6v-0.2c-0.1-1-0.3-1.8-0.8-2.4C128.6,22.2,127.9,21.9,127.1,21.9z"
                  />
                </g>
              </g>
            </g>
          </svg>
        )
      },
      dental: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
            <g fill="none" fillRule="evenodd">
              <path
                fill="#D7E9FF"
                d="M13.607 42.652c-3.011-3.08-3.623-14.02-3.51-19.999.038-1.98-1.152-4.671-2.411-7.52-1.16-2.622-2.358-5.334-2.358-7.111 0-2.435.628-4.531 1.744-6.142-3.543 1.19-5.768 4.579-5.768 9.171 0 1.777 1.198 4.489 2.357 7.111 1.26 2.85 2.449 5.54 2.411 7.52-.113 5.98.499 16.92 3.51 20 .505.517 1.04.768 1.634.768.072 0 .743-.083 2.043-2.943.121-.267.243-.547.366-.837l-.018-.018M34.185 40.523c-.747-1.671-1.529-3.849-2.356-6.154-2.518-7.014-4.204-11.273-6.37-11.273-1.052 0-1.947 1.188-2.936 3.404 1.686 1.182 3.199 5.098 5.281 10.898.828 2.306 1.61 4.484 2.356 6.155 1.056 2.36 1.57 2.596 1.645 2.62 1.243-.009 2.304-1.437 3.118-4.165a17.142 17.142 0 0 1-.738-1.485"
              />
              <path
                fill="#4A4A4A"
                d="M4.77 25.656c-.026 1.326-.062 6.024.522 10.777.633 5.14 1.773 8.586 3.39 10.239.773.791 1.66 1.191 2.639 1.191 2.132 0 3.702-4.223 6.089-11.113.845-2.441 1.643-4.746 2.421-6.513 1.14-2.589 1.69-2.695 1.71-2.698.128 0 .837.146 2.193 3.026.947 2.013 1.915 4.707 2.85 7.312 2.29 6.38 3.567 9.709 5.316 9.709 2.437 0 4.123-2.62 5.157-8.01.8-4.169 1.045-9.098 1.207-12.36l.026-.505a.705.705 0 1 0-1.407-.071l-.026.506c-.16 3.222-.402 8.092-1.183 12.163-.86 4.48-2.16 6.853-3.763 6.863-.076-.022-.59-.258-1.645-2.619-.747-1.672-1.53-3.85-2.357-6.154-2.518-7.015-4.203-11.274-6.369-11.274-1.852 0-3.213 3.672-5.46 10.16-.894 2.58-1.817 5.247-2.716 7.222-1.3 2.86-1.971 2.943-2.043 2.943-.594 0-1.129-.251-1.634-.768-3.011-3.08-3.622-14.02-3.51-20 .038-1.98-1.152-4.67-2.41-7.52-1.16-2.622-2.358-5.334-2.358-7.11 0-5.765 3.505-9.638 8.721-9.638 1.357 0 3.46.668 5.495 1.314 2.233.71 4.341 1.38 5.915 1.38h.002c1.574 0 3.684-.668 5.917-1.375 2.033-.644 4.135-1.31 5.491-1.31 3.38 0 5.955 1.442 7.447 4.172.19.34.62.462.959.27a.708.708 0 0 0 .276-.95C39.903 1.753 36.82.01 32.95.01c-1.573 0-3.682.668-5.915 1.376-2.034.643-4.136 1.31-5.493 1.31h-.001c-1.357 0-3.459-.669-5.491-1.315C13.815.67 11.705 0 10.13 0 7.16 0 4.616 1.072 2.775 3.101.96 5.104 0 7.852 0 11.051c0 2.077 1.26 4.928 2.479 7.684 1.141 2.583 2.322 5.254 2.29 6.92"
              />
              <path
                fill="#1AE5BE"
                d="M35.836 26.103c-5.886 0-10.658-4.789-10.658-10.696S29.949 4.711 35.835 4.711 46.493 9.5 46.493 15.407c-.007 5.904-4.774 10.69-10.657 10.696m0-22.805c-6.664 0-12.067 5.421-12.067 12.109s5.402 12.11 12.066 12.11c6.664 0 12.066-5.422 12.066-12.11-.007-6.685-5.405-12.102-12.065-12.11"
              />
              <path
                fill="#1AE5BE"
                d="M40.657 16.46h-3.32a.706.706 0 0 0-.705.706V20.6h-1.81v-3.434a.706.706 0 0 0-.705-.707h-3.42v-1.817h3.42a.706.706 0 0 0 .704-.707v-3.332h1.811v3.332c0 .39.316.707.705.707h3.32v1.817zm.704-3.232h-3.32V9.896a.706.706 0 0 0-.704-.707h-3.22a.706.706 0 0 0-.704.707v3.332h-3.421a.706.706 0 0 0-.704.707v3.231c0 .39.315.707.704.707h3.42v3.433c0 .39.316.707.705.707h3.22a.706.706 0 0 0 .704-.707v-3.433h3.32a.706.706 0 0 0 .705-.707v-3.231a.706.706 0 0 0-.705-.707z"
              />
            </g>
          </svg>
        )
      },
      cosmetic: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="40"
            height="48"
            viewBox="0 0 40 48">
            <defs>
              <path id="a" d="M0 .216h27.754v47.45H0z" />
            </defs>
            <g fill="none" fillRule="evenodd">
              <path
                fill="#D7E9FF"
                d="M11.525 34.583c.115.12-.01.638-.01.788-.006.868.171 1.889-.378 2.643-.53.728-1.541.868-2.43 1.045a12.606 12.606 0 0 0-4.117 1.61c-.643.394-1.097.827-1.315 1.555-.469 1.57-.35 3.187-.35 4.803H1.083l-.273-3.31.722-2.47 1.246-1.458 3.985-1.828 2.69-.964.1-1.778.05-1.186.971-.436.952.986M15.015 15.462c-1.008 1.41-1.793 1.443-4.702 2.945 0 0-.098.038-.264.115-3.417 1.586-4.74 5.744-2.897 9.01 1.26 2.235 3.307 5.273 5.377 5.86l-1.787-.273a.23.23 0 0 1-.174-.028L5.174 29.71 3.42 24.757l.298-3.775 2.103-2.784 4.1-2.062 3.15-1.522 3.35-1.8-.8 1.622a7.407 7.407 0 0 1-.606 1.026"
              />
              <g transform="translate(0 .118)">
                <mask id="b" fill="#fff">
                  <use xlinkHref="#a" />
                </mask>
                <path
                  fill="#4A4A4A"
                  d="M24.687 12.843l-.273-.19a.704.704 0 0 0-.976.168.691.691 0 0 0 .169.969l1.462 1.02c.01.008.02.013.031.02l.023.014c1.84 1.054.997 5.068.16 6.884l-.484.1c-.945-3.37-2.724-7.219-7.488-9.287 1.688-1.367 3.433-3.232 3.68-5.377 2.517 1.131 3.437 3.475 3.696 5.68zm2.843 30.59a6.58 6.58 0 0 0-1.406-3.675.704.704 0 0 0-.984-.12.69.69 0 0 0-.121.976 5.208 5.208 0 0 1 1.112 2.906l.175 2.756H1.45l.175-2.757a5.208 5.208 0 0 1 1.799-3.626 5.35 5.35 0 0 1 2.222-1.149l3.787-.928c.503-.123.854-.568.854-1.081V34.05c1.242.497 2.485.75 3.59.75 1.142 0 2.36-.259 3.548-.728v2.65c0 .515.352.96.856 1.084l3.83.937c.324.08.644.191.953.332a.703.703 0 0 0 .93-.34.693.693 0 0 0-.343-.923 6.82 6.82 0 0 0-1.205-.419l-3.619-.886v-3.096a12.488 12.488 0 0 0 2.524-1.83.691.691 0 0 0 .026-.983.705.705 0 0 0-.991-.026 11.138 11.138 0 0 1-2.614 1.826c-1.286.646-2.647 1.011-3.894 1.011-1.92 0-4.212-.91-5.984-2.375-1.492-1.233-3.34-3.424-3.686-6.86.019-2.579 2.449-5.72 5.55-7.162 2.464-1.147 4.563-2.32 6.246-3.495 2.35.86 4.14 2.221 5.46 4.159 1.155 1.695 1.725 3.502 2.127 5.057.003.364 0 .691-.011.97a.698.698 0 0 0 .701.723.698.698 0 0 0 .7-.669c.007-.17.01-.354.012-.55l.58-.12c.433-.09.8-.382.984-.78.43-.931.965-2.613 1.061-4.29.11-1.925-.39-3.35-1.451-4.152-.075-2.455-.723-4.448-1.927-5.928-.86-1.055-1.975-1.826-3.32-2.298-.436-2.23-2.221-4.211-4.573-5.021-2.026-.698-6.197-1.09-11.37 4.115a.69.69 0 0 0 .007.983c.276.27.72.267.991-.007 4.633-4.662 8.199-4.368 9.912-3.778.489.168.929.39 1.32.651a5.78 5.78 0 0 0-1.354.118c-1.436.3-2.826 1.09-4.246 2.419a.691.691 0 0 0-.03.982.703.703 0 0 0 .991.03c1.228-1.148 2.397-1.825 3.574-2.07 1.01-.212 2.06-.056 2.845.414.343.599.547 1.216.608 1.77a3.496 3.496 0 0 1 .017.586c-.084 1.422-1.127 2.954-3.105 4.565-.317.258-.658.52-1.023.781v.001c-1.66 1.194-3.787 2.396-6.322 3.575-3.467 1.614-6.117 5.008-6.342 8.043-.297-.154-.663-.433-.752-.605-.666-2.734-1.773-9.66 2.167-15.388a.692.692 0 0 0-.184-.966.704.704 0 0 0-.973.183C-1.19 13.224 0 20.64.71 23.54c.186.756 1.351 1.621 2.24 1.74.707 3.85 3.193 6.58 5.934 8.104v3.134l-3.575.876a6.752 6.752 0 0 0-2.81 1.452 6.584 6.584 0 0 0-2.274 4.585l-.222 3.496a.691.691 0 0 0 .188.52c.133.14.317.219.511.219h26.35c.193 0 .378-.08.51-.22.133-.14.201-.328.19-.52l-.223-3.495z"
                  mask="url(#b)"
                />
              </g>
              <path
                fill="#1AE5BE"
                d="M34.489 44.912l-.241-.285 3.936-3.276.241.285-3.936 3.276zM22.78 26.63l.525.62c.182.215.358.21 1.02.496.153.06.289.158.395.283l.461.546-1.362 1.134c-.36-.46-.595-.603-.675-.98l-.166-.779c-.059-.276-.222-.36-.674-.924l.476-.396zm1.054 4.881l3.134-2.608 1.765 2.085-3.134 2.608-1.765-2.085zm8.207 9.699l-1.167-1.379.903-.751a.691.691 0 0 0 .086-.98.705.705 0 0 0-.987-.085l-.903.751-1.406-1.662.903-.751a.691.691 0 0 0 .087-.98.705.705 0 0 0-.988-.085l-.903.751-1.167-1.378 3.135-2.608 5.541 6.549-3.134 2.608zm7.703-.18l-.73-.863a1.026 1.026 0 0 0-1.44-.124l-1.722 1.433-.806-.952 1.567-1.304 1.412-1.175a.69.69 0 0 0 .086-.979.705.705 0 0 0-.987-.085l-.875.727-5.991-7.08v-.001l-2.327-2.749a1.234 1.234 0 0 0-1.673-.194c-.343-.355-.624-.915-1.409-1.228l-.582-.232-.677-.8a.997.997 0 0 0-1.395-.122l-.017.014-1.996-2.359a.705.705 0 0 0-.988-.086.69.69 0 0 0-.086.98l1.996 2.359-.016.014a.978.978 0 0 0-.122 1.383l.677.8.13.61c.174.822.674 1.182.974 1.588a1.206 1.206 0 0 0-.098 1.669l6.7 7.918h.001v.001l1.617 1.91-.874.728a.69.69 0 0 0-.087.98.7.7 0 0 0 .537.248c.455 0 .386-.183 3.43-2.641l.805.952-1.723 1.434c-.431.359-.488.998-.126 1.426.612.637.774 1.165 1.424 1.222a1.031 1.031 0 0 0 .745-.233l4.52-3.761c.431-.36.488-.999.126-1.427z"
              />
            </g>
          </svg>
        )
      },
      editPencil: () => {
        return (
          <svg
            id="round-edit-24px_1_"
            data-name="round-edit-24px (1)"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20">
            <path id="Path_605" data-name="Path 605" d="M0,0H20V20H0Z" fill="none" />
            <path
              id="Path_606"
              data-name="Path 606"
              d="M3,14.247v2.365A.385.385,0,0,0,3.389,17H5.753a.365.365,0,0,0,.272-.117L14.519,8.4,11.6,5.481,3.117,13.967a.382.382,0,0,0-.117.28Zm13.775-8.1a.775.775,0,0,0,0-1.1l-1.82-1.82a.775.775,0,0,0-1.1,0L12.435,4.648l2.917,2.917,1.423-1.423Z"
              fill={fill ? fill : '#436AB2'}
            />
          </svg>
        )
      },
      maternity: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="56"
            height="48"
            viewBox="0 0 56 48">
            <defs>
              <path id="a" d="M0 .415h25.08v33.409H0z" />
            </defs>
            <g fill="none" fillRule="evenodd">
              <path
                fill="#D7E9FF"
                fillOpacity=".233"
                d="M13.721 10.55c.215.314 3.5-.608 3.715-.294.36.527.834 2.255 0 2.32-2.35.18-3.357-.184-4.763.821-1.137.813-1.432 2.352-1.413 3.732.011.874.128 1.791.642 2.505.36.502.902.881 1.156 1.442.242.533.186 1.143.164 1.726-.122 3.3 1.167 6.67 3.598 8.967 1.371 1.296 3.025 2.279 4.762 3.043 1.276.563 2.736 1.131 4.151 1.167-1.603.152-3.205.419-4.802.631l-4.269-1.753-3.274-3.454-1.782-4.108-.346-5.857-2.473-4.31.472-4.477 4.336-2.888.126.788z"
              />
              <path
                fill="#1AE5BE"
                d="M30.729 22.8l.354-.697a3.161 3.161 0 0 1 3.476-1.293 3.18 3.18 0 0 1 2.202 2.136l.814 2.628c.18.584-.121 1.204-.673 1.382a1.061 1.061 0 0 1-1.302-.597l-.62-2.004a1.06 1.06 0 0 0-1.33-.701c-.56.175-.873.773-.698 1.335l.637 2.056c.962 3.119-.444 6.416-3.342 7.84-.576.282-1.18.522-1.798.712-6.121 1.875-12.975-1.702-14.966-7.812a12.127 12.127 0 0 1-.591-4.272c.048-1.177-.405-2.356-1.245-3.234a5.37 5.37 0 0 1-1.29-2.252c-.824-2.862.822-5.875 3.67-6.716a5.82 5.82 0 0 1 1.642-.232c1.129 0 2.26.314 3.177.911.727.473 1.632 1.333 1.822 2.743.09.661.058 1.047.022 1.495-.043.543-.092 1.158.058 2.199.087.599-.03.721-.752 1.358-.197.175-.422.374-.655.604l-.008.008-.013.013a2.019 2.019 0 0 0-.465 2.183 1.985 1.985 0 0 0 1.811 1.261l3.644.073a1.71 1.71 0 0 0 1.556-.936l1.536-3.029c.129-.254.348-.442.618-.53a1.059 1.059 0 0 1 1.338.685c.087.272.065.56-.064.814l-.054.107a5.373 5.373 0 0 0-.449.884l-1.033 2.038a3.872 3.872 0 0 1-2.288 1.928c-.392.123-.796.18-1.202.173l-4.591-.093a1.062 1.062 0 0 0-1.083 1.045 1.065 1.065 0 0 0 1.04 1.088l4.591.093a5.898 5.898 0 0 0 1.877-.268 6.023 6.023 0 0 0 2.746-1.805l.748 2.414a1.061 1.061 0 1 0 2.028-.634l-.946-3.052a3.219 3.219 0 0 1 .051-2.049m-9.33-1.412c.48-.425 1-.884 1.283-1.567a1.836 1.836 0 0 1 1.854 1.094l-.443.873-3.071-.06c.127-.12.253-.231.377-.34m8.438-3.769l-.042-.024a3.15 3.15 0 0 0-2.43-.193 3.161 3.161 0 0 0-1.75 1.403 4 4 0 0 0-.92-.668 3.93 3.93 0 0 0-1.898-.458 6.638 6.638 0 0 1 .01-1.28 8.189 8.189 0 0 0-.034-1.952c-.234-1.726-1.218-3.235-2.771-4.247-1.875-1.222-4.394-1.58-6.574-.936-3.966 1.172-6.258 5.368-5.11 9.356a7.598 7.598 0 0 0 1.799 3.138c.44.46.678 1.068.653 1.666-.07 1.702.164 3.393.696 5.025 1.14 3.495 3.614 6.384 6.97 8.135 2.1 1.097 4.365 1.654 6.625 1.653 1.35 0 2.699-.199 4.008-.6a14.366 14.366 0 0 0 2.111-.835 8.633 8.633 0 0 0 4.128-4.37 8.766 8.766 0 0 0 .698-3.343 3.16 3.16 0 0 0 1.548-.102c1.655-.536 2.574-2.352 2.049-4.047l-.815-2.629a5.298 5.298 0 0 0-3.669-3.56 5.264 5.264 0 0 0-3.327.174M13.317 35.323l-.034-.032a1.203 1.203 0 0 0-1.7.092 1.207 1.207 0 0 0 .092 1.701l.034.031a1.201 1.201 0 0 0 1.7-.092 1.205 1.205 0 0 0-.092-1.7"
              />
              <g transform="translate(.7)">
                <mask id="b" fill="#fff">
                  <use xlinkHref="#a" />
                </mask>
                <path
                  fill="#4A4A4A"
                  d="M24.586 2.822A15.997 15.997 0 0 0 16.14.415C7.239.415-.001 7.721-.001 16.7c0 5.67 2.589 11.318 7.694 16.787.208.224.493.337.779.337.256 0 .513-.091.716-.275.43-.39.459-1.05.063-1.474C4.517 27.004 2.116 21.83 2.116 16.7 2.116 8.87 8.407 2.5 16.14 2.5c2.59 0 5.122.721 7.319 2.086a1.067 1.067 0 0 0 1.46-.327 1.034 1.034 0 0 0-.332-1.438"
                  mask="url(#b)"
                />
              </g>
              <path
                fill="#FFF"
                d="M38.528 5.695a1.22 1.22 0 0 0 0 2.44h.007c.673 0 1.215-.546 1.215-1.22 0-.673-.548-1.22-1.222-1.22"
              />
              <path
                fill="#FF7676"
                d="M48.231 10.03a11.538 11.538 0 0 0-5.378-4.263 1.086 1.086 0 0 0-.779 2.028c3.637 1.397 6.081 5.021 6.081 9.017a1.086 1.086 0 1 0 2.172 0c0-2.444-.725-4.79-2.096-6.782"
              />
              <path
                fill="#4A4A4A"
                d="M32.359 19.5c.77-4.198-.744-6.232-1.983-7.897-.623-.835-1.16-1.557-1.29-2.443-.378-2.541 2.401-4.02 2.516-4.08.028-.014.054-.029.08-.046a13.81 13.81 0 0 1 7.341-2.11c7.754 0 14.063 6.447 14.063 14.37 0 8.695-6.866 16.002-12.626 20.6-5.393 4.306-10.857 7.111-12.425 7.88-1.508-.74-6.613-3.358-11.79-7.38a1.066 1.066 0 0 0-1.49.183c-.36.46-.279 1.123.183 1.481 6.341 4.926 12.397 7.728 12.652 7.845a1.062 1.062 0 0 0 .889 0c.272-.124 6.722-3.11 13.276-8.334 3.873-3.089 6.966-6.318 9.192-9.598 2.827-4.168 4.261-8.433 4.261-12.676 0-9.088-7.26-16.481-16.185-16.481-2.987 0-5.904.834-8.44 2.414-.485.261-4.17 2.38-3.599 6.24.21 1.41.96 2.417 1.685 3.392 1.024 1.374 2.001 2.688 1.735 5.347-.015-.007-.029-.016-.043-.024"
              />
            </g>
          </svg>
        )
      },
      amazonPay: () => {
        return (
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="amazon-pay"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 512"
            width={width ? width : 48}
            height={height ? height : 48}
            >
            <path
              fill="rgb(247,156,52)"
              d="M14 325.3c2.3-4.2 5.2-4.9 9.7-2.5 10.4 5.6 20.6 11.4 31.2 16.7a595.88 595.88 0 0 0 127.4 46.3 616.61 616.61 0 0 0 63.2 11.8 603.33 603.33 0 0 0 95 5.2c17.4-.4 34.8-1.8 52.1-3.8a603.66 603.66 0 0 0 163.3-42.8c2.9-1.2 5.9-2 9.1-1.2 6.7 1.8 9 9 4.1 13.9a70 70 0 0 1-9.6 7.4c-30.7 21.1-64.2 36.4-99.6 47.9a473.31 473.31 0 0 1-75.1 17.6 431 431 0 0 1-53.2 4.8 21.3 21.3 0 0 0-2.5.3H308a21.3 21.3 0 0 0-2.5-.3c-3.6-.2-7.2-.3-10.7-.4a426.3 426.3 0 0 1-50.4-5.3A448.4 448.4 0 0 1 164 420a443.33 443.33 0 0 1-145.6-87c-1.8-1.6-3-3.8-4.4-5.7zM172 65.1l-4.3.6a80.92 80.92 0 0 0-38 15.1c-2.4 1.7-4.6 3.5-7.1 5.4a4.29 4.29 0 0 1-.4-1.4c-.4-2.7-.8-5.5-1.3-8.2-.7-4.6-3-6.6-7.6-6.6h-11.5c-6.9 0-8.2 1.3-8.2 8.2v209.3c0 1 0 2 .1 3 .2 3 2 4.9 4.9 5 7 .1 14.1.1 21.1 0 2.9 0 4.7-2 5-5 .1-1 .1-2 .1-3v-72.4c1.1.9 1.7 1.4 2.2 1.9 17.9 14.9 38.5 19.8 61 15.4 20.4-4 34.6-16.5 43.8-34.9 7-13.9 9.9-28.7 10.3-44.1.5-17.1-1.2-33.9-8.1-49.8-8.5-19.6-22.6-32.5-43.9-36.9-3.2-.7-6.5-1-9.8-1.5-2.8-.1-5.5-.1-8.3-.1zM124.6 107a3.48 3.48 0 0 1 1.7-3.3c13.7-9.5 28.8-14.5 45.6-13.2 14.9 1.1 27.1 8.4 33.5 25.9 3.9 10.7 4.9 21.8 4.9 33 0 10.4-.8 20.6-4 30.6-6.8 21.3-22.4 29.4-42.6 28.5-14-.6-26.2-6-37.4-13.9a3.57 3.57 0 0 1-1.7-3.3c.1-14.1 0-28.1 0-42.2s.1-28 0-42.1zm205.7-41.9c-1 .1-2 .3-2.9.4a148 148 0 0 0-28.9 4.1c-6.1 1.6-12 3.8-17.9 5.8-3.6 1.2-5.4 3.8-5.3 7.7.1 3.3-.1 6.6 0 9.9.1 4.8 2.1 6.1 6.8 4.9 7.8-2 15.6-4.2 23.5-5.7 12.3-2.3 24.7-3.3 37.2-1.4 6.5 1 12.6 2.9 16.8 8.4 3.7 4.8 5.1 10.5 5.3 16.4.3 8.3.2 16.6.3 24.9a7.84 7.84 0 0 1-.2 1.4c-.5-.1-.9 0-1.3-.1a180.56 180.56 0 0 0-32-4.9c-11.3-.6-22.5.1-33.3 3.9-12.9 4.5-23.3 12.3-29.4 24.9-4.7 9.8-5.4 20.2-3.9 30.7 2 14 9 24.8 21.4 31.7 11.9 6.6 24.8 7.4 37.9 5.4 15.1-2.3 28.5-8.7 40.3-18.4a7.36 7.36 0 0 1 1.6-1.1c.6 3.8 1.1 7.4 1.8 11 .6 3.1 2.5 5.1 5.4 5.2 5.4.1 10.9.1 16.3 0a4.84 4.84 0 0 0 4.8-4.7 26.2 26.2 0 0 0 .1-2.8v-106a80 80 0 0 0-.9-12.9c-1.9-12.9-7.4-23.5-19-30.4-6.7-4-14.1-6-21.8-7.1-3.6-.5-7.2-.8-10.8-1.3-3.9.1-7.9.1-11.9.1zm35 127.7a3.33 3.33 0 0 1-1.5 3c-11.2 8.1-23.5 13.5-37.4 14.9-5.7.6-11.4.4-16.8-1.8a20.08 20.08 0 0 1-12.4-13.3 32.9 32.9 0 0 1-.1-19.4c2.5-8.3 8.4-13 16.4-15.6a61.33 61.33 0 0 1 24.8-2.2c8.4.7 16.6 2.3 25 3.4 1.6.2 2.1 1 2.1 2.6-.1 4.8 0 9.5 0 14.3s-.2 9.4-.1 14.1zm259.9 129.4c-1-5-4.8-6.9-9.1-8.3a88.42 88.42 0 0 0-21-3.9 147.32 147.32 0 0 0-39.2 1.9c-14.3 2.7-27.9 7.3-40 15.6a13.75 13.75 0 0 0-3.7 3.5 5.11 5.11 0 0 0-.5 4c.4 1.5 2.1 1.9 3.6 1.8a16.2 16.2 0 0 0 2.2-.1c7.8-.8 15.5-1.7 23.3-2.5 11.4-1.1 22.9-1.8 34.3-.9a71.64 71.64 0 0 1 14.4 2.7c5.1 1.4 7.4 5.2 7.6 10.4.4 8-1.4 15.7-3.5 23.3-4.1 15.4-10 30.3-15.8 45.1a17.6 17.6 0 0 0-1 3c-.5 2.9 1.2 4.8 4.1 4.1a10.56 10.56 0 0 0 4.8-2.5 145.91 145.91 0 0 0 12.7-13.4c12.8-16.4 20.3-35.3 24.7-55.6.8-3.6 1.4-7.3 2.1-10.9v-17.3zM493.1 199q-19.35-53.55-38.7-107.2c-2-5.7-4.2-11.3-6.3-16.9-1.1-2.9-3.2-4.8-6.4-4.8-7.6-.1-15.2-.2-22.9-.1-2.5 0-3.7 2-3.2 4.5a43.1 43.1 0 0 0 1.9 6.1q29.4 72.75 59.1 145.5c1.7 4.1 2.1 7.6.2 11.8-3.3 7.3-5.9 15-9.3 22.3-3 6.5-8 11.4-15.2 13.3a42.13 42.13 0 0 1-15.4 1.1c-2.5-.2-5-.8-7.5-1-3.4-.2-5.1 1.3-5.2 4.8q-.15 5 0 9.9c.1 5.5 2 8 7.4 8.9a108.18 108.18 0 0 0 16.9 2c17.1.4 30.7-6.5 39.5-21.4a131.63 131.63 0 0 0 9.2-18.4q35.55-89.7 70.6-179.6a26.62 26.62 0 0 0 1.6-5.5c.4-2.8-.9-4.4-3.7-4.4-6.6-.1-13.3 0-19.9 0a7.54 7.54 0 0 0-7.7 5.2c-.5 1.4-1.1 2.7-1.6 4.1l-34.8 100c-2.5 7.2-5.1 14.5-7.7 22.2-.4-1.1-.6-1.7-.9-2.4z"
            />
          </svg>
        )
      },
      upload: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="24"
            height="24"
            viewBox="0 0 24 24">
            <defs>
              <path
                id="a"
                d="M10 16.296h4c.55 0 1-.45 1-1v-5h1.59c.89 0 1.34-1.08.71-1.71l-4.59-4.59a.996.996 0 0 0-1.41 0l-4.59 4.59c-.63.63-.19 1.71.7 1.71H9v5c0 .55.45 1 1 1zm-4 2h12c.55 0 1 .45 1 1s-.45 1-1 1H6c-.55 0-1-.45-1-1s.45-1 1-1z"
              />
              <path id="c" d="M0 0h24v24H0z" />
            </defs>
            <g fill="none" fillRule="evenodd">
              <mask id="b" fill="#fff">
                <use xlinkHref="#a" />
              </mask>
              <g mask="url(#b)">
                <mask id="d" fill="#fff">
                  <use xlinkHref="#c" />
                </mask>
                <use fill="#6202EE" fillOpacity="0" xlinkHref="#c" />
                <g fill="#436AB2" mask="url(#d)">
                  <path d="M0 0h24v24H0z" />
                </g>
              </g>
            </g>
          </svg>
        )
      },
      cameraNew: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42">
            <g fill="none" fillRule="evenodd">
              <path fill="#FFF" fillOpacity=".01" d="M0 0h42v42H0z" />
              <path d="M7 9.625h28v22.867H7z" />
              <path
                fill="#116FFF"
                d="M34.067 30.646a.912.912 0 0 1-.912.912H8.845a.912.912 0 0 1-.912-.912v-14.51c0-.503.409-.911.912-.911h4.387a.911.911 0 0 0 .846-.573l1.409-3.52a.91.91 0 0 1 .846-.574h9.334a.91.91 0 0 1 .846.574l1.409 3.52a.911.911 0 0 0 .846.573h4.387c.503 0 .912.408.912.912v14.51zM11.2 12.892c.258 0 .467.208.467.466v.467a.466.466 0 1 1-.934 0v-.467c0-.258.209-.466.467-.466zm22.888 1.4H29.4a.911.911 0 0 1-.847-.573l-1.408-3.52a.91.91 0 0 0-.846-.574H15.7a.91.91 0 0 0-.846.573l-1.408 3.52a.911.911 0 0 1-.847.574V12.87a.912.912 0 0 0-.912-.912h-.976a.912.912 0 0 0-.912.912v.51a.912.912 0 0 1-.912.912h-.976a.912.912 0 0 0-.912.911V31.58c0 .503.408.912.912.912h26.176A.912.912 0 0 0 35 31.58V15.203a.912.912 0 0 0-.912-.911z"
              />
              <path
                fill="#1AE5BE"
                d="M21.973 29.63c-4.877.62-8.997-3.501-8.378-8.378.423-3.324 3.107-6.01 6.432-6.432 4.877-.62 8.997 3.501 8.378 8.378-.423 3.325-3.107 6.01-6.432 6.432m2.857-14.948c-7.488-3.393-14.766 3.885-11.373 11.373a7.477 7.477 0 0 0 3.713 3.713c7.488 3.392 14.766-3.885 11.373-11.373a7.474 7.474 0 0 0-3.713-3.713"
              />
              <path
                fill="#1AE5BE"
                d="M21.792 26.826a4.675 4.675 0 0 1-5.393-5.393 4.671 4.671 0 0 1 3.81-3.81 4.675 4.675 0 0 1 5.392 5.394 4.67 4.67 0 0 1-3.81 3.81m2.199-9.415c-5.286-2.838-10.64 2.517-7.803 7.803a4.49 4.49 0 0 0 1.823 1.823c5.286 2.838 10.64-2.517 7.803-7.803a4.49 4.49 0 0 0-1.823-1.823M31.267 18.958a.934.934 0 0 1 0-1.866.934.934 0 0 1 0 1.866m1.227-2.397c-1.909-1.294-3.986.783-2.692 2.692a.897.897 0 0 0 .237.236c1.909 1.294 3.986-.783 2.692-2.692a.897.897 0 0 0-.237-.236"
              />
            </g>
          </svg>
        )
      },
      uploadDoc: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42">
            <g fill="none" fillRule="evenodd">
              <path fill="#FFF" fillOpacity=".01" d="M0 0h42v42H0z" />
              <path
                fill="#D7E9FF"
                d="M24.131 5.878v1.975l-11.181.093s-1.821.338-1.648 1.769v7.298c0 4.067.029 8.136.005 12.203-.005.805-.013 1.61-.019 2.416-.003.323-.004.652.078.965.18.683.747 1.21 1.385 1.515.585.28 1.232.4 1.869.5.477.074 1.236.258 1.7.117l-2.72.822L10 34.25l-.866-2.645v-3.425l.26-19.246.78-1.648.607-.823h.78l2.125-.423 10.444-.163z"
              />
              <path d="M8.75 5.31h24.49v30.913H8.75z" />
              <path
                fill="#116FFF"
                d="M29.179 34.73H12.812c-1.396 0-2.569-1.158-2.569-2.562V9.365c0-1.396 1.165-2.561 2.569-2.561h11.32v4.719a3.266 3.266 0 0 0 3.277 3.27h4.339v17.375c0 1.404-1.165 2.562-2.569 2.562zM25.625 7.946l5.1 5.354h-3.316a1.778 1.778 0 0 1-1.784-1.777V7.946zm-.217-2.397a.748.748 0 0 0-.537-.238H12.81c-2.224 0-4.061 1.829-4.061 4.054v22.803c0 2.225 1.837 4.055 4.062 4.055h16.367c2.225 0 4.062-1.83 4.062-4.055V14.061c0-.194-.09-.38-.217-.522l-7.616-7.99z"
              />
              <path
                fill="#1AE5BE"
                d="M27.14 29.578H14.85a.749.749 0 0 0-.746.746c0 .41.336.747.746.747h12.298c.41 0 .747-.336.747-.747a.75.75 0 0 0-.754-.746M17.172 21.543l3.077-3.308v8.154c0 .41.336.747.746.747.411 0 .747-.336.747-.747v-8.154l3.076 3.308c.15.157.344.24.545.24.18 0 .367-.068.508-.202a.744.744 0 0 0 .038-1.053l-4.376-4.697a.752.752 0 0 0-.545-.239c-.21 0-.403.09-.545.24l-4.376 4.696a.744.744 0 0 0 .038 1.053.762.762 0 0 0 1.067-.038"
              />
            </g>
          </svg>
        )
      },
      self: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="36"
            height="36"
            viewBox="0 0 36 36">
            <defs>
              <path
                id="a"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619z"
              />
              <path
                id="c"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619z"
              />
              <path
                id="e"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="g"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="i"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="k"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="m"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="o"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="q"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="s"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="u"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619z"
              />
              <path
                id="w"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619z"
              />
              <path
                id="y"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="A"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619z"
              />
              <path
                id="C"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619z"
              />
              <path
                id="E"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619z"
              />
              <path
                id="G"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619z"
              />
              <path
                id="I"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619z"
              />
              <path
                id="K"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619z"
              />
              <path
                id="M"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619z"
              />
              <path
                id="O"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619z"
              />
              <path
                id="Q"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619z"
              />
              <path
                id="S"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="U"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="W"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="Y"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="aa"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="ac"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="ae"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="ag"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="ai"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="ak"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="am"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="ao"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="aq"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
              <path
                id="as"
                d="M0 16.62C0 25.737 7.273 33.13 16.244 33.13c8.972 0 16.245-7.393 16.245-16.512C32.489 7.5 25.216.107 16.244.107 7.273.107 0 7.5 0 16.619"
              />
            </defs>
            <g fill="none" fillRule="evenodd">
              <path
                fill="#F1F2F2"
                d="M34.026 18.193c0 9.12-7.273 16.513-16.245 16.513-8.971 0-16.244-7.393-16.244-16.513 0-9.12 7.273-16.512 16.244-16.512 8.972 0 16.245 7.393 16.245 16.512"
              />
              <path d="M34.026 18.193c0 9.12-7.273 16.513-16.245 16.513-8.971 0-16.244-7.393-16.244-16.513 0-9.12 7.273-16.512 16.244-16.512 8.972 0 16.245 7.393 16.245 16.512z" />
              <g>
                <g transform="translate(1.537 1.574)">
                  <mask id="b" fill="#fff">
                    <use xlinkHref="#a" />
                  </mask>
                  <path
                    fill="#FFF"
                    d="M16.245 24.822l-4.792-2.965v1.271l1.13 3.61 3.662-1.492 3.662 1.492 1.13-3.61v-1.271z"
                    mask="url(#b)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="d" fill="#fff">
                    <use xlinkHref="#c" />
                  </mask>
                  <path
                    fill="#94C1FF"
                    d="M22.844 10.382c1.067 2.414.692 5.083.692 5.083s-.162-2.423-1.654-3.389l.962-1.694z"
                    mask="url(#d)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="f" fill="#fff">
                    <use xlinkHref="#e" />
                  </mask>
                  <path
                    fill="#94C1FF"
                    d="M22.844 10.382l-.962 1.694c-3.754-2.426-6.85 4.117-12.658 2.372a8.9 8.9 0 0 1-.713-.254s.442-7.623 7.733-7.623c3.863 0 5.721 1.816 6.6 3.811"
                    mask="url(#f)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="h" fill="#fff">
                    <use xlinkHref="#g" />
                  </mask>
                  <path
                    fill="#5C9EFF"
                    d="M22.844 10.382c-.879-1.995-2.737-3.811-6.6-3.811-.135 0-.264.007-.396.012 3.564.135 5.318 1.882 6.163 3.8.372.841.566 1.713.665 2.493.757 1.108.86 2.589.86 2.589s.375-2.669-.692-5.083"
                    mask="url(#h)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="j" fill="#fff">
                    <use xlinkHref="#i" />
                  </mask>
                  <path
                    fill="#D7E9FF"
                    d="M9.325 14.478s.45-7.62 7.357-7.894c-.145-.006-.287-.013-.438-.013-7.291 0-7.733 7.623-7.733 7.623.242.097.814.284.814.284"
                    mask="url(#j)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="l" fill="#fff">
                    <use xlinkHref="#k" />
                  </mask>
                  <path
                    fill="#000"
                    d="M16.244 25.206c1.422 0 3.298-1.178 4.793-2.974v-.375l-4.792 2.965-4.792-2.965v.382c1.494 1.794 3.37 2.967 4.791 2.967"
                    mask="url(#l)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="n" fill="#fff">
                    <use xlinkHref="#m" />
                  </mask>
                  <path
                    fill="#D7E9FF"
                    d="M23.536 15.465l-.046.847c-.475 4.51-4.633 8.47-7.246 8.47-2.775 0-7.291-4.468-7.291-9.317v-1.106c6.106 1.94 9.174-4.71 12.929-2.283 1.492.966 1.654 3.389 1.654 3.389"
                    mask="url(#n)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="p" fill="#fff">
                    <use xlinkHref="#o" />
                  </mask>
                  <path
                    fill="#94C1FF"
                    d="M21.882 12.076c-.739-.477-1.45-.6-2.164-.51.438.06.88.219 1.33.51 1.492.966 1.655 3.389 1.655 3.389l-.046.847c-.451 4.286-4.227 8.068-6.844 8.434.148.022.292.036.431.036 2.613 0 6.771-3.96 7.246-8.47l.046-.847s-.162-2.423-1.654-3.389"
                    mask="url(#p)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="r" fill="#fff">
                    <use xlinkHref="#q" />
                  </mask>
                  <path
                    fill="#FFF"
                    d="M9.786 15.465v-.894a7.791 7.791 0 0 1-.833-.212v1.106c0 4.85 4.516 9.317 7.291 9.317.13 0 .266-.017.403-.036-2.787-.416-6.86-4.675-6.86-9.281"
                    mask="url(#r)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="t" fill="#fff">
                    <use xlinkHref="#s" />
                  </mask>
                  <path
                    fill="#94C1FF"
                    d="M28.953 29.017v4.236H18.744l.596-.847 2.113-2.965-.417-1.27 2.083-2.965-.894-.908c.942.419 3.62 1.526 4.228 1.755 1.666.631 2.5 1.27 2.5 2.964"
                    mask="url(#t)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="v" fill="#fff">
                    <use xlinkHref="#u" />
                  </mask>
                  <path
                    fill="#5D9CEC"
                    d="M18.744 33.253h-.894l2.07-6.599 1.116-3.566 2.083 2.118-2.083 2.965.417 1.27z"
                    mask="url(#v)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="x" fill="#fff">
                    <use xlinkHref="#w" />
                  </mask>
                  <path
                    fill="#D7E9FF"
                    d="M18.744 33.253h-.894l2.07-6.599 1.116-3.566 2.083 2.118-2.083 2.965.417 1.27z"
                    mask="url(#x)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="z" fill="#fff">
                    <use xlinkHref="#y" />
                  </mask>
                  <path
                    fill="#94C1FF"
                    d="M3.536 29.017v4.236h10.209l-.596-.847-2.113-2.965.417-1.27-2.083-2.965.893-.908a143.28 143.28 0 0 1-4.227 1.755c-1.666.631-2.5 1.27-2.5 2.964"
                    mask="url(#z)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="B" fill="#fff">
                    <use xlinkHref="#A" />
                  </mask>
                  <path
                    fill="#5D9CEC"
                    d="M13.745 33.253h.893l-2.069-6.599-1.116-3.566-2.083 2.118 2.083 2.965-.417 1.27z"
                    mask="url(#B)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="D" fill="#fff">
                    <use xlinkHref="#C" />
                  </mask>
                  <path
                    fill="#D7E9FF"
                    d="M13.745 33.253h.893l-2.069-6.599-1.116-3.566-2.083 2.118 2.083 2.965-.417 1.27z"
                    mask="url(#D)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="F" fill="#fff">
                    <use xlinkHref="#E" />
                  </mask>
                  <path
                    fill="#5C9EFF"
                    d="M11.036 29.441l.417-1.27-2.083-2.965.893-.908c-.184.081-.437.19-.726.314l-.584.594 2.083 2.964-.416 1.271 2.708 3.812h.417l-.596-.847-2.113-2.965z"
                    mask="url(#F)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="H" fill="#fff">
                    <use xlinkHref="#G" />
                  </mask>
                  <path
                    fill="#D7E9FF"
                    d="M8.953 25.206l.584-.594a144.934 144.934 0 0 1-3.5 1.44c-1.667.632-2.5 1.271-2.5 2.966v4.235h.833v-3.388c0-1.694.833-2.334 2.5-2.965.37-.14 1.5-.601 2.544-1.038l-.461-.656z"
                    mask="url(#H)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="J" fill="#fff">
                    <use xlinkHref="#I" />
                  </mask>
                  <path
                    fill="#5C9EFF"
                    d="M21.453 29.441l-.417-1.27 2.083-2.965-.894-.908c.185.081.437.19.727.314l.584.594-2.083 2.964.416 1.271-2.708 3.812h-.417l.596-.847 2.113-2.965z"
                    mask="url(#J)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="L" fill="#fff">
                    <use xlinkHref="#K" />
                  </mask>
                  <path
                    fill="#5C9EFF"
                    d="M23.536 25.206l-.584-.594c1.186.505 3.012 1.257 3.5 1.44 1.667.632 2.5 1.271 2.5 2.966v4.235h-.833v-3.388c0-1.694-.833-2.334-2.5-2.965-.37-.14-1.5-.601-2.544-1.038l.461-.656z"
                    mask="url(#L)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="N" fill="#fff">
                    <use xlinkHref="#M" />
                  </mask>
                  <path
                    fill="#FFF"
                    d="M16.244 25.206l3.663 1.49-1.788 5.71-.269.847h-3.212l-.268-.847-1.787-5.708z"
                    mask="url(#N)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="P" fill="#fff">
                    <use xlinkHref="#O" />
                  </mask>
                  <path fill="#94C1FF" d="M17.286 27.323h-2.083l-.681-1.417 1.722-.7 1.724.7z" mask="url(#P)" />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="R" fill="#fff">
                    <use xlinkHref="#Q" />
                  </mask>
                  <path fill="#94C1FF" d="M17.703 33.187h-2.917V29.44l.833-2.118h1.25l.834 2.118z" mask="url(#R)" />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="T" fill="#fff">
                    <use xlinkHref="#S" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M28.953 33.685H3.536a.21.21 0 0 1-.208-.212v-4.235c0-1.82.926-2.516 2.635-3.163a51.365 51.365 0 0 0 2.142-.861l.349-.156a.207.207 0 0 1 .274.11.213.213 0 0 1-.11.279l-.35.157c-.701.3-1.509.625-2.16.868-1.6.606-2.364 1.175-2.364 2.766v4.023h25v-4.023c0-1.591-.762-2.16-2.364-2.766-.5-.189-1.493-.573-2.51-1.026a.213.213 0 0 1-.108-.279.208.208 0 0 1 .274-.109c1.008.449 1.992.83 2.49 1.017 1.709.647 2.635 1.343 2.635 3.163v4.235a.21.21 0 0 1-.208.212"
                    mask="url(#T)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="V" fill="#fff">
                    <use xlinkHref="#U" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M16.244 25.214c-2.825 0-7.5-4.453-7.5-9.53a.21.21 0 0 1 .209-.211.21.21 0 0 1 .208.212c0 4.695 4.42 9.106 7.083 9.106 2.379 0 6.566-3.79 7.039-8.282a.216.216 0 0 1 .229-.188.211.211 0 0 1 .185.233c-.47 4.46-4.596 8.66-7.453 8.66"
                    mask="url(#V)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="X" fill="#fff">
                    <use xlinkHref="#W" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M8.733 14.274c.186.072.371.136.552.192a6.69 6.69 0 0 0 1.924.29c1.987 0 3.673-.955 5.16-1.798 1.289-.73 2.506-1.42 3.75-1.42.658 0 1.271.19 1.875.58.707.458 1.131 1.208 1.385 1.902-.043-.946-.213-2.173-.725-3.33-1.077-2.447-3.234-3.687-6.41-3.687-2.936 0-5.093 1.24-6.41 3.688-.83 1.54-1.05 3.1-1.1 3.583m14.802 1.622h-.008a.21.21 0 0 1-.2-.197c-.002-.023-.174-2.328-1.558-3.224-.535-.345-1.075-.513-1.652-.513-1.135 0-2.306.663-3.545 1.366-1.532.868-3.269 1.852-5.364 1.852a7.106 7.106 0 0 1-2.044-.309 9.05 9.05 0 0 1-.73-.26.212.212 0 0 1-.131-.21c.004-.077.538-7.822 7.94-7.822 3.355 0 5.64 1.325 6.79 3.937 1.08 2.442.724 5.087.708 5.199a.21.21 0 0 1-.206.181"
                    mask="url(#X)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="Z" fill="#fff">
                    <use xlinkHref="#Y" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M21.882 12.508a.203.203 0 0 1-.104-.028.213.213 0 0 1-.076-.29l.962-1.694a.207.207 0 0 1 .284-.077c.1.059.134.188.076.29l-.962 1.694a.207.207 0 0 1-.18.105"
                    mask="url(#Z)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="ab" fill="#fff">
                    <use xlinkHref="#aa" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M17.286 27.755h-2.083a.209.209 0 0 1-.187-.117l-.416-.847a.214.214 0 0 1 .093-.284.207.207 0 0 1 .28.095l.358.73h1.826l.36-.73a.208.208 0 0 1 .279-.095c.103.052.144.18.093.284l-.417.847a.209.209 0 0 1-.186.117"
                    mask="url(#ab)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="ad" fill="#fff">
                    <use xlinkHref="#ac" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M14.786 29.873a.211.211 0 0 1-.077-.015.213.213 0 0 1-.116-.275l.833-2.118a.207.207 0 0 1 .27-.118.213.213 0 0 1 .117.275l-.834 2.118a.208.208 0 0 1-.193.133"
                    mask="url(#ad)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="af" fill="#fff">
                    <use xlinkHref="#ae" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M17.703 29.873a.209.209 0 0 1-.194-.133l-.833-2.118a.213.213 0 0 1 .116-.275.207.207 0 0 1 .27.118l.834 2.118a.213.213 0 0 1-.116.275.211.211 0 0 1-.077.015"
                    mask="url(#af)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="ah" fill="#fff">
                    <use xlinkHref="#ag" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M19.34 32.838a.213.213 0 0 1-.169-.336l2.05-2.877-.383-1.168a.215.215 0 0 1 .028-.19l1.981-2.818-1.958-1.991a.214.214 0 0 1 0-.3.206.206 0 0 1 .294 0l2.084 2.118a.215.215 0 0 1 .022.273l-2.022 2.877.383 1.168a.215.215 0 0 1-.028.191l-2.113 2.965a.208.208 0 0 1-.169.088"
                    mask="url(#ah)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="aj" fill="#fff">
                    <use xlinkHref="#ai" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M18.12 32.838a.212.212 0 0 1-.199-.276l2.917-9.318a.207.207 0 0 1 .261-.138c.11.036.17.155.136.267l-2.917 9.317a.209.209 0 0 1-.198.148"
                    mask="url(#aj)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="al" fill="#fff">
                    <use xlinkHref="#ak" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M19.37 26.908a.211.211 0 0 1-.078-.014l-3.125-1.271a.213.213 0 0 1-.116-.276.207.207 0 0 1 .27-.118l3.126 1.27a.213.213 0 0 1 .116.276.209.209 0 0 1-.194.133"
                    mask="url(#al)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="an" fill="#fff">
                    <use xlinkHref="#am" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M13.149 32.838a.208.208 0 0 1-.17-.088l-2.112-2.965a.215.215 0 0 1-.029-.19l.384-1.169L9.2 25.55a.215.215 0 0 1 .022-.273l2.083-2.117a.206.206 0 0 1 .295 0 .214.214 0 0 1 0 .299l-1.958 1.991 1.98 2.818c.04.056.05.126.028.19l-.382 1.168 2.05 2.877a.213.213 0 0 1-.17.336"
                    mask="url(#an)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="ap" fill="#fff">
                    <use xlinkHref="#ao" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M14.37 32.838a.209.209 0 0 1-.2-.148l-2.916-9.317a.213.213 0 0 1 .136-.267.207.207 0 0 1 .261.138l2.917 9.318a.212.212 0 0 1-.198.276"
                    mask="url(#ap)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="ar" fill="#fff">
                    <use xlinkHref="#aq" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M13.12 26.908a.209.209 0 0 1-.194-.133.213.213 0 0 1 .116-.275l3.125-1.27a.207.207 0 0 1 .27.117.213.213 0 0 1-.115.276l-3.125 1.27a.211.211 0 0 1-.078.015"
                    mask="url(#ar)"
                  />
                </g>
                <g transform="translate(1.537 1.574)">
                  <mask id="at" fill="#fff">
                    <use xlinkHref="#as" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M16.244 32.838a.21.21 0 0 1-.208-.212v-3.812a.21.21 0 0 1 .208-.211.21.21 0 0 1 .209.211v3.812a.21.21 0 0 1-.209.212"
                    mask="url(#at)"
                  />
                </g>
              </g>
            </g>
          </svg>
        )
      },
      father: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="36"
            height="36"
            viewBox="0 0 36 36">
            <defs>
              <path
                id="a"
                d="M16.776.15C7.511.15 0 7.66 0 16.925c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776C33.553 7.66 26.042.149 16.776.149z"
              />
              <path
                id="c"
                d="M16.776.15C7.511.15 0 7.66 0 16.925c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776C33.553 7.66 26.042.149 16.776.149z"
              />
              <path
                id="e"
                d="M16.776.15C7.511.15 0 7.66 0 16.925c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776C33.553 7.66 26.042.149 16.776.149z"
              />
              <path
                id="g"
                d="M16.776.15C7.511.15 0 7.66 0 16.925c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776C33.553 7.66 26.042.149 16.776.149z"
              />
            </defs>
            <g fill="none" fillRule="evenodd">
              <path
                fill="#F1F2F2"
                d="M34.553 18c0 9.265-7.511 16.776-16.777 16.776C8.511 34.776 1 27.266 1 18 1 8.735 8.51 1.224 17.776 1.224S34.553 8.734 34.553 18"
              />
              <g transform="translate(1 1.074)">
                <mask id="b" fill="#fff">
                  <use xlinkHref="#a" />
                </mask>
                <path
                  fill="#FFF"
                  d="M22.01 23.25l-4.948 1.722-4.949-1.721-.43 1.076 5.379 6.024 5.379-6.024z"
                  mask="url(#b)"
                />
                <mask id="d" fill="#fff">
                  <use xlinkHref="#c" />
                </mask>
                <path
                  fill="#E6E9ED"
                  d="M17.062 24.972l-4.949-3.011v1.29l3.012 3.442 1.937-.941 1.936.941 3.012-3.442v-1.29z"
                  mask="url(#d)"
                />
                <mask id="f" fill="#fff">
                  <use xlinkHref="#e" />
                </mask>
                <path
                  fill="#FFF"
                  d="M17.062 24.972l-4.949-3.011v1.29l3.012 3.442 1.937-.941 1.936.941 3.012-3.442v-1.29z"
                  mask="url(#f)"
                />
                <mask id="h" fill="#fff">
                  <use xlinkHref="#g" />
                </mask>
                <path
                  fill="#94C1FF"
                  d="M12.113 16.366h3.873v-1.72h-3.873zM18.137 16.366h3.873v-1.72h-3.873z"
                  mask="url(#h)"
                />
                <path
                  fill="#D7E9FF"
                  d="M13.143 16.366h.891l.462-1.72h-.891zM14.265 16.366h.23l.462-1.72h-.23zM19.168 16.366h.89l.462-1.72h-.89zM20.289 16.366h.23l.462-1.72h-.23z"
                  mask="url(#h)"
                />
                <path
                  fill="#116FFF"
                  d="M17.075 27.339a.217.217 0 0 1-.218-.215c0-.12.094-.216.213-.216h.005a.215.215 0 1 1 0 .43M17.075 28.63a.217.217 0 0 1-.218-.215c0-.12.094-.216.213-.216h.005a.215.215 0 1 1 0 .43"
                  mask="url(#h)"
                />
                <path
                  fill="#94C1FF"
                  d="M30.186 29.705v4.303H3.937v-4.303c0-1.72.861-2.37 2.582-3.012 1.02-.383 2.995-1.144 4.303-1.867l6.24 7.031 6.239-7.031c1.308.723 3.283 1.484 4.303 1.867 1.721.642 2.582 1.291 2.582 3.012"
                  mask="url(#h)"
                />
                <path
                  fill="#FFF"
                  d="M20.72 7.842s3.317 1.39 3.872 3.36c.585 2.079 0 3.873 0 3.873-.065-3.45-3.012-4.733-3.012-4.733l-.86-2.5zM13.404 7.842l-.86 2.5s-2.948 1.282-3.012 4.733c0 0-.586-1.794 0-3.873.555-1.97 3.872-3.36 3.872-3.36"
                  mask="url(#h)"
                />
                <path
                  fill="#D7E9FF"
                  d="M20.72 7.842l.86 2.5s2.947 1.282 3.012 4.733l-.013.861c-.258 4.759-4.733 9.036-7.517 9.036-2.784 0-7.26-4.277-7.518-9.036l-.013-.86c.065-3.452 3.013-4.734 3.013-4.734l.86-2.5.43-.224a7.433 7.433 0 0 1 3.228-.718c1.157 0 2.25.25 3.227.718l.43.224zm-2.583 7.676v.848h3.873v-1.721h-3.873v.873zm-2.151 0v-.873h-3.873v1.721h3.873v-.848z"
                  mask="url(#h)"
                />
                <path
                  fill="#FFF"
                  d="M10.405 15.936l-.013-.86c.064-3.452 2.152-4.734 2.152-4.734s-2.948 1.282-3.012 4.733l.012.861c.259 4.759 4.733 9.036 7.518 9.036.139 0 .283-.013.43-.034-2.792-.397-6.842-4.48-7.087-9.002"
                  mask="url(#h)"
                />
                <path
                  fill="#94C1FF"
                  d="M23.742 15.936l.013-.86c-.065-3.452-2.152-4.734-2.152-4.734s2.948 1.282 3.012 4.733l-.013.861c-.258 4.76-4.733 9.036-7.517 9.036-.14 0-.283-.013-.43-.034 2.79-.397 6.84-4.48 7.087-9.002"
                  mask="url(#h)"
                />
                <path
                  fill="#5C9EFF"
                  d="M22.44 24.327l-5.378 6.024-5.38-6.024-.86.499 6.24 7.031 6.239-7.031z"
                  mask="url(#h)"
                />
                <path
                  fill="#D7E9FF"
                  d="M4.798 30.566c0-1.72.86-2.37 2.582-3.012 1.011-.38 2.96-1.132 4.268-1.849l-.78-.88c-1.308.724-3.283 1.485-4.303 1.868-1.72.642-2.582 1.291-2.582 3.012v4.304h.815v-3.443z"
                  mask="url(#h)"
                />
                <path fill="#94C1FF" d="M11.683 25.687l.8-.464-.8-.896-.86.499.794.895.066-.034" mask="url(#h)" />
                <path
                  fill="#5C9EFF"
                  d="M29.372 30.566c0-1.72-.861-2.37-2.582-3.012-1.012-.38-2.96-1.132-4.269-1.849l.78-.88c1.308.724 3.283 1.485 4.303 1.868 1.721.642 2.582 1.291 2.582 3.012v4.304h-.815v-3.443"
                  mask="url(#h)"
                />
                <path fill="#2287FF" d="M22.487 25.687l-.8-.464.8-.896.86.499-.794.895-.066-.034" mask="url(#h)" />
                <path
                  fill="#116FFF"
                  d="M17.062 25.187c-2.79 0-7.46-4.228-7.732-9.24a.215.215 0 0 1 .203-.226.223.223 0 0 1 .226.203c.114 2.103 1.119 4.353 2.757 6.17 1.479 1.643 3.22 2.663 4.546 2.663 2.57 0 7.047-4.128 7.302-8.833a.22.22 0 0 1 .227-.203c.119.007.21.108.203.226-.272 5.012-4.943 9.24-7.732 9.24M20.289 7.833a.216.216 0 0 1-.093-.02 7.181 7.181 0 0 0-3.134-.698 7.18 7.18 0 0 0-3.134.697.215.215 0 1 1-.187-.388 7.608 7.608 0 0 1 3.32-.74c1.182 0 2.298.25 3.321.74a.215.215 0 0 1-.093.41"
                  mask="url(#h)"
                />
                <path
                  fill="#116FFF"
                  d="M30.186 34.224H3.937a.215.215 0 0 1-.215-.215v-4.304c0-1.848.957-2.555 2.722-3.213 1.903-.715 3.34-1.338 4.274-1.854a.214.214 0 1 1 .208.376c-.951.526-2.408 1.159-4.331 1.881-1.655.616-2.442 1.194-2.442 2.81v4.088H29.97v-4.088c0-1.616-.788-2.194-2.442-2.81-1.923-.722-3.38-1.355-4.332-1.88a.215.215 0 1 1 .208-.377c.934.516 2.372 1.14 4.275 1.854 1.765.658 2.721 1.365 2.721 3.213v4.303a.215.215 0 0 1-.215.216M22.01 23.466a.215.215 0 0 1-.215-.215v-.43a.215.215 0 1 1 .43 0v.43a.215.215 0 0 1-.215.215"
                  mask="url(#h)"
                />
                <path
                  fill="#116FFF"
                  d="M18.998 26.909a.216.216 0 0 1-.162-.357l3.012-3.443a.215.215 0 1 1 .324.284l-3.012 3.442a.215.215 0 0 1-.162.074"
                  mask="url(#h)"
                />
                <path
                  fill="#116FFF"
                  d="M18.998 26.909a.218.218 0 0 1-.096-.023l-1.721-.86a.215.215 0 0 1 .192-.386l1.721.861a.215.215 0 0 1-.096.408M12.113 23.466a.215.215 0 0 1-.215-.215v-.43a.215.215 0 0 1 .43 0v.43a.215.215 0 0 1-.215.215"
                  mask="url(#h)"
                />
                <path
                  fill="#116FFF"
                  d="M15.125 26.909a.215.215 0 0 1-.162-.074l-3.012-3.442a.215.215 0 0 1 .324-.284l3.013 3.443a.216.216 0 0 1-.163.357"
                  mask="url(#h)"
                />
                <path
                  fill="#116FFF"
                  d="M15.126 26.909a.215.215 0 0 1-.097-.408l1.721-.86a.215.215 0 0 1 .193.384l-1.721.86a.215.215 0 0 1-.096.024M13.036 8.252c-.908.452-2.897 1.586-3.297 3.01a7.049 7.049 0 0 0-.23 2.422c.604-2.237 2.435-3.281 2.86-3.497l.667-1.935zM9.53 15.291a.216.216 0 0 1-.204-.149c-.025-.076-.599-1.88-.003-3.998.577-2.047 3.858-3.442 3.997-3.5a.216.216 0 0 1 .287.269l-.861 2.499a.216.216 0 0 1-.117.127c-.116.05-2.822 1.274-2.883 4.54a.216.216 0 0 1-.216.212zM21.754 10.187c.425.216 2.257 1.26 2.86 3.497a7.05 7.05 0 0 0-.23-2.423c-.4-1.425-2.389-2.558-3.296-3.01l.666 1.936zm2.838 5.103c-.01 0-.021 0-.032-.002a.215.215 0 0 1-.183-.209c-.061-3.266-2.768-4.49-2.883-4.54a.212.212 0 0 1-.117-.127l-.861-2.5a.214.214 0 0 1 .056-.227.214.214 0 0 1 .23-.042c.14.059 3.42 1.454 3.997 3.5.596 2.118.022 3.923-.002 3.999a.215.215 0 0 1-.205.148zM20.289 8.836a.216.216 0 0 1-.152-.063c-.007-.007-.846-.798-3.075-.798-2.252 0-3.068.79-3.075.798a.215.215 0 1 1-.305-.304c.038-.038.952-.924 3.38-.924s3.341.886 3.38.924a.215.215 0 0 1-.153.367"
                  mask="url(#h)"
                />
                <path
                  fill="#116FFF"
                  d="M20.289 9.696a.216.216 0 0 1-.152-.062c-.007-.007-.846-.798-3.075-.798-2.252 0-3.068.79-3.075.798a.215.215 0 1 1-.305-.305c.038-.038.952-.923 3.38-.923s3.341.885 3.38.923a.216.216 0 0 1-.153.367M17.062 30.566a.214.214 0 0 1-.16-.072l-5.38-6.024a.216.216 0 0 1 .322-.287l5.378 6.025a.216.216 0 0 1-.16.358"
                  mask="url(#h)"
                />
                <path
                  fill="#116FFF"
                  d="M17.062 30.566a.216.216 0 0 1-.16-.358l5.378-6.025a.215.215 0 1 1 .321.287l-5.379 6.024a.214.214 0 0 1-.16.072M17.062 32.072a.216.216 0 0 1-.16-.358l6.238-7.03a.215.215 0 1 1 .322.285L17.222 32a.215.215 0 0 1-.16.072"
                  mask="url(#h)"
                />
                <path
                  fill="#116FFF"
                  d="M17.062 32.072A.214.214 0 0 1 16.9 32l-6.24-7.031a.215.215 0 1 1 .322-.286l6.24 7.031a.216.216 0 0 1-.161.358M12.328 16.151h3.443v-1.29h-3.443v1.29zm3.658.43h-3.873a.215.215 0 0 1-.215-.215v-1.72c0-.12.096-.216.215-.216h3.873c.119 0 .215.096.215.215v1.721a.215.215 0 0 1-.215.215zM18.353 16.151h3.442v-1.29h-3.442v1.29zm3.657.43h-3.873a.215.215 0 0 1-.215-.215v-1.72c0-.12.097-.216.215-.216h3.873c.12 0 .215.096.215.215v1.721a.215.215 0 0 1-.215.215z"
                  mask="url(#h)"
                />
                <path
                  fill="#116FFF"
                  d="M18.137 15.733h-2.151a.215.215 0 1 1 0-.43h2.151a.215.215 0 0 1 0 .43M10.822 25.041a.215.215 0 0 1-.108-.401l.861-.5a.215.215 0 0 1 .216.372l-.86.5a.212.212 0 0 1-.109.029M23.301 25.041a.212.212 0 0 1-.108-.029l-.86-.5a.215.215 0 0 1 .215-.371l.861.499a.215.215 0 0 1-.108.401"
                  mask="url(#h)"
                />
              </g>
            </g>
          </svg>
        )
      },
      mother: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="36"
            height="36"
            viewBox="0 0 36 36">
            <defs>
              <path id="a" d="M0 .032h33.553v33.552H0z" />
              <path
                id="c"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777c0-9.265-7.511-16.776-16.777-16.776z"
              />
              <path
                id="e"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777c0-9.265-7.511-16.776-16.777-16.776z"
              />
              <path
                id="g"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777c0-9.265-7.511-16.776-16.777-16.776z"
              />
              <path
                id="i"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777c0-9.265-7.511-16.776-16.777-16.776z"
              />
              <path
                id="k"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777c0-9.265-7.511-16.776-16.777-16.776z"
              />
              <path
                id="m"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777c0-9.265-7.511-16.776-16.777-16.776z"
              />
              <path
                id="o"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="q"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777c0-9.265-7.511-16.776-16.777-16.776z"
              />
              <path
                id="s"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="u"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777c0-9.265-7.511-16.776-16.777-16.776z"
              />
              <path
                id="w"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="y"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="A"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="C"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="E"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="G"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777c0-9.265-7.511-16.776-16.777-16.776z"
              />
              <path
                id="I"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777c0-9.265-7.511-16.776-16.777-16.776z"
              />
              <path
                id="K"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777c0-9.265-7.511-16.776-16.777-16.776z"
              />
              <path
                id="M"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="O"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="Q"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="S"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777c0-9.265-7.511-16.776-16.777-16.776z"
              />
              <path
                id="U"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="W"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777c0-9.265-7.511-16.776-16.777-16.776z"
              />
              <path
                id="Y"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="aa"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777c0-9.265-7.511-16.776-16.777-16.776z"
              />
              <path
                id="ac"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="ae"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="ag"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="ai"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777c0-9.265-7.511-16.776-16.777-16.776z"
              />
              <path
                id="ak"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777c0-9.265-7.511-16.776-16.777-16.776z"
              />
              <path
                id="am"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="ao"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="aq"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="as"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="au"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="aw"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="ay"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="aA"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="aC"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="aE"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="aG"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="aI"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="aK"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="aM"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="aO"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="aQ"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="aS"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="aU"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="aW"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="aY"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="ba"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="bc"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="be"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="bg"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="bi"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="bk"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="bm"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="bo"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="bq"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="bs"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="bu"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="bw"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="by"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="bA"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
              <path
                id="bC"
                d="M16.776.032C7.511.032 0 7.542 0 16.808s7.51 16.777 16.776 16.777 16.777-7.511 16.777-16.777"
              />
            </defs>
            <g fill="none" fillRule="evenodd">
              <g transform="translate(1 1.192)">
                <mask id="b" fill="#fff">
                  <use xlinkHref="#a" />
                </mask>
                <path
                  fill="#F1F2F2"
                  d="M33.553 16.808c0 9.266-7.511 16.776-16.777 16.776C7.511 33.584 0 26.074 0 16.808 0 7.543 7.51.032 16.776.032s16.777 7.51 16.777 16.776"
                  mask="url(#b)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="d" fill="#fff">
                  <use xlinkref="#c" />
                </mask>
                <path
                  fill="#5C9EFF"
                  d="M16.29 17.567c0 .245-.2.445-.444.445h-3.112a.446.446 0 0 1-.445-.445v-.89c0-.244.2-.444.445-.444h3.112c.245 0 .445.2.445.445v.889z"
                  mask="url(#d)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="f" fill="#fff">
                  <use xlinkHref="#e" />
                </mask>
                <path fill="#94C1FF" d="M13.353 18.012h.921l.476-1.779h-.92z" mask="url(#f)" />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="h" fill="#fff">
                  <use xlinkHref="#g" />
                </mask>
                <path fill="#94C1FF" d="M14.512 18.012h.238l.477-1.779h-.238z" mask="url(#h)" />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="j" fill="#fff">
                  <use xlinkHref="#i" />
                </mask>
                <path
                  fill="#5C9EFF"
                  d="M22.516 17.567c0 .245-.2.445-.445.445H18.96a.446.446 0 0 1-.445-.445v-.89c0-.244.2-.444.445-.444h3.112c.244 0 .445.2.445.445v.889z"
                  mask="url(#j)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="l" fill="#fff">
                  <use xlinkHref="#k" />
                </mask>
                <path fill="#94C1FF" d="M19.578 18.012h.921l.477-1.779h-.92z" mask="url(#l)" />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="n" fill="#fff">
                  <use xlinkHref="#m" />
                </mask>
                <path fill="#94C1FF" d="M20.737 18.012h.238l.477-1.779h-.238z" mask="url(#n)" />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="p" fill="#fff">
                  <use xlinkHref="#o" />
                </mask>
                <path
                  fill="#5C9EFF"
                  d="M26.073 16.442v8.893l-.444-.445-.445.445-.445-.445-.445.445-.444-.445-.445.445-.444-.445-.445.445h-.445v-.836c1.735-1.836 3.113-4.446 3.113-7.168v-1.208c.209.08.67.248.889.319"
                  mask="url(#p)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="r" fill="#fff">
                  <use xlinkHref="#q" />
                </mask>
                <path
                  fill="#5C9EFF"
                  d="M9.177 24.89l-.445.445v-8.893c4.188-1.103 7.172-3.348 9.115-5.336 0 0 2.526 3.245 7.287 4.993l.05.788v.444c0 2.721-1.379 5.332-3.113 7.168-1.512 1.6-3.29 2.614-4.669 2.614-1.378 0-3.157-1.013-4.668-2.614v.836h-.445l-.445-.445-.444.445-.445-.445-.444.445-.445-.445-.445.445-.444-.445zm9.337-7.768v.431c0 .245.2.445.445.445h3.112c.245 0 .445-.2.445-.445v-.889c0-.244-.2-.445-.445-.445h-3.112c-.245 0-.445.2-.445.445v.458zm-2.223 0v-.458c0-.244-.2-.445-.445-.445h-3.112c-.245 0-.445.2-.445.445v.89c0 .244.2.444.445.444h3.112c.245 0 .445-.2.445-.445v-.431z"
                  mask="url(#r)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="t" fill="#fff">
                  <use xlinkHref="#s" />
                </mask>
                <path
                  fill="#D7E9FF"
                  d="M19.626 27.558l-.054.89-.03.48-.583-.036s-.89.222-1.557.222c-.667 0-1.556-.222-1.556-.222l-.582.036-.027-.48h-.004l-.054-.89a3.543 3.543 0 0 1-2.445-1.427v-1.632c1.511 1.6 3.29 2.614 4.668 2.614 1.379 0 3.157-1.014 4.67-2.614v1.632a3.541 3.541 0 0 1-2.446 1.427"
                  mask="url(#t)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="v" fill="#fff">
                  <use xlinkHref="#u" />
                </mask>
                <path
                  fill="#D7E9FF"
                  d="M22.516 17.553c0 .245-.2.445-.445.445H18.96a.446.446 0 0 1-.445-.445v-.889c0-.244.2-.445.445-.445h3.112c.244 0 .445.2.445.445v.89zm-6.225-.431v.431c0 .245-.2.445-.445.445h-3.112a.446.446 0 0 1-.445-.445v-.889c0-.244.2-.445.445-.445h3.112c.245 0 .445.2.445.445v.458zm1.556-6.016c-.142.145-.291.292-.445.44a20.783 20.783 0 0 1-.444-.44s-2.564 3.328-7.326 5.076l-.01.705v.444c0 2.721 1.377 5.332 3.112 7.168 1.511 1.6 3.29 2.614 4.668 2.614 1.379 0 3.157-1.013 4.67-2.614 1.733-1.836 3.112-4.447 3.112-7.168v-1.208c-4.762-1.747-7.337-5.017-7.337-5.017z"
                  mask="url(#v)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="x" fill="#fff">
                  <use xlinkHref="#w" />
                </mask>
                <path
                  fill="#94C1FF"
                  d="M17.402 27.113c-1.378 0-3.156-1.013-4.668-2.614v.445c1.512 1.6 3.29 2.614 4.668 2.614 1.379 0 3.157-1.014 4.67-2.614v-.445c-1.513 1.6-3.291 2.614-4.67 2.614"
                  mask="url(#x)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="z" fill="#fff">
                  <use xlinkHref="#y" />
                </mask>
                <path
                  fill="#FFF"
                  d="M12.734 24.944v1.187c.207.28.498.59.889.852v-1.2a11.512 11.512 0 0 1-.89-.84"
                  mask="url(#z)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="B" fill="#fff">
                  <use xlinkHref="#A" />
                </mask>
                <path
                  fill="#94C1FF"
                  d="M22.071 24.944v1.187c-.207.28-.498.59-.89.852v-1.2c.303-.26.603-.535.89-.84"
                  mask="url(#B)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="D" fill="#fff">
                  <use xlinkHref="#C" />
                </mask>
                <path
                  fill="#FFF"
                  d="M13.623 24.5c-1.734-1.837-3.113-4.448-3.113-7.169v-.444l.012-1.005-.89.3-.011.705v.444c0 2.721 1.379 5.332 3.113 7.168 1.511 1.6 3.29 2.614 4.668 2.614.144 0 .294-.017.445-.039-1.303-.184-2.87-1.14-4.224-2.575"
                  mask="url(#D)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="F" fill="#fff">
                  <use xlinkHref="#E" />
                </mask>
                <path
                  fill="#94C1FF"
                  d="M21.206 24.5c1.734-1.837 3.112-4.448 3.112-7.169v-.444l-.011-1.133.852.345.049.788v.444c0 2.721-1.379 5.332-3.113 7.168-1.511 1.6-3.29 2.614-4.668 2.614-.144 0-.294-.017-.445-.039 1.303-.184 2.87-1.14 4.224-2.575"
                  mask="url(#F)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="H" fill="#fff">
                  <use xlinkHref="#G" />
                </mask>
                <path
                  fill="#FFF"
                  d="M19.541 28.684l-.36 5.988h-3.557l-.36-5.988.582.208s.89.222 1.556.222c.667 0 1.557-.222 1.557-.222l.582-.208z"
                  mask="url(#H)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="J" fill="#fff">
                  <use xlinkHref="#I" />
                </mask>
                <path
                  fill="#5C9EFF"
                  d="M22.96 25.944s-.889 2.503-3.388 2.503l.054-.889a3.542 3.542 0 0 0 2.445-1.427c.32-.436.445-.796.445-.796l.445.61z"
                  mask="url(#J)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="L" fill="#fff">
                  <use xlinkHref="#K" />
                </mask>
                <path
                  fill="#94C1FF"
                  d="M19.572 28.447c2.5 0 3.389-2.503 3.389-2.503 1.111.885 3.561 2.005 4.89 2.503 1.78.663 2.668 1.334 2.668 3.113v3.112H19.181l.36-5.745.031-.48z"
                  mask="url(#L)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="N" fill="#fff">
                  <use xlinkHref="#M" />
                </mask>
                <path
                  fill="#5C9EFF"
                  d="M15.18 27.558l.053.89c-2.5-.005-3.389-2.504-3.389-2.504l.445-.61s.124.36.445.797a3.542 3.542 0 0 0 2.445 1.427"
                  mask="url(#N)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="P" fill="#fff">
                  <use xlinkHref="#O" />
                </mask>
                <path
                  fill="#94C1FF"
                  d="M11.844 25.944s.89 2.5 3.388 2.503h.005l.027.48.36 5.745H4.285V31.56c0-1.779.89-2.45 2.668-3.113 1.33-.498 3.784-1.618 4.891-2.503"
                  mask="url(#P)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="R" fill="#fff">
                  <use xlinkHref="#Q" />
                </mask>
                <path
                  fill="#94C1FF"
                  d="M12.734 26.833l.275-.377a3.852 3.852 0 0 1-.275-.325c-.32-.436-.445-.796-.445-.796l-.445.609s.188.52.626 1.086a5.95 5.95 0 0 0 .264-.197"
                  mask="url(#R)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="T" fill="#fff">
                  <use xlinkHref="#S" />
                </mask>
                <path
                  fill="#D7E9FF"
                  d="M5.175 32.45c0-1.78.889-2.45 2.668-3.113 1.232-.462 3.431-1.459 4.627-2.307-.438-.566-.626-1.086-.626-1.086-1.107.885-3.561 2.005-4.89 2.503-1.78.663-2.669 1.334-2.669 3.113v3.112h.89V32.45z"
                  mask="url(#T)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="V" fill="#fff">
                  <use xlinkHref="#U" />
                </mask>
                <path
                  fill="#2287FF"
                  d="M22.071 26.833l-.275-.377c.102-.11.197-.22.275-.325.32-.436.445-.796.445-.796l.445.609s-.188.52-.627 1.086a6.213 6.213 0 0 1-.263-.197"
                  mask="url(#V)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="X" fill="#fff">
                  <use xlinkHref="#W" />
                </mask>
                <path
                  fill="#5C9EFF"
                  d="M29.63 32.45c0-1.78-.89-2.45-2.668-3.113-1.233-.462-3.431-1.459-4.628-2.307.439-.566.627-1.086.627-1.086 1.107.885 3.561 2.005 4.89 2.503 1.78.663 2.669 1.334 2.669 3.113v3.112h-.89V32.45z"
                  mask="url(#X)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="Z" fill="#fff">
                  <use xlinkHref="#Y" />
                </mask>
                <path
                  fill="#94C1FF"
                  d="M20.737 7.327s-.907 1.752-2.89 3.78c-1.943 1.987-4.927 4.232-9.115 5.335V15.33a8.67 8.67 0 0 1 12.005-8.003"
                  mask="url(#Z)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="ab" fill="#fff">
                  <use xlinkHref="#aa" />
                </mask>
                <path
                  fill="#D7E9FF"
                  d="M9.621 15.33c0-4.64 3.647-8.417 8.23-8.648-.15-.007-.297-.022-.449-.022a8.67 8.67 0 0 0-8.67 8.67v1.112c.303-.08.598-.167.89-.259v-.853z"
                  mask="url(#ab)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="ad" fill="#fff">
                  <use xlinkHref="#ac" />
                </mask>
                <path
                  fill="#94C1FF"
                  d="M26.073 15.33v1.112a14.357 14.357 0 0 1-.645-.227c-4.762-1.747-7.58-5.109-7.58-5.109 1.982-2.028 2.89-3.78 2.89-3.78a8.664 8.664 0 0 1 5.335 8.004"
                  mask="url(#ad)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="af" fill="#fff">
                  <use xlinkHref="#ae" />
                </mask>
                <path
                  fill="#5C9EFF"
                  d="M20.737 7.327a8.583 8.583 0 0 0-3.335-.667c-.149 0-.294.014-.44.022a8.555 8.555 0 0 1 2.886.645 8.664 8.664 0 0 1 5.336 8.003v.788c.082.032.16.067.244.097.209.08.427.156.645.227V15.33c0-3.606-2.201-6.7-5.336-8.003"
                  mask="url(#af)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="ah" fill="#fff">
                  <use xlinkHref="#ag" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M17.402 27.336c-1.437 0-3.243-1.004-4.83-2.684-2.017-2.136-3.173-4.804-3.173-7.321a.222.222 0 0 1 .444 0c0 2.404 1.113 4.962 3.053 7.015 1.482 1.57 3.209 2.545 4.506 2.545 1.298 0 3.025-.975 4.508-2.545 1.939-2.053 3.052-4.61 3.052-7.015a.222.222 0 1 1 .444 0c0 2.517-1.157 5.185-3.173 7.32-1.588 1.681-3.393 2.685-4.83 2.685"
                  mask="url(#ah)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="aj" fill="#fff">
                  <use xlinkHref="#ai" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M12.734 16.442c-.123 0-.223.1-.223.222v.89c0 .122.1.222.223.222h3.112c.123 0 .223-.1.223-.222v-.89c0-.122-.1-.222-.223-.222h-3.112zm3.112 1.778h-3.112a.667.667 0 0 1-.667-.666v-.89c0-.368.299-.667.667-.667h3.112c.368 0 .667.3.667.667v.89c0 .367-.3.666-.667.666z"
                  mask="url(#aj)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="al" fill="#fff">
                  <use xlinkHref="#ak" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M18.959 16.442c-.123 0-.223.1-.223.222v.89c0 .122.1.222.223.222h3.112c.123 0 .222-.1.222-.222v-.89c0-.122-.1-.222-.222-.222H18.96zm3.112 1.778H18.96a.668.668 0 0 1-.667-.666v-.89c0-.368.299-.667.667-.667h3.112c.368 0 .667.3.667.667v.89c0 .367-.299.666-.667.666z"
                  mask="url(#al)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="an" fill="#fff">
                  <use xlinkHref="#am" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M18.514 17.344h-2.223a.222.222 0 1 1 0-.444h2.223a.222.222 0 1 1 0 .444"
                  mask="url(#an)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="ap" fill="#fff">
                  <use xlinkHref="#ao" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M30.52 34.895H4.285a.222.222 0 0 1-.222-.223V31.56c0-1.91.989-2.641 2.813-3.321 1.36-.51 3.759-1.613 4.83-2.469a.223.223 0 0 1 .277.348c-1.11.886-3.563 2.018-4.952 2.537-1.71.638-2.523 1.234-2.523 2.905v2.89h25.79v-2.89c0-1.67-.815-2.267-2.523-2.904-1.385-.519-3.836-1.649-4.953-2.538a.223.223 0 0 1 .277-.348c1.079.86 3.474 1.961 4.83 2.47 1.824.679 2.813 1.41 2.813 3.32v3.112c0 .123-.1.223-.222.223"
                  mask="url(#ap)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="ar" fill="#fff">
                  <use xlinkHref="#aq" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M26.073 15.553a.222.222 0 0 1-.222-.223 8.419 8.419 0 0 0-5.199-7.798 8.346 8.346 0 0 0-3.25-.65c-4.658 0-8.448 3.79-8.448 8.448a.222.222 0 1 1-.445 0c0-4.903 3.99-8.893 8.893-8.893 1.19 0 2.34.23 3.421.685a8.862 8.862 0 0 1 5.472 8.208c0 .123-.099.223-.222.223"
                  mask="url(#ar)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="at" fill="#fff">
                  <use xlinkHref="#as" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M8.732 25.557a.222.222 0 0 1-.223-.222V15.33a.222.222 0 0 1 .445 0v10.005c0 .123-.1.222-.222.222"
                  mask="url(#at)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="av" fill="#fff">
                  <use xlinkHref="#au" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M26.073 25.557a.222.222 0 0 1-.222-.222V15.33a.222.222 0 0 1 .444 0v10.005c0 .123-.099.222-.222.222"
                  mask="url(#av)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="ax" fill="#fff">
                  <use xlinkHref="#aw" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M8.732 25.557a.222.222 0 0 1-.157-.38l.444-.444a.222.222 0 1 1 .314.314l-.444.445a.222.222 0 0 1-.157.065"
                  mask="url(#ax)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="az" fill="#fff">
                  <use xlinkHref="#ay" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M9.621 25.557a.221.221 0 0 1-.157-.065l-.445-.445a.222.222 0 0 1 .315-.314l.444.445a.222.222 0 0 1-.157.38"
                  mask="url(#az)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="aB" fill="#fff">
                  <use xlinkHref="#aA" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M9.621 25.557a.222.222 0 0 1-.157-.38l.444-.444a.222.222 0 0 1 .315.314l-.445.445a.222.222 0 0 1-.157.065"
                  mask="url(#aB)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="aD" fill="#fff">
                  <use xlinkHref="#aC" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M10.51 25.557a.222.222 0 0 1-.157-.065l-.444-.445a.222.222 0 0 1 .314-.314l.445.445a.222.222 0 0 1-.158.38"
                  mask="url(#aD)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="aF" fill="#fff">
                  <use xlinkHref="#aE" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M10.51 25.557a.222.222 0 0 1-.157-.38l.445-.444a.222.222 0 0 1 .314.314l-.444.445a.222.222 0 0 1-.158.065"
                  mask="url(#aF)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="aH" fill="#fff">
                  <use xlinkHref="#aG" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M11.4 25.557a.222.222 0 0 1-.157-.065l-.445-.445a.222.222 0 0 1 .314-.314l.445.445a.222.222 0 0 1-.157.38"
                  mask="url(#aH)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="aJ" fill="#fff">
                  <use xlinkHref="#aI" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M11.4 25.557a.222.222 0 0 1-.157-.38l.444-.444a.222.222 0 1 1 .315.314l-.445.445a.222.222 0 0 1-.157.065"
                  mask="url(#aJ)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="aL" fill="#fff">
                  <use xlinkHref="#aK" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M23.405 25.557a.222.222 0 0 1-.157-.065l-.445-.445a.222.222 0 1 1 .315-.314l.444.445a.222.222 0 0 1-.157.38"
                  mask="url(#aL)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="aN" fill="#fff">
                  <use xlinkHref="#aM" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M23.405 25.557a.222.222 0 0 1-.157-.38l.445-.444a.222.222 0 1 1 .314.314l-.445.445a.222.222 0 0 1-.157.065"
                  mask="url(#aN)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="aP" fill="#fff">
                  <use xlinkHref="#aO" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M24.294 25.557a.222.222 0 0 1-.157-.065l-.444-.445a.222.222 0 0 1 .314-.314l.445.445a.222.222 0 0 1-.158.38"
                  mask="url(#aP)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="aR" fill="#fff">
                  <use xlinkHref="#aQ" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M24.294 25.557a.222.222 0 0 1-.157-.38l.445-.444a.222.222 0 1 1 .314.314l-.444.445a.222.222 0 0 1-.158.065"
                  mask="url(#aR)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="aT" fill="#fff">
                  <use xlinkHref="#aS" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M25.184 25.557a.221.221 0 0 1-.157-.065l-.445-.445a.222.222 0 0 1 .314-.314l.445.445a.222.222 0 0 1-.157.38"
                  mask="url(#aT)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="aV" fill="#fff">
                  <use xlinkHref="#aU" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M25.184 25.557a.222.222 0 0 1-.157-.38l.444-.444a.222.222 0 1 1 .314.314l-.444.445a.222.222 0 0 1-.157.065"
                  mask="url(#aV)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="aX" fill="#fff">
                  <use xlinkHref="#aW" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M26.073 25.557a.221.221 0 0 1-.157-.065l-.445-.445a.222.222 0 0 1 .315-.314l.444.445a.222.222 0 0 1-.157.38"
                  mask="url(#aX)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="aZ" fill="#fff">
                  <use xlinkHref="#aY" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M8.732 16.664a.222.222 0 0 1-.057-.437c4.29-1.13 7.27-3.493 9.013-5.276 1.938-1.981 2.843-3.71 2.852-3.727a.222.222 0 0 1 .3-.095c.108.057.151.191.095.3-.038.073-.945 1.804-2.929 3.833-1.783 1.823-4.829 4.24-9.217 5.395a.228.228 0 0 1-.057.007"
                  mask="url(#aZ)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="bb" fill="#fff">
                  <use xlinkHref="#ba" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M26.073 16.664a.222.222 0 0 1-.07-.011 14.348 14.348 0 0 1-.654-.23c-4.76-1.747-7.644-5.14-7.672-5.174a.222.222 0 1 1 .34-.286c.028.033 2.841 3.338 7.488 5.044.209.08.423.153.637.224a.222.222 0 0 1-.069.433"
                  mask="url(#bb)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="bd" fill="#fff">
                  <use xlinkHref="#bc" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M9.621 17.553a.222.222 0 0 1-.222-.222v-.445a.222.222 0 1 1 .444 0v.445c0 .123-.099.222-.222.222"
                  mask="url(#bd)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="bf" fill="#fff">
                  <use xlinkHref="#be" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M25.184 17.553a.222.222 0 0 1-.223-.222v-.445a.222.222 0 1 1 .445 0v.445c0 .123-.1.222-.222.222"
                  mask="url(#bf)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="bh" fill="#fff">
                  <use xlinkHref="#bg" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M19.18 34.895h-.013a.223.223 0 0 1-.208-.237l.445-7.113a.221.221 0 0 1 .235-.209.222.222 0 0 1 .209.235l-.445 7.115a.222.222 0 0 1-.222.209"
                  mask="url(#bh)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="bj" fill="#fff">
                  <use xlinkHref="#bi" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M19.572 28.67a.222.222 0 1 1 0-.445c2.308 0 3.144-2.26 3.18-2.356a.223.223 0 0 1 .283-.134c.116.04.176.168.135.283-.01.027-.972 2.652-3.598 2.652"
                  mask="url(#bj)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="bl" fill="#fff">
                  <use xlinkHref="#bk" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M19.626 27.78a.223.223 0 0 1-.029-.442 3.33 3.33 0 0 0 2.296-1.34c.293-.399.412-.733.413-.736a.225.225 0 0 1 .283-.137c.116.04.177.166.137.282-.006.016-.14.398-.476.855a3.764 3.764 0 0 1-2.624 1.518"
                  mask="url(#bl)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="bn" fill="#fff">
                  <use xlinkHref="#bm" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M15.624 34.895a.222.222 0 0 1-.222-.209l-.387-6.227a.222.222 0 0 1 .21-.233c.122-.014.227.086.234.21l.027.48.36 5.742a.222.222 0 0 1-.208.236h-.014"
                  mask="url(#bn)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="bp" fill="#fff">
                  <use xlinkHref="#bo" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M15.232 28.67a.222.222 0 0 1-.221-.21l-.054-.889a.222.222 0 1 1 .444-.026l.053.889a.222.222 0 0 1-.208.235h-.014"
                  mask="url(#bp)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="br" fill="#fff">
                  <use xlinkHref="#bq" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M15.237 28.67h-.005c-2.625-.005-3.588-2.625-3.597-2.651a.222.222 0 0 1 .419-.15c.034.096.87 2.352 3.179 2.356.123 0 .224.1.224.222a.22.22 0 0 1-.22.223"
                  mask="url(#br)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="bt" fill="#fff">
                  <use xlinkHref="#bs" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M15.18 27.78l-.03-.001a3.764 3.764 0 0 1-2.595-1.516c-.337-.458-.47-.84-.476-.856a.222.222 0 0 1 .42-.145c0 .003.12.337.414.737a3.33 3.33 0 0 0 2.295 1.339.222.222 0 0 1-.029.442"
                  mask="url(#bt)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="bv" fill="#fff">
                  <use xlinkHref="#bu" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M22.96 26.166a.222.222 0 0 1-.18-.09l-.444-.61a.223.223 0 0 1 .36-.262l.444.609a.224.224 0 0 1-.18.353"
                  mask="url(#bv)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="bx" fill="#fff">
                  <use xlinkHref="#bw" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M11.844 26.166a.222.222 0 0 1-.18-.353l.446-.61a.223.223 0 0 1 .358.263l-.444.61a.223.223 0 0 1-.18.09"
                  mask="url(#bx)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="bz" fill="#fff">
                  <use xlinkHref="#by" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M22.071 26.353a.222.222 0 0 1-.222-.222v-1.632a.222.222 0 1 1 .444 0v1.632c0 .123-.099.222-.222.222"
                  mask="url(#bz)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="bB" fill="#fff">
                  <use xlinkHref="#bA" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M12.734 26.353a.222.222 0 0 1-.223-.222v-1.632a.222.222 0 1 1 .445 0v1.632c0 .123-.1.222-.222.222"
                  mask="url(#bB)"
                />
              </g>
              <g transform="translate(1 1.192)">
                <mask id="bD" fill="#fff">
                  <use xlinkHref="#bC" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M17.402 29.337c-.686 0-1.572-.22-1.61-.23a.223.223 0 0 1 .108-.43c.009.001.871.215 1.502.215.632 0 1.494-.214 1.503-.216a.223.223 0 0 1 .107.432c-.037.009-.923.229-1.61.229"
                  mask="url(#bD)"
                />
              </g>
            </g>
          </svg>
        )
      },
      son: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="36"
            height="36"
            viewBox="0 0 36 36">
            <defs>
              <path id="a" d="M0 .185h33.553v33.553H0z" />
              <path
                id="c"
                d="M16.698.185C7.468.227 0 7.722 0 16.962c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.24-7.469-16.735-16.698-16.777h-.157z"
              />
              <path
                id="e"
                d="M16.698.185C7.468.227 0 7.722 0 16.962c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.24-7.469-16.735-16.698-16.777h-.157z"
              />
              <path
                id="g"
                d="M16.698.185C7.468.227 0 7.722 0 16.962c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.24-7.469-16.735-16.698-16.777h-.157z"
              />
              <path
                id="i"
                d="M16.698.185C7.468.227 0 7.722 0 16.962c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.24-7.469-16.735-16.698-16.777h-.157z"
              />
              <path
                id="k"
                d="M16.698.185C7.468.227 0 7.722 0 16.962c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.24-7.469-16.735-16.698-16.777h-.157z"
              />
              <path
                id="m"
                d="M16.698.185C7.468.227 0 7.722 0 16.962c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.24-7.469-16.735-16.698-16.777h-.157z"
              />
              <path
                id="o"
                d="M16.698.185C7.468.227 0 7.722 0 16.962c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.24-7.469-16.735-16.698-16.777"
              />
              <path
                id="q"
                d="M16.698.185C7.468.227 0 7.722 0 16.962c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.24-7.469-16.735-16.698-16.777"
              />
              <path
                id="s"
                d="M16.698.185C7.468.227 0 7.722 0 16.962c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.24-7.469-16.735-16.698-16.777"
              />
              <path
                id="u"
                d="M16.698.185C7.468.227 0 7.722 0 16.962c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.24-7.469-16.735-16.698-16.777h-.157z"
              />
              <path
                id="w"
                d="M16.698.185C7.468.227 0 7.722 0 16.962c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.24-7.469-16.735-16.698-16.777"
              />
              <path
                id="y"
                d="M16.698.185C7.468.227 0 7.722 0 16.962c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.24-7.469-16.735-16.698-16.777"
              />
              <path
                id="A"
                d="M16.698.185C7.468.227 0 7.722 0 16.962c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.24-7.469-16.735-16.698-16.777h-.157z"
              />
            </defs>
            <g fill="none" fillRule="evenodd">
              <g transform="translate(1 1.038)">
                <mask id="b" fill="#fff">
                  <use xlinkHref="#a" />
                </mask>
                <path
                  fill="#F1F2F2"
                  d="M33.553 16.961c0 9.266-7.511 16.777-16.777 16.777C7.511 33.738 0 26.227 0 16.96 0 7.696 7.51.185 16.776.185s16.777 7.511 16.777 16.776"
                  mask="url(#b)"
                />
              </g>
              <g transform="translate(1 1.038)">
                <mask id="d" fill="#fff">
                  <use xlinkHref="#c" />
                </mask>
                <path fill="#E6E9ED" d="M16.73 27.308l-.646-.265-.646.265v6.701h1.291z" mask="url(#d)" />
                <mask id="f" fill="#fff">
                  <use xlinkHref="#e" />
                </mask>
                <path
                  fill="#94C1FF"
                  d="M29.208 34.01H16.73v-6.702l-.43-.184 3.012 1.291 2.105-2.947.907.65c1.308.722 3.28 1.484 4.303 1.867 1.722.642 2.582 1.291 2.582 3.012v3.012z"
                  mask="url(#f)"
                />
                <mask id="h" fill="#fff">
                  <use xlinkHref="#g" />
                </mask>
                <path
                  fill="#94C1FF"
                  d="M15.438 27.308v6.701H2.96v-3.012c0-1.72.86-2.37 2.581-3.012 1.02-.383 2.996-1.145 4.303-1.867l.908-.65 2.105 2.947 3.012-1.291-.43.184z"
                  mask="url(#h)"
                />
                <mask id="j" fill="#fff">
                  <use xlinkHref="#i" />
                </mask>
                <path
                  fill="#D7E9FF"
                  d="M3.82 31.427c0-1.72.86-2.37 2.582-3.012 1.02-.383 2.995-1.144 4.303-1.867l.542-.387-.495-.693-.907.65c-1.309.722-3.284 1.484-4.304 1.867-1.72.642-2.581 1.291-2.581 3.012v3.012h.86v-2.582z"
                  mask="url(#j)"
                />
                <mask id="l" fill="#fff">
                  <use xlinkHref="#k" />
                </mask>
                <path
                  fill="#E6E9ED"
                  d="M20.68 23.847l-4.596 2.416-4.597-2.416-.782 1.555 2.152 3.013 3.227-1.372 3.227 1.372 2.152-3.013z"
                  mask="url(#l)"
                />
                <mask id="n" fill="#fff">
                  <use xlinkHref="#m" />
                </mask>
                <path
                  fill="#E6E9ED"
                  d="M20.68 23.847l-4.596 2.416-4.597-2.416-.782 1.555 2.152 3.013 3.227-1.372 3.227 1.372 2.152-3.013z"
                  mask="url(#n)"
                />
                <mask id="p" fill="#fff">
                  <use xlinkHref="#o" />
                </mask>
                <path
                  fill="#94C1FF"
                  d="M20.056 10.183s4.621-.64 3.558 6.184l-1.89-3.09s-2.994 1.235-5.7 1.235c-2.711 0-5.672-1.235-5.672-1.235l-1.798 3.09c-1.072-11.425 12.271-9.35 12.74-9.273-2.022.83-1.238 3.09-1.238 3.09"
                  mask="url(#p)"
                />
                <mask id="r" fill="#fff">
                  <use xlinkHref="#q" />
                </mask>
                <path
                  fill="#5C9EFF"
                  d="M20.056 10.183s3.204-.563 2.832 4.997l.726 1.187c1.063-6.824-3.558-6.184-3.558-6.184"
                  mask="url(#r)"
                />
                <mask id="t" fill="#fff">
                  <use xlinkHref="#s" />
                </mask>
                <path
                  fill="#D7E9FF"
                  d="M19.004 6.905c-3.889-.09-11.257.857-10.45 9.462l.809-1.39c.076-6.771 5.87-7.996 9.64-8.072"
                  mask="url(#t)"
                />
                <mask id="v" fill="#fff">
                  <use xlinkHref="#u" />
                </mask>
                <path
                  fill="#D7E9FF"
                  d="M23.614 16.367v.86c0 4.928-4.664 9.037-7.53 9.037-2.866 0-7.53-4.11-7.53-9.036v-.861l1.798-3.09s2.96 1.235 5.671 1.235c2.708 0 5.702-1.235 5.702-1.235l1.89 3.09z"
                  mask="url(#v)"
                />
                <mask id="x" fill="#fff">
                  <use xlinkHref="#w" />
                </mask>
                <path
                  fill="#FFF"
                  d="M9.414 17.228v-.861l1.645-2.825c-.44-.154-.707-.265-.707-.265l-1.799 3.09v.86c0 4.928 4.665 9.037 7.53 9.037.14 0 .284-.013.431-.031-2.878-.372-7.1-4.318-7.1-9.005"
                  mask="url(#x)"
                />
                <mask id="z" fill="#fff">
                  <use xlinkHref="#y" />
                </mask>
                <path
                  fill="#94C1FF"
                  d="M22.754 17.228v-.861l-1.645-2.825c.44-.154.707-.265.707-.265l1.798 3.09v.86c0 4.928-4.664 9.037-7.53 9.037-.139 0-.283-.013-.43-.031 2.878-.372 7.1-4.318 7.1-9.005"
                  mask="url(#z)"
                />
                <mask id="B" fill="#fff">
                  <use xlinkHref="#A" />
                </mask>
                <path fill="#94C1FF" d="M20.172 34.01h4.303v-1.723h-4.303z" mask="url(#B)" />
                <path fill="#D7E9FF" d="M22.754 30.566l-1.291 1.291v.43h2.581v-.43z" mask="url(#B)" />
                <path fill="#FFF" d="M21.893 30.566l-1.291 1.291v.43h2.582v-.43z" mask="url(#B)" />
                <path fill="#D7E9FF" d="M20.172 34.01h.43v-1.723h-.43z" mask="url(#B)" />
                <path
                  fill="#5C9EFF"
                  d="M24.044 34.01h.43v-1.723h-.43zM28.348 31.427c0-1.72-.861-2.37-2.582-3.012-1.02-.383-2.995-1.144-4.303-1.867l-.542-.387.495-.693.907.65c1.308.722 3.283 1.484 4.303 1.867 1.722.642 2.582 1.291 2.582 3.012v3.012h-.86v-2.582z"
                  mask="url(#B)"
                />
                <path
                  fill="#116FFF"
                  d="M29.638 34.224H3.39a.215.215 0 0 1-.215-.215v-3.013c0-1.847.956-2.554 2.722-3.213 1.858-.695 3.336-1.336 4.273-1.856a.215.215 0 0 1 .209.376c-.956.53-2.454 1.181-4.332 1.883-1.654.618-2.442 1.196-2.442 2.81v2.797h25.818v-2.797c0-1.614-.787-2.192-2.442-2.81-1.91-.715-3.368-1.349-4.332-1.883a.216.216 0 0 1 .208-.377c.946.525 2.385 1.15 4.275 1.857 1.765.66 2.722 1.366 2.722 3.213v3.013a.215.215 0 0 1-.216.215"
                  mask="url(#B)"
                />
                <path
                  fill="#116FFF"
                  d="M16.514 26.478c-2.988 0-7.745-4.234-7.745-9.251a.215.215 0 1 1 .43 0c0 4.784 4.493 8.82 7.315 8.82s7.315-4.036 7.315-8.82a.215.215 0 1 1 .43 0c0 5.017-4.757 9.251-7.745 9.251M16.527 28.2a.217.217 0 0 1-.217-.216c0-.119.094-.215.213-.215h.004a.215.215 0 1 1 0 .43M16.527 29.92a.217.217 0 0 1-.217-.215c0-.119.094-.215.213-.215h.004a.215.215 0 1 1 0 .43M16.527 31.642a.217.217 0 0 1-.217-.215c0-.12.094-.216.213-.216h.004a.215.215 0 1 1 0 .43M16.527 33.363a.217.217 0 0 1-.217-.215c0-.12.094-.215.213-.215h.004a.215.215 0 1 1 0 .43"
                  mask="url(#B)"
                />
                <path
                  fill="#116FFF"
                  d="M21.893 25.618a.215.215 0 0 1-.192-.12l-.43-.86a.215.215 0 0 1 .384-.192l.43.86a.215.215 0 0 1-.192.312"
                  mask="url(#B)"
                />
                <path
                  fill="#116FFF"
                  d="M19.741 28.63a.214.214 0 0 1-.175-.34l2.152-3.013a.215.215 0 1 1 .35.25l-2.152 3.013a.213.213 0 0 1-.175.09"
                  mask="url(#B)"
                />
                <path
                  fill="#116FFF"
                  d="M19.741 28.63a.208.208 0 0 1-.085-.018l-3.011-1.29a.215.215 0 1 1 .169-.396l3.012 1.291a.215.215 0 0 1-.085.413M11.135 25.618a.215.215 0 0 1-.192-.311l.43-.861a.215.215 0 1 1 .385.192l-.43.86a.215.215 0 0 1-.193.12"
                  mask="url(#B)"
                />
                <path
                  fill="#116FFF"
                  d="M13.287 28.63a.214.214 0 0 1-.175-.09l-2.152-3.012a.215.215 0 0 1 .35-.25l2.152 3.011a.214.214 0 0 1-.175.34"
                  mask="url(#B)"
                />
                <path
                  fill="#116FFF"
                  d="M13.287 28.63a.215.215 0 0 1-.085-.413l3.012-1.29a.214.214 0 1 1 .17.394l-3.012 1.291a.206.206 0 0 1-.085.018M22.154 13.06c.073 0 .143.037.184.103l1.575 2.575c.227-1.987-.05-3.452-.827-4.359-.742-.866-1.754-.996-2.291-.996-.167 0-.271.014-.278.015a.218.218 0 0 1-.232-.143c-.008-.022-.665-1.978.764-3.032a19.905 19.905 0 0 0-2.077-.109c-2.527 0-5.975.479-8.048 2.754-1.284 1.41-1.88 3.354-1.774 5.785l1.449-2.486a.216.216 0 0 1 .268-.09c.03.012 2.953 1.22 5.586 1.22 2.634 0 5.59-1.208 5.62-1.22a.21.21 0 0 1 .08-.017m-13.17 3.521a.216.216 0 0 1-.214-.195c-.27-2.883.348-5.173 1.837-6.807 2.178-2.393 5.752-2.895 8.366-2.895 1.528 0 2.662.177 2.786.197a.215.215 0 0 1 .047.411c-1.538.633-1.289 2.165-1.16 2.664.043-.002.093-.003.15-.003.61 0 1.764.149 2.618 1.146.937 1.096 1.221 2.879.844 5.3a.215.215 0 0 1-.396.08l-1.796-2.937c-.68.264-3.23 1.185-5.612 1.185-2.376 0-4.893-.916-5.576-1.183l-1.707 2.93a.215.215 0 0 1-.186.107M17.16 34.224a.215.215 0 0 1-.215-.215v-6.025a.215.215 0 1 1 .43 0v6.025a.215.215 0 0 1-.215.215M15.869 34.224a.215.215 0 0 1-.215-.215v-6.025a.215.215 0 0 1 .43 0v6.025a.215.215 0 0 1-.215.215M24.905 32.502h-4.303a.215.215 0 1 1 0-.43h4.303a.215.215 0 1 1 0 .43"
                  mask="url(#B)"
                />
                <path
                  fill="#116FFF"
                  d="M20.602 33.363a.215.215 0 0 1-.215-.215v-.86a.215.215 0 1 1 .43 0v.86a.215.215 0 0 1-.215.215M24.905 33.363a.215.215 0 0 1-.215-.215v-.86a.215.215 0 0 1 .43 0v.86a.215.215 0 0 1-.215.215M21.032 32.072a.216.216 0 0 1-.152-.367l1.291-1.291a.215.215 0 0 1 .304.304l-1.29 1.291a.216.216 0 0 1-.153.063"
                  mask="url(#B)"
                />
                <path
                  fill="#116FFF"
                  d="M23.614 32.072a.216.216 0 0 1-.152-.063l-1.29-1.29a.215.215 0 1 1 .303-.305l1.291 1.29a.215.215 0 0 1-.152.368M24.475 32.072a.215.215 0 0 1-.152-.063l-1.291-1.29a.215.215 0 0 1 .304-.305l1.291 1.29a.216.216 0 0 1-.152.368"
                  mask="url(#B)"
                />
              </g>
            </g>
          </svg>
        )
      },
      daughter: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="36"
            height="36"
            viewBox="0 0 36 36">
            <defs>
              <path id="a" d="M0 .193h33.553v33.553H0z" />
              <path
                id="c"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.266-7.511-16.777-16.777-16.777z"
              />
              <path
                id="e"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="g"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.266-7.511-16.777-16.777-16.777z"
              />
              <path
                id="i"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.266-7.511-16.777-16.777-16.777z"
              />
              <path
                id="k"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.266-7.511-16.777-16.777-16.777z"
              />
              <path
                id="m"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.266-7.511-16.777-16.777-16.777z"
              />
              <path
                id="o"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="q"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="s"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="u"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.266-7.511-16.777-16.777-16.777z"
              />
              <path
                id="w"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="y"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="A"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="C"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="E"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="G"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="I"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="K"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="M"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.266-7.511-16.777-16.777-16.777z"
              />
              <path
                id="O"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="Q"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="S"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.266-7.511-16.777-16.777-16.777z"
              />
              <path
                id="U"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776c0-9.266-7.511-16.777-16.777-16.777z"
              />
              <path
                id="W"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="Y"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="aa"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="ac"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="ae"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="ag"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="ai"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="ak"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="am"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="ao"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="aq"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="as"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="au"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="aw"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="ay"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="aA"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="aC"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="aE"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="aG"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="aI"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="aK"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="aM"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="aO"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="aQ"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="aS"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="aU"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="aW"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="aY"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
              <path
                id="ba"
                d="M16.776.193C7.511.193 0 7.704 0 16.97c0 9.265 7.51 16.776 16.776 16.776s16.777-7.511 16.777-16.776"
              />
            </defs>
            <g fill="none" fillRule="evenodd">
              <g transform="translate(1 1.03)">
                <mask id="b" fill="#fff">
                  <use xlinkHref="#a" />
                </mask>
                <path
                  fill="#F1F2F2"
                  d="M33.553 16.97c0 9.265-7.511 16.776-16.777 16.776C7.511 33.746 0 26.235 0 16.97 0 7.704 7.51.193 16.776.193S33.553 7.704 33.553 16.97"
                  mask="url(#b)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="d" fill="#fff">
                  <use xlinkHref="#c" />
                </mask>
                <path
                  fill="#5C9EFF"
                  d="M10.983 15.592s.572 6.708-1.191 5.392c-1.764-1.315-1.737-4.557-1.737-4.557l2.928-.835z"
                  mask="url(#d)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="f" fill="#fff">
                  <use xlinkHref="#e" />
                </mask>
                <path
                  fill="#94C1FF"
                  d="M28.457 31.402v2.605H4.583v-2.605c0-1.736.868-2.387 2.604-3.038.356-.135.807-.27 1.294-.425.278-.092.573-.187.864-.291l.013.034s1.302 3.286 7.162 3.286c5.86 0 7.162-3.286 7.162-3.286l.013-.034c.799.286 1.593.508 2.157.716 1.736.65 2.605 1.302 2.605 3.038"
                  mask="url(#f)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="h" fill="#fff">
                  <use xlinkHref="#g" />
                </mask>
                <path
                  fill="#D7E9FF"
                  d="M5.451 31.836c0-1.736.868-2.387 2.604-3.038.356-.135.808-.27 1.294-.425l.348-.115c-.245-.342-.34-.575-.34-.575l-.012-.035c-.292.103-.586.199-.864.29-.486.156-.938.291-1.294.426-1.736.65-2.604 1.302-2.604 3.038v2.605h.868v-2.17z"
                  mask="url(#h)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="j" fill="#fff">
                  <use xlinkHref="#i" />
                </mask>
                <path
                  fill="#5C9EFF"
                  d="M27.589 31.836c0-1.736-.869-2.387-2.605-3.038-.356-.135-.807-.27-1.294-.425l-.348-.115c.246-.342.34-.575.34-.575l.013-.035c.29.103.586.199.864.29.486.156.937.291 1.293.426 1.737.65 2.605 1.302 2.605 3.038v2.605h-.868v-2.17z"
                  mask="url(#j)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="l" fill="#fff">
                  <use xlinkHref="#k" />
                </mask>
                <path
                  fill="#D7E9FF"
                  d="M20.643 24.891c0 1.424 1.537 2.21 3.052 2.757l-.013.035s-1.302 3.285-7.162 3.285c-5.86 0-7.162-3.285-7.162-3.285l-.013-.035c1.514-.547 3.051-1.333 3.051-2.757v-1.25c1.372 1.31 2.908 2.118 4.124 2.118 1.215 0 2.752-.811 4.123-2.118v1.25z"
                  mask="url(#l)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="n" fill="#fff">
                  <use xlinkHref="#m" />
                </mask>
                <path
                  fill="#94C1FF"
                  d="M9.358 27.682s1.302 3.286 7.162 3.286c5.86 0 7.162-3.286 7.162-3.286l.013-.034a10.442 10.442 0 0 1-.188-.07c-.51.832-2.274 2.956-6.987 2.956s-6.477-2.124-6.987-2.957a11.17 11.17 0 0 1-.189.07l.014.035z"
                  mask="url(#n)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="p" fill="#fff">
                  <use xlinkHref="#o" />
                </mask>
                <path
                  fill="#FFF"
                  d="M10.062 28.266c1.466-.573 3.202-1.603 3.202-2.94v-.511a10.549 10.549 0 0 1-.868-.74v.816c0 1.365-1.412 2.143-2.863 2.686.11.181.284.423.529.69"
                  mask="url(#p)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="r" fill="#fff">
                  <use xlinkHref="#q" />
                </mask>
                <path fill="#FFF" d="M9.778 28.367l.003.005h.001l-.004-.005" mask="url(#r)" />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="t" fill="#fff">
                  <use xlinkHref="#s" />
                </mask>
                <path
                  fill="#94C1FF"
                  d="M22.974 28.27c.246-.266.42-.508.53-.688-1.455-.545-2.873-1.323-2.873-2.69v-.817c-.284.271-.575.515-.868.74v.51c0 1.34 1.743 2.372 3.211 2.945"
                  mask="url(#t)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="v" fill="#fff">
                  <use xlinkHref="#u" />
                </mask>
                <path
                  fill="#5C9EFF"
                  d="M22.024 23.155l.531 5.21.259 2.603.434 1.736.434-1.736.254-2.604 1.024-12.772-.85-.33-2.29 6.048z"
                  mask="url(#v)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="x" fill="#fff">
                  <use xlinkHref="#w" />
                </mask>
                <path
                  fill="#F6BB42"
                  d="M24.984 15.124c0-4.64-3.736-8.404-8.364-8.459.518 1.996 1.355 5.204 1.355 5.204s2.911 2.236 6.986 3.723c.008-.156.023-.31.023-.468"
                  mask="url(#x)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="z" fill="#fff">
                  <use xlinkHref="#y" />
                </mask>
                <path
                  fill="#FFCE54"
                  d="M16.52 6.66a8.465 8.465 0 0 0-8.465 8.464c0 .436.044.86.107 1.279 7.62-1.618 13.747-7.74 13.782-7.773a8.426 8.426 0 0 0-5.424-1.97"
                  mask="url(#z)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="B" fill="#fff">
                  <use xlinkHref="#A" />
                </mask>
                <path
                  fill="#94C1FF"
                  d="M24.984 15.124a8.438 8.438 0 0 0-3.038-6.493c-1.446-1.208-3.971 3.238-3.971 3.238s2.911 2.236 6.986 3.723c.008-.156.023-.31.023-.468"
                  mask="url(#B)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="D" fill="#fff">
                  <use xlinkHref="#C" />
                </mask>
                <path
                  fill="#94C1FF"
                  d="M16.52 6.66a8.465 8.465 0 0 0-8.465 8.464c0 .436.044.86.107 1.279 7.62-1.618 13.747-7.74 13.782-7.773a8.426 8.426 0 0 0-5.424-1.97"
                  mask="url(#D)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="F" fill="#fff">
                  <use xlinkHref="#E" />
                </mask>
                <path
                  fill="#5C9EFF"
                  d="M21.946 8.63h-.002a8.426 8.426 0 0 0-5.424-1.97c-.138 0-.272.014-.408.021a8.423 8.423 0 0 1 4.964 1.948l.001.002a8.438 8.438 0 0 1 3.039 6.493c0 .047-.005.092-.007.139.278.112.561.223.852.33.008-.157.023-.31.023-.469a8.44 8.44 0 0 0-3.038-6.493"
                  mask="url(#F)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="H" fill="#fff">
                  <use xlinkHref="#G" />
                </mask>
                <path
                  fill="#FFF"
                  d="M8.924 15.124c0-4.536 3.572-8.23 8.056-8.443-.153-.008-.305-.021-.46-.021a8.465 8.465 0 0 0-8.465 8.464c0 .436.044.86.107 1.279.284-.06.565-.129.844-.202a8.017 8.017 0 0 1-.082-1.077"
                  mask="url(#H)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="J" fill="#fff">
                  <use xlinkHref="#I" />
                </mask>
                <path
                  fill="#D7E9FF"
                  d="M17.974 11.869s2.5 1.93 6.142 3.398v.943c0 2.878-1.58 5.63-3.472 7.431-1.372 1.307-2.909 2.118-4.124 2.118-1.216 0-2.752-.807-4.124-2.118-1.702-1.62-3.151-4.007-3.425-6.563v-.863c3.525-.904 6.685-2.72 9.003-4.346"
                  mask="url(#J)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="L" fill="#fff">
                  <use xlinkHref="#K" />
                </mask>
                <path
                  fill="#000"
                  d="M20.643 24.075v-.434c-1.371 1.306-2.908 2.118-4.123 2.118-1.216 0-2.752-.807-4.124-2.118v.434c1.372 1.31 2.908 2.118 4.124 2.118 1.215 0 2.752-.811 4.123-2.118"
                  mask="url(#L)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="N" fill="#fff">
                  <use xlinkHref="#M" />
                </mask>
                <path
                  fill="#94C1FF"
                  d="M23.248 14.903v1.307c0 2.877-1.58 5.63-3.473 7.431-1.213 1.156-2.555 1.922-3.69 2.084.148.021.294.034.435.034 1.215 0 2.752-.811 4.123-2.118 1.893-1.801 3.473-4.554 3.473-7.431v-.943l-.868-.364z"
                  mask="url(#N)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="P" fill="#fff">
                  <use xlinkHref="#O" />
                </mask>
                <path
                  fill="#FFF"
                  d="M13.264 23.641c-1.701-1.62-3.151-4.007-3.425-6.563l-.037-1.095-.83.232v.863c.273 2.556 1.723 4.944 3.424 6.563 1.372 1.31 2.908 2.118 4.124 2.118.14 0 .285-.013.433-.034-1.135-.162-2.476-.925-3.689-2.084"
                  mask="url(#P)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="R" fill="#fff">
                  <use xlinkHref="#Q" />
                </mask>
                <path fill="#D7E9FF" d="M22.597 29.665a.651.651 0 1 0 1.302 0 .651.651 0 0 0-1.302 0" mask="url(#R)" />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="T" fill="#fff">
                  <use xlinkHref="#S" />
                </mask>
                <path fill="#D7E9FF" d="M22.814 30.15l-1.737.818v-2.605l1.685.868z" mask="url(#T)" />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="V" fill="#fff">
                  <use xlinkHref="#U" />
                </mask>
                <path fill="#D7E9FF" d="M23.708 29.182l1.736-.819v2.605L23.76 30.1z" mask="url(#V)" />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="X" fill="#fff">
                  <use xlinkHref="#W" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M16.52 25.977c-2.974 0-7.273-4.305-7.765-8.876a.217.217 0 0 1 .192-.239.214.214 0 0 1 .24.193c.22 2.053 1.271 4.221 2.883 5.95 1.46 1.565 3.165 2.538 4.45 2.538 2.775 0 7.379-4.52 7.379-9.333a.217.217 0 0 1 .434 0c0 5.202-4.87 9.767-7.813 9.767"
                  mask="url(#X)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="Z" fill="#fff">
                  <use xlinkHref="#Y" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M28.457 34.224H4.583a.217.217 0 0 1-.217-.218v-2.604c0-1.862.965-2.576 2.745-3.242.28-.104.615-.21.98-.327 1.725-.548 4.088-1.298 4.088-2.942a.217.217 0 0 1 .434 0c0 1.961-2.537 2.767-4.39 3.356a21.52 21.52 0 0 0-.96.32c-1.669.624-2.463 1.207-2.463 2.835v2.388h23.44v-2.388c0-1.532-.717-2.12-2.038-2.668a.217.217 0 0 1 .166-.4c1.424.59 2.306 1.309 2.306 3.068v2.604c0 .12-.097.218-.217.218"
                  mask="url(#Z)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="ab" fill="#fff">
                  <use xlinkHref="#aa" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M21.64 26.844a.216.216 0 0 1-.13-.044c-.719-.54-1.084-1.183-1.084-1.909a.217.217 0 1 1 .435 0c0 .59.297 1.101.91 1.563a.217.217 0 0 1-.13.39"
                  mask="url(#ab)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="ad" fill="#fff">
                  <use xlinkHref="#ac" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M12.396 25.108a.217.217 0 0 1-.217-.217v-1.248a.217.217 0 1 1 .434 0v1.248c0 .12-.097.217-.217.217"
                  mask="url(#ad)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="af" fill="#fff">
                  <use xlinkHref="#ae" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M20.643 25.108a.217.217 0 0 1-.217-.217v-1.249a.217.217 0 1 1 .435 0v1.25c0 .119-.098.216-.218.216"
                  mask="url(#af)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="ah" fill="#fff">
                  <use xlinkHref="#ag" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M24.984 15.342a.217.217 0 0 1-.217-.218c0-4.547-3.7-8.247-8.247-8.247-4.548 0-8.248 3.7-8.248 8.247a.217.217 0 1 1-.434 0c0-4.786 3.895-8.68 8.682-8.68 4.786 0 8.681 3.894 8.681 8.68 0 .12-.097.218-.217.218"
                  mask="url(#ah)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="aj" fill="#fff">
                  <use xlinkHref="#ai" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M9.791 21.202a.215.215 0 0 1-.13-.044c-1.802-1.351-1.823-4.594-1.823-4.731a.217.217 0 1 1 .434 0c0 .031.022 3.163 1.65 4.384a.216.216 0 0 1-.13.39"
                  mask="url(#aj)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="al" fill="#fff">
                  <use xlinkHref="#ak" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M8.055 16.644a.217.217 0 0 1-.044-.43c7.537-1.555 13.72-7.678 13.781-7.74a.217.217 0 1 1 .307.307c-.062.063-6.334 6.277-14 7.858a.2.2 0 0 1-.044.005"
                  mask="url(#al)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="an" fill="#fff">
                  <use xlinkHref="#am" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M24.975 15.815a.217.217 0 0 1-.074-.014c-4.067-1.481-7.029-3.737-7.058-3.76a.217.217 0 1 1 .264-.344c.03.022 2.942 2.24 6.942 3.697a.217.217 0 0 1-.074.42"
                  mask="url(#an)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="ap" fill="#fff">
                  <use xlinkHref="#ao" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M16.52 31.185c-5.94 0-7.309-3.285-7.364-3.424a.217.217 0 0 1 .403-.16c.013.03 1.336 3.15 6.96 3.15 1.355 0 2.573-.18 3.621-.535a.217.217 0 1 1 .139.411c-1.093.37-2.358.558-3.76.558"
                  mask="url(#ap)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="ar" fill="#fff">
                  <use xlinkHref="#aq" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M23.734 29.449a.217.217 0 0 1-.1-.41l1.685-.869a.217.217 0 1 1 .199.386l-1.685.869a.21.21 0 0 1-.1.024"
                  mask="url(#ar)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="at" fill="#fff">
                  <use xlinkHref="#as" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M25.418 31.185a.217.217 0 0 1-.217-.217v-2.605a.217.217 0 1 1 .434 0v2.605c0 .12-.097.217-.217.217"
                  mask="url(#at)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="av" fill="#fff">
                  <use xlinkHref="#au" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M25.418 31.185a.21.21 0 0 1-.099-.024l-1.685-.869a.217.217 0 1 1 .199-.386l1.684.87a.217.217 0 0 1-.099.41"
                  mask="url(#av)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="ax" fill="#fff">
                  <use xlinkHref="#aw" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M21.077 31.185a.217.217 0 0 1-.099-.41l1.686-.869a.217.217 0 1 1 .198.386l-1.685.869a.21.21 0 0 1-.1.024"
                  mask="url(#ax)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="az" fill="#fff">
                  <use xlinkHref="#ay" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M21.077 31.185a.217.217 0 0 1-.217-.217v-2.605a.217.217 0 1 1 .435 0v2.605c0 .12-.098.217-.218.217"
                  mask="url(#az)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="aB" fill="#fff">
                  <use xlinkHref="#aA" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M22.762 29.448a.214.214 0 0 1-.099-.024l-1.685-.868a.217.217 0 0 1 .199-.386l1.684.869a.217.217 0 0 1-.099.41"
                  mask="url(#aB)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="aD" fill="#fff">
                  <use xlinkHref="#aC" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M23.248 29.231a.435.435 0 1 0 .001.87.435.435 0 0 0-.001-.87m0 1.302a.869.869 0 1 1 .001-1.737.869.869 0 0 1-.001 1.737"
                  mask="url(#aD)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="aF" fill="#fff">
                  <use xlinkHref="#aE" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M23.248 32.922a.217.217 0 0 1-.212-.262c.037-.175.107-.435.181-.711.097-.357.207-.763.251-1.018a.217.217 0 0 1 .427.074c-.047.275-.155.673-.259 1.058-.072.267-.14.517-.176.686a.217.217 0 0 1-.212.173"
                  mask="url(#aF)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="aH" fill="#fff">
                  <use xlinkHref="#aG" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M23.936 28.58a.217.217 0 0 1-.215-.244c.704-5.68 1.034-12.679 1.038-12.749.005-.12.096-.217.226-.206.12.006.213.107.207.227-.003.07-.334 7.085-1.04 12.782a.217.217 0 0 1-.216.19"
                  mask="url(#aH)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="aJ" fill="#fff">
                  <use xlinkHref="#aI" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M23.243 32.922c-.1 0-.19-.07-.212-.173a15.24 15.24 0 0 0-.172-.675 13.841 13.841 0 0 1-.259-1.069.217.217 0 1 1 .427-.074c.045.259.155.67.252 1.032.072.27.14.525.177.696a.217.217 0 0 1-.213.263"
                  mask="url(#aJ)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="aL" fill="#fff">
                  <use xlinkHref="#aK" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M22.555 28.581a.217.217 0 0 1-.215-.19 138.669 138.669 0 0 1-.533-5.218.217.217 0 1 1 .433-.036c.163 1.928.342 3.678.53 5.2a.217.217 0 0 1-.215.244"
                  mask="url(#aL)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="aN" fill="#fff">
                  <use xlinkHref="#aM" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M24.975 15.815h-.004a.217.217 0 0 1-.213-.221l.01-.474c.002-.12.105-.233.22-.213.12.002.215.102.213.222l-.009.473a.217.217 0 0 1-.217.213"
                  mask="url(#aN)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="aP" fill="#fff">
                  <use xlinkHref="#aO" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M8.055 16.644a.217.217 0 0 1-.217-.217v-1.303a.217.217 0 1 1 .434 0v1.303c0 .12-.097.217-.217.217"
                  mask="url(#aP)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="aR" fill="#fff">
                  <use xlinkHref="#aQ" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M24.116 25.108a.217.217 0 0 1-.153-.063l-1.737-1.737a.217.217 0 1 1 .307-.307l1.737 1.737a.217.217 0 0 1-.154.37"
                  mask="url(#aR)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="aT" fill="#fff">
                  <use xlinkHref="#aS" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M22.38 25.108a.217.217 0 0 1-.154-.37L23.963 23a.217.217 0 1 1 .306.307l-1.736 1.737a.217.217 0 0 1-.153.063"
                  mask="url(#aT)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="aV" fill="#fff">
                  <use xlinkHref="#aU" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M24.126 26.855a.218.218 0 0 1-.153-.064l-1.747-1.747a.217.217 0 1 1 .307-.306l1.747 1.746a.217.217 0 0 1-.154.37"
                  mask="url(#aV)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="aX" fill="#fff">
                  <use xlinkHref="#aW" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M22.38 26.844a.217.217 0 0 1-.154-.37l1.737-1.736a.217.217 0 1 1 .306.307l-1.736 1.736a.217.217 0 0 1-.153.063"
                  mask="url(#aX)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="aZ" fill="#fff">
                  <use xlinkHref="#aY" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M23.956 28.416a.217.217 0 0 1-.153-.064l-1.577-1.576a.217.217 0 1 1 .307-.307l1.577 1.576a.217.217 0 0 1-.154.37"
                  mask="url(#aZ)"
                />
              </g>
              <g transform="translate(1 1.03)">
                <mask id="bb" fill="#fff">
                  <use xlinkHref="#ba" />
                </mask>
                <path
                  fill="#116FFF"
                  d="M22.54 28.416a.217.217 0 0 1-.154-.37l1.577-1.577a.217.217 0 1 1 .306.307l-1.576 1.576a.217.217 0 0 1-.154.064"
                  mask="url(#bb)"
                />
              </g>
            </g>
          </svg>
        )
      },
      spouse: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="36"
            height="36"
            viewBox="0 0 36 36">
            <defs>
              <path
                id="a"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="c"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="e"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="g"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="i"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="k"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="m"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="o"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="q"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="s"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959z"
              />
              <path
                id="u"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="w"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="y"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="A"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959z"
              />
              <path
                id="C"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="E"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="G"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="I"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="K"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="M"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="O"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="Q"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="S"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="U"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="W"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="Y"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="aa"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="ac"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="ae"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="ag"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="ai"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="ak"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="am"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="ao"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="aq"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="as"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="au"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="aw"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="ay"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="aA"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="aC"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="aE"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="aG"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="aI"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
              <path
                id="aK"
                d="M0 16.959c0 9.265 7.511 16.776 16.776 16.776 9.266 0 16.776-7.51 16.776-16.776S26.042.183 16.776.183C7.511.183 0 7.693 0 16.959"
              />
            </defs>
            <g fill="none" fillRule="evenodd">
              <path
                fill="#F1F2F2"
                d="M34.553 18c0 9.265-7.511 16.776-16.777 16.776C8.511 34.776 1 27.266 1 18 1 8.735 8.51 1.224 17.776 1.224c9.266 0 16.777 7.51 16.777 16.776"
              />
              <path d="M34.553 18c0 9.265-7.511 16.776-16.777 16.776C8.511 34.776 1 27.266 1 18 1 8.735 8.51 1.224 17.776 1.224c9.266 0 16.777 7.51 16.777 16.776z" />
              <g>
                <g transform="translate(1 1.041)">
                  <mask id="b" fill="#fff">
                    <use xlinkHref="#a" />
                  </mask>
                  <path
                    fill="#D7E9FF"
                    d="M14.298 28.171a.433.433 0 0 0-.432-.431.433.433 0 0 0-.432.431c0 .238.195.432.432.432a.433.433 0 0 0 .432-.432m1.295.864a.433.433 0 0 0-.432-.432.433.433 0 0 0-.431.432c0 .237.194.432.431.432a.433.433 0 0 0 .432-.432m1.727.432a.433.433 0 0 0-.432-.432.433.433 0 0 0-.431.432c0 .237.194.431.431.431a.433.433 0 0 0 .432-.431m1.727-.432a.433.433 0 0 0-.432-.432.433.433 0 0 0-.431.432c0 .237.194.432.431.432a.433.433 0 0 0 .432-.432m1.295-.864a.433.433 0 0 0-.431-.431.433.433 0 0 0-.432.431c0 .238.194.432.432.432a.433.433 0 0 0 .431-.432m3.666.583l-.013.035s-1.295 3.268-7.124 3.268c-5.828 0-7.124-3.268-7.124-3.268l-.013-.035c.613-.22 1.226-.479 1.74-.807l.739-.397a.433.433 0 0 0 .79-.242.433.433 0 0 0-.432-.432l.199-.863v-1.244c1.364 1.3 2.893 2.107 4.101 2.107 1.213 0 2.737-.803 4.102-2.107v1.244l.147.872c-.2.039.397.457.397.665l.751.397c.514.328 1.127.587 1.74.807"
                    mask="url(#b)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="d" fill="#fff">
                    <use xlinkHref="#c" />
                  </mask>
                  <path
                    fill="#000"
                    d="M12.77 24.77v.431c1.364 1.3 2.893 2.107 4.101 2.107 1.213 0 2.737-.803 4.102-2.107v-.432c-1.365 1.304-2.889 2.107-4.102 2.107-1.208 0-2.737-.807-4.101-2.107"
                    mask="url(#d)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="f" fill="#fff">
                    <use xlinkHref="#e" />
                  </mask>
                  <path
                    fill="#FFF"
                    d="M12.77 25.201v.812l-.199.863c.237 0-.281.786-.358.674l-.739.397c-.514.328-1.127.587-1.74.807-.794.285-1.584.505-2.145.713-1.727.647-2.59 1.295-2.59 3.022v1.295h.863v-.432c0-1.727.863-2.374 2.59-3.022.561-.207 1.351-.427 2.146-.712.613-.22 1.226-.48 1.74-.807 0 0 1.295-.977 1.295-1.935v-.941a10.668 10.668 0 0 1-.863-.734"
                    mask="url(#f)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="h" fill="#fff">
                    <use xlinkHref="#g" />
                  </mask>
                  <path
                    fill="#94C1FF"
                    d="M26.14 29.467c-.56-.208-1.35-.428-2.145-.713-.613-.22-1.226-.479-1.74-.807l-.738-.397c-.078.112-.596-.674-.359-.674l-.198-.863v-.8a10.5 10.5 0 0 1-.864.734v.93c0 .957 1.295 1.934 1.295 1.934.514.328 1.128.586 1.74.807.795.285 1.585.505 2.146.712 1.727.648 2.59 1.295 2.59 3.022v.432h.864V32.49c0-1.727-.863-2.375-2.59-3.022"
                    mask="url(#h)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="j" fill="#fff">
                    <use xlinkHref="#i" />
                  </mask>
                  <path
                    fill="#965353"
                    d="M16.871 6.584c-1.787 0-3.238.864-3.238 1.926v1.299h6.476v-1.3c0-1.061-1.446-1.925-3.238-1.925"
                    mask="url(#j)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="l" fill="#fff">
                    <use xlinkHref="#k" />
                  </mask>
                  <path
                    fill="#5C9EFF"
                    d="M16.871 6.584c-1.787 0-3.238.864-3.238 1.926v1.299h6.476v-1.3c0-1.061-1.446-1.925-3.238-1.925"
                    mask="url(#l)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="n" fill="#fff">
                    <use xlinkHref="#m" />
                  </mask>
                  <path
                    fill="#2287FF"
                    d="M16.871 7.88c-.522 0-1.027.042-1.51.125a7.825 7.825 0 0 0-1.728.503V9.81h6.476v-1.3-.008a7.855 7.855 0 0 0-1.727-.496 9.005 9.005 0 0 0-1.51-.126"
                    mask="url(#n)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="p" fill="#fff">
                    <use xlinkHref="#o" />
                  </mask>
                  <path
                    fill="#94C1FF"
                    d="M24.643 16.298v.648c-3.718-1.537-5.829-3.605-5.829-3.605l-.095-.142c2.232-1.49 3.549-2.768 3.549-2.768l.052-.052c1.472 1.425 2.323 3.493 2.323 5.92"
                    mask="url(#p)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="r" fill="#fff">
                    <use xlinkHref="#q" />
                  </mask>
                  <path
                    fill="#D7E9FF"
                    d="M24.414 16.85v.96c-.147 2.706-1.654 5.258-3.441 6.96-1.365 1.303-2.889 2.106-4.102 2.106-1.209 0-2.737-.807-4.101-2.107-1.693-1.61-3.135-3.985-3.407-6.528v-.92c3.89-.817 7.025-2.564 9.356-4.122l.095.142s1.882 1.972 5.6 3.509"
                    mask="url(#r)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="t" fill="#fff">
                    <use xlinkHref="#s" />
                  </mask>
                  <path
                    fill="#94C1FF"
                    d="M23.55 16.452v1.357c-.147 2.707-1.654 5.259-3.44 6.96-1.207 1.153-2.538 1.912-3.669 2.073.147.02.291.034.43.034 1.213 0 2.737-.803 4.102-2.107 1.787-1.701 3.294-4.253 3.44-6.96v-.96l-.863-.397z"
                    mask="url(#t)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="v" fill="#fff">
                    <use xlinkHref="#u" />
                  </mask>
                  <path
                    fill="#FFF"
                    d="M13.633 24.77c-1.692-1.611-3.134-3.986-3.406-6.529V17.13l-.864.191v.921c.272 2.543 1.714 4.918 3.407 6.528 1.364 1.3 2.892 2.107 4.101 2.107.14 0 .286-.013.434-.034-1.13-.16-2.464-.923-3.672-2.073"
                    mask="url(#v)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="x" fill="#fff">
                    <use xlinkHref="#w" />
                  </mask>
                  <path
                    fill="#94C1FF"
                    d="M18.382 8.436c1.567.264 2.906.946 3.938 1.943l-.052.052s-1.317 1.278-3.549 2.768c-2.332 1.558-5.664 3.35-9.554 4.166l-.065.013v-1.08c0-4.123 2.457-7.218 6.26-7.862a9.004 9.004 0 0 1 1.511-.125c.523 0 1.028.043 1.511.125"
                    mask="url(#x)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="z" fill="#fff">
                    <use xlinkHref="#y" />
                  </mask>
                  <path
                    fill="#5C9EFF"
                    d="M22.32 10.38c-1.032-.998-2.37-1.68-3.938-1.944a9.002 9.002 0 0 0-1.51-.125c-.147 0-.289.011-.433.018.37.017.731.048 1.08.107 1.567.264 2.906.946 3.937 1.943 1.473 1.425 2.323 3.493 2.323 5.92v.265c.279.13.564.258.864.382v-.648c0-2.426-.85-4.494-2.323-5.919"
                    mask="url(#z)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="B" fill="#fff">
                    <use xlinkHref="#A" />
                  </mask>
                  <path
                    fill="#D7E9FF"
                    d="M9.963 16.298c0-4.123 2.457-7.218 6.26-7.862.349-.059.71-.09 1.08-.107-.144-.007-.286-.018-.432-.018a8.98 8.98 0 0 0-1.51.125c-3.804.644-6.261 3.74-6.261 7.862v1.08l.065-.013c.27-.057.533-.13.798-.195v-.872z"
                    mask="url(#B)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="D" fill="#fff">
                    <use xlinkHref="#C" />
                  </mask>
                  <path
                    fill="#FFF"
                    d="M21.206 26.876c.237 0 .432.195.432.432a.433.433 0 0 1-.432.432.433.433 0 0 1-.087-.855.57.57 0 0 1 .087-.009"
                    mask="url(#D)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="F" fill="#fff">
                    <use xlinkHref="#E" />
                  </mask>
                  <path
                    fill="#FFF"
                    d="M19.91 27.74c.238 0 .432.194.432.432a.433.433 0 0 1-.431.431.433.433 0 0 1-.432-.431c0-.238.194-.432.432-.432"
                    mask="url(#F)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="H" fill="#fff">
                    <use xlinkHref="#G" />
                  </mask>
                  <path
                    fill="#FFF"
                    d="M18.615 28.603c.238 0 .432.195.432.432a.433.433 0 0 1-.432.432.433.433 0 0 1-.431-.432c0-.237.194-.432.431-.432"
                    mask="url(#H)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="J" fill="#fff">
                    <use xlinkHref="#I" />
                  </mask>
                  <path
                    fill="#FFF"
                    d="M16.888 29.035c.238 0 .432.194.432.432a.433.433 0 0 1-.432.431.433.433 0 0 1-.431-.431c0-.238.194-.432.431-.432"
                    mask="url(#J)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="L" fill="#fff">
                    <use xlinkHref="#K" />
                  </mask>
                  <path
                    fill="#FFF"
                    d="M15.162 28.603c.237 0 .431.195.431.432a.433.433 0 0 1-.431.432.433.433 0 0 1-.432-.432c0-.237.194-.432.432-.432"
                    mask="url(#L)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="N" fill="#fff">
                    <use xlinkHref="#M" />
                  </mask>
                  <path
                    fill="#FFF"
                    d="M13.866 27.74c.238 0 .432.194.432.432a.433.433 0 0 1-.432.431.433.433 0 0 1-.432-.431c0-.238.195-.432.432-.432"
                    mask="url(#N)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="P" fill="#fff">
                    <use xlinkHref="#O" />
                  </mask>
                  <path
                    fill="#FFF"
                    d="M12.571 26.876c.237 0 .432.195.432.432a.433.433 0 0 1-.79.242.433.433 0 0 1 .359-.674"
                    mask="url(#P)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="R" fill="#fff">
                    <use xlinkHref="#Q" />
                  </mask>
                  <path
                    fill="#94C1FF"
                    d="M28.744 32.489v1.295H4.998V32.49c0-1.727.864-2.375 2.59-3.022.562-.208 1.352-.428 2.146-.713l.013.035s1.296 3.268 7.124 3.268c5.829 0 7.124-3.268 7.124-3.268l.013-.035c.794.285 1.585.505 2.146.713 1.727.647 2.59 1.295 2.59 3.022"
                    mask="url(#R)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="T" fill="#fff">
                    <use xlinkHref="#S" />
                  </mask>
                  <path
                    fill="#D7E9FF"
                    d="M8.452 30.33c.503-.186 1.193-.385 1.903-.63-.45-.515-.608-.911-.608-.911l-.013-.035c-.794.285-1.584.505-2.145.713-1.727.647-2.59 1.295-2.59 3.022v1.295h.863v-.432c0-1.727.863-2.374 2.59-3.022"
                    mask="url(#T)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="V" fill="#fff">
                    <use xlinkHref="#U" />
                  </mask>
                  <path
                    fill="#5C9EFF"
                    d="M25.277 30.33c-.503-.186-1.193-.385-1.903-.63.45-.515.608-.911.608-.911l.013-.035c.794.285 1.585.505 2.146.713 1.727.647 2.59 1.295 2.59 3.022v1.295h-.863v-.432c0-1.727-.864-2.374-2.59-3.022"
                    mask="url(#V)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="X" fill="#fff">
                    <use xlinkHref="#W" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M16.871 27.092c-1.237 0-2.826-.81-4.25-2.166-1.924-1.832-3.222-4.322-3.472-6.662a.215.215 0 0 1 .192-.237c.11-.01.224.073.237.191.24 2.242 1.489 4.632 3.34 6.395 1.347 1.282 2.824 2.047 3.953 2.047 1.133 0 2.611-.765 3.953-2.047 1.984-1.888 3.245-4.436 3.374-6.815a.208.208 0 0 1 .227-.204c.12.006.21.108.204.227-.134 2.486-1.446 5.142-3.507 7.105-1.441 1.376-2.99 2.166-4.25 2.166"
                    mask="url(#X)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="Z" fill="#fff">
                    <use xlinkHref="#Y" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M28.744 34H4.998a.216.216 0 0 1-.216-.216V32.49c0-1.85.96-2.56 2.73-3.224.277-.103.607-.207.966-.321.372-.119.777-.248 1.183-.393.727-.26 1.266-.51 1.697-.786a.215.215 0 1 1 .232.364c-.459.293-1.025.556-1.783.828-.41.148-.82.278-1.199.398-.351.112-.674.214-.944.314-1.66.622-2.45 1.203-2.45 2.82v1.08h23.314v-1.08c0-1.617-.79-2.198-2.45-2.82-.27-.1-.593-.202-.944-.314-.378-.12-.788-.25-1.199-.398-.757-.272-1.324-.535-1.783-.828a.216.216 0 1 1 .232-.364c.432.276.97.525 1.697.786.406.145.81.274 1.184.393.358.114.688.218.964.32C28 29.93 28.96 30.64 28.96 32.49v1.295c0 .12-.097.216-.216.216"
                    mask="url(#Z)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="ab" fill="#fff">
                    <use xlinkHref="#aa" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M12.77 26.229a.216.216 0 0 1-.216-.216v-1.244a.216.216 0 1 1 .431 0v1.244c0 .119-.096.216-.215.216"
                    mask="url(#ab)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="ad" fill="#fff">
                    <use xlinkHref="#ac" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M20.973 26.229a.216.216 0 0 1-.216-.216v-1.244a.216.216 0 1 1 .432 0v1.244c0 .119-.097.216-.216.216"
                    mask="url(#ad)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="af" fill="#fff">
                    <use xlinkHref="#ae" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M24.643 16.514a.216.216 0 0 1-.216-.216c0-2.308-.802-4.355-2.257-5.764-1.018-.983-2.34-1.636-3.823-1.885a8.957 8.957 0 0 0-2.95 0c-3.695.625-6.082 3.628-6.082 7.65a.216.216 0 1 1-.431 0c0-4.244 2.528-7.414 6.44-8.076 1.001-.17 2.093-.17 3.095 0 1.569.264 2.97.956 4.05 2.001 1.541 1.49 2.39 3.648 2.39 6.074 0 .12-.097.216-.216.216"
                    mask="url(#af)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="ah" fill="#fff">
                    <use xlinkHref="#ag" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M9.1 17.594a.215.215 0 0 1-.212-.174.215.215 0 0 1 .17-.254l.062-.013c3.967-.831 7.344-2.707 9.479-4.134 2.188-1.46 3.506-2.73 3.518-2.743a.215.215 0 1 1 .301.31c-.013.013-1.356 1.309-3.58 2.792-2.166 1.448-5.595 3.352-9.63 4.198l-.067.013a.191.191 0 0 1-.042.005"
                    mask="url(#ah)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="aj" fill="#fff">
                    <use xlinkHref="#ai" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M24.643 17.162a.211.211 0 0 1-.083-.017c-3.713-1.535-5.81-3.564-5.897-3.65a.216.216 0 1 1 .302-.308c.021.02 2.13 2.059 5.76 3.56a.216.216 0 0 1-.082.415"
                    mask="url(#aj)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="al" fill="#fff">
                    <use xlinkHref="#ak" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M16.871 32.273c-5.907 0-7.27-3.266-7.324-3.405a.216.216 0 0 1 .4-.16c.013.032 1.33 3.133 6.924 3.133 5.617 0 6.911-3.1 6.923-3.132a.216.216 0 1 1 .401.16c-.054.138-1.416 3.404-7.324 3.404"
                    mask="url(#al)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="an" fill="#fff">
                    <use xlinkHref="#am" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M24.643 17.162a.216.216 0 0 1-.216-.216v-.648a.216.216 0 1 1 .431 0v.648c0 .12-.096.216-.215.216"
                    mask="url(#an)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="ap" fill="#fff">
                    <use xlinkHref="#ao" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M9.1 17.594a.216.216 0 0 1-.216-.216v-1.08a.216.216 0 0 1 .432 0v1.08c0 .119-.097.216-.216.216"
                    mask="url(#ap)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="ar" fill="#fff">
                    <use xlinkHref="#aq" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M20.13 8.726a.216.216 0 0 1-.215-.216c0-.927-1.384-1.71-3.022-1.71s-3.023.783-3.023 1.71a.216.216 0 1 1-.431 0c0-1.201 1.516-2.142 3.454-2.142 1.937 0 3.454.94 3.454 2.142 0 .119-.097.216-.216.216"
                    mask="url(#ar)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="at" fill="#fff">
                    <use xlinkHref="#as" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M15.36 8.659a.21.21 0 0 1-.216-.21v-.57a.216.216 0 1 1 .432 0v.557c0 .12-.097.223-.216.223"
                    mask="url(#at)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="av" fill="#fff">
                    <use xlinkHref="#au" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M18.382 8.659a.21.21 0 0 1-.216-.21v-.57a.216.216 0 1 1 .432 0v.557c0 .12-.097.223-.216.223"
                    mask="url(#av)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="ax" fill="#fff">
                    <use xlinkHref="#aw" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M16.871 8.527a.216.216 0 0 1-.216-.216v-.432a.216.216 0 1 1 .432 0v.432c0 .12-.096.216-.216.216"
                    mask="url(#ax)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="az" fill="#fff">
                    <use xlinkHref="#ay" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M13.866 27.956a.216.216 0 0 0 0 .431.216.216 0 0 0 0-.432m0 .864a.648.648 0 1 1 .001-1.297.648.648 0 0 1 0 1.297"
                    mask="url(#az)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="aB" fill="#fff">
                    <use xlinkHref="#aA" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M12.571 27.092a.216.216 0 0 0-.181.334c.041.06.112.098.181.098a.216.216 0 0 0 .216-.216.216.216 0 0 0-.216-.216m0 .864a.662.662 0 0 1-.536-.284.648.648 0 1 1 .536.283"
                    mask="url(#aB)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="aD" fill="#fff">
                    <use xlinkHref="#aC" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M15.162 28.819a.216.216 0 1 0 .216.216.216.216 0 0 0-.216-.216m0 .863a.648.648 0 1 1 0-1.296.648.648 0 0 1 0 1.296"
                    mask="url(#aD)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="aF" fill="#fff">
                    <use xlinkHref="#aE" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M16.888 29.25a.216.216 0 0 0-.216.217.216.216 0 0 0 .432 0 .216.216 0 0 0-.216-.216m0 .863a.648.648 0 1 1 .002-1.296.648.648 0 0 1-.002 1.296"
                    mask="url(#aF)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="aH" fill="#fff">
                    <use xlinkHref="#aG" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M18.615 28.819a.216.216 0 0 0 0 .432.216.216 0 0 0 0-.432m0 .863a.648.648 0 1 1 .001-1.296.648.648 0 0 1 0 1.296"
                    mask="url(#aH)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="aJ" fill="#fff">
                    <use xlinkHref="#aI" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M19.91 27.956a.216.216 0 0 0 0 .431.216.216 0 0 0 0-.432m0 .864a.648.648 0 1 1 .002-1.297.648.648 0 0 1-.001 1.297"
                    mask="url(#aJ)"
                  />
                </g>
                <g transform="translate(1 1.041)">
                  <mask id="aL" fill="#fff">
                    <use xlinkHref="#aK" />
                  </mask>
                  <path
                    fill="#116FFF"
                    d="M21.206 27.092a.214.214 0 0 0-.216.216.216.216 0 1 0 .216-.216m0 .864a.648.648 0 0 1-.128-1.283.655.655 0 0 1 .776.635c0 .357-.291.648-.648.648"
                    mask="url(#aL)"
                  />
                </g>
              </g>
            </g>
          </svg>
        )
      },
      RoundCheck: () => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path fill="none" d="M0 0h24v24H0V0z" />
            <path d="M9 16.17L5.53 12.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l4.18 4.18c.39.39 1.02.39 1.41 0L20.29 7.71c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L9 16.17z" />
          </svg>
        )
      },
      searchLens: () => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="24"
            height="24"
            viewBox="0 0 24 24">
            <defs>
              <path
                id="a"
                d="M15.977 14.472h-.79l-.28-.27a6.5 6.5 0 0 0 1.48-5.34c-.47-2.78-2.79-5-5.59-5.34a6.505 6.505 0 0 0-7.27 7.27c.34 2.8 2.56 5.12 5.34 5.59a6.5 6.5 0 0 0 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49l-4.24-4.26zm-6 0c-2.49 0-4.5-2.01-4.5-4.5s2.01-4.5 4.5-4.5 4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5z"
              />
            </defs>
            <g fill="none" fillRule="evenodd">
              <mask id="b" fill="#fff">
                <use xlinkHref="#a" />
              </mask>
              <g fill="#000" fillOpacity=".54" mask="url(#b)">
                <path d="M0 0h24v24H0z" />
              </g>
            </g>
          </svg>
        )
      }
    }

    return svg[icon] ? svg[icon]() : <div />
  }
}
